const uk = {
  _name: 'Українська',
  _flag: '🇺🇦',

  // ── Navigation sections ──
  'nav.businessMonitor': 'Монітор бізнесу',
  'nav.dashboard': 'Дешборд',
  'nav.clients': 'Клієнти',
  'nav.communication': 'Комунікація',
  'nav.staff': 'Персонал',
  'nav.inventory': 'Склад',
  'nav.salary': 'Зарплати',
  'nav.finances': 'Фінанси',
  'nav.system': 'Система',
  'nav.integrations': 'Інтеграції',
  'nav.sales': 'Продажі',

  // ── Navigation items ──
  'nav.pos': 'Магазин',
  'nav.salesProducts': 'Відвантаження зі складу',
  'nav.salesServices': 'Запис на послуги',
  'nav.clientsBase': 'Клієнтська база',
  'nav.categories': 'Категорії клієнтів',
  'nav.messages': 'Повідомлення',
  'nav.employees': 'Співробітники',
  'nav.schedule': 'Розклад роботи',
  'nav.scheduleTemplates': 'Шаблони розкладів',
  'nav.services': 'Послуги',
  'nav.tariffPlans': 'Тарифні плани',
  'nav.products': 'Номенклатура',
  'nav.stock': 'Залишки',
  'nav.purchases': 'Закупівлі',
  'nav.movements': 'Рух товарів',
  'nav.orders': 'Замовлення',
  'nav.salaryCalc': 'Розрахунок',
  'nav.salarySchemes': 'Схеми мотивації',
  'nav.financialOps': 'Фінансові операції',
  'nav.cashRegister': 'Каса',
  'nav.reports': 'Звіти',
  'nav.financialResult': 'Фін. результат',
  'nav.users': 'Користувачі',
  'nav.roles': 'Ролі',
  'nav.checkbox': 'Checkbox ПРРО',
  'nav.telegram': 'Telegram нагадування',
  'nav.sms': 'SMS-розсилка',
  'nav.email': 'Email-розсилка',
  'nav.novaPoshta': 'Нова Пошта',
  'nav.meestExpress': 'Meest Express',
  'nav.olx': 'OLX',
  'olx.tagline': 'Чати з оголошень + синхронізація каталогу',
  'olx.connected': 'Підключено',
  'olx.notConnected': 'Не підключено',
  'olx.connectIntro': 'Підключи OLX-акаунт через OAuth, щоб отримувати повідомлення з оголошень у CRM та публікувати товари як оголошення.',
  'olx.connectBtn': 'Підключити OLX',
  'olx.tabOpened': 'OLX відкрито в новій вкладці. Авторизуйся і повернись сюди.',
  'olx.connectFailed': 'Помилка підключення:',
  'olx.connectedToast': 'OLX підключено',
  'olx.confirmDisconnect': 'Відключити OLX-інтеграцію?',
  'olx.disconnected': 'OLX відключено',
  'olx.disconnectBtn': 'Відключити',
  'olx.testBtn': 'Перевірити з\'єднання',
  'olx.testOk': 'Підключено як: {name} (ID {id})',
  'olx.testFailed': 'Помилка тесту',
  'olx.accountId': 'OLX ID',
  'olx.scope': 'Дозволи',
  'olx.connectedAt': 'Підключено',
  'olx.reconnectRequired': 'Потрібна повторна авторизація',
  'olx.reconnectExplain': 'OLX анулював наші токени (зазвичай через 30 днів неактивності або при зміні пароля). Натисни «Підключити OLX» щоб продовжити отримувати повідомлення.',
  'olx.refreshBtn': 'Перевірити нові повідомлення',
  'olx.refreshFound': 'Отримано {n} нових повідомлень — дивись у Комунікаціях',
  'olx.refreshNoNew': 'Нових повідомлень немає',
  'olx.refreshFailed': 'Не вдалось перевірити',
  'comm.olxThreadMissing': 'Не вдалось визначити OLX-тред',
  'olx.howItWorks': 'Як це працює',
  'olx.step1': 'Натисни «Підключити OLX» — у новій вкладці відкриється OLX-авторизація.',
  'olx.step2': 'Увійди у свій OLX-акаунт і дозволь додатку доступ.',
  'olx.step3': 'Повернись на цю вкладку — статус оновиться автоматично; перевір кнопкою «Перевірити з\'єднання».',
  'olx.capabilities': 'Що дає підключення',
  'olx.capInboxTitle': 'Чати з оголошень — у CRM',
  'olx.capInboxText': 'Усі повідомлення від покупців з твоїх OLX-оголошень потрапляють у Sidebar → Комунікація. Перевірка раз на 10 хв; кнопка «Перевірити нові повідомлення» вище для миттєвого фетчу.',
  'olx.capOutboundTitle': 'Відповідь з CRM напряму в OLX-чат',
  'olx.capOutboundText': 'Відкрий тред у Комунікації, обери канал «OLX» — текст піде в OLX-чат покупця, як ніби ти писав з самого OLX.',
  'olx.capPublishTitle': 'Публікація товарів як OLX-оголошень',
  'olx.capPublishText': 'Sidebar → Номенклатура → відкрий товар → кнопка «Опублікувати на OLX». Назва, опис, ціна, фото підтягнуться з картки товару — заповниш категорію + місто + контакти, і оголошення піде на модерацію OLX.',
  'olx.limitations': 'Обмеження',
  'olx.limitationsText': 'OLX-замовлення (OLX Доставка) поки недоступні через партнерський API. Робота з ним — досі через інтерфейс olx.ua.',

  // ─── Instagram (OAuth + вхідні через webhook + вихідні — усе в проді)
  'nav.instagram': 'Instagram',
  'instagram.tagline': 'Direct-повідомлення з твого Instagram Business акаунту — у CRM',
  'instagram.connected': 'Підключено',
  'instagram.notConnected': 'Не підключено',
  'instagram.connectIntro': 'Підключи Instagram Business акаунт через OAuth, щоб отримувати Direct-повідомлення від клієнтів прямо у CRM.',
  'instagram.connectBtn': 'Підключити Instagram',
  'instagram.tabOpened': 'Instagram відкрито в новій вкладці. Авторизуйся і повернись сюди.',
  'instagram.connectFailed': 'Помилка підключення:',
  'instagram.confirmDisconnect': 'Відключити Instagram-інтеграцію?',
  'instagram.disconnected': 'Instagram відключено',
  'instagram.disconnectBtn': 'Відключити',
  'instagram.testBtn': 'Перевірити з\'єднання',
  'instagram.testOk': 'З\'єднання працює:',
  'instagram.testFailed': 'Помилка тесту',
  'instagram.account': 'Акаунт',
  'instagram.userId': 'IG User ID',
  'instagram.scope': 'Дозволи',
  'instagram.connectedAt': 'Підключено',
  'instagram.expiresAt': 'Дійсний до',
  'instagram.reconnectRequired': 'Потрібна повторна авторизація',
  'instagram.reconnectExplain': 'Long-lived токен не вдалось оновити (зазвичай через >60 днів неактивності або зміну пароля Instagram). Натисни «Підключити Instagram» щоб продовжити отримувати повідомлення.',
  'instagram.howItWorks': 'Як це працює',
  'instagram.step1': 'Натисни «Підключити Instagram» — у новій вкладці відкриється авторизація Instagram.',
  'instagram.step2': 'Увійди у свій Instagram Business акаунт (Professional Account, прив\'язаний до Facebook Page) і дозволь додатку доступ до Direct.',
  'instagram.step3': 'Повернись на цю вкладку — статус оновиться автоматично; перевір кнопкою «Перевірити з\'єднання».',
  'instagram.capabilities': 'Що дає підключення',
  'instagram.capInboxTitle': 'Direct-повідомлення — у CRM',
  'instagram.capInboxText': 'Усі повідомлення з Instagram Direct падають у Sidebar → Комунікація, у реальному часі через Meta webhooks — поруч із Telegram, SMS та email.',
  'instagram.capOutboundTitle': 'Відповідь з CRM напряму в Instagram',
  'instagram.capOutboundText': 'Відкрий тред у Комунікації, обери канал «Instagram» — повідомлення піде в Direct клієнта.',
  'instagram.limitations': 'Обмеження',
  'instagram.limitationsText': 'Працює лише з Instagram Professional Account (Business або Creator), прив\'язаним до Facebook Page. Особисті IG-акаунти Meta не підтримує для Messaging API.',

  // ─── Messenger (Phase 2 — labels live mostly in component file)
  'nav.messenger': 'Messenger',
  'nav.locations': 'Локації',
  'nav.myPlan': 'Мій план',
  'nav.onlineBooking': 'Онлайн-запис',
  'nav.help': 'Довідка',
  'booking.title': 'Онлайн-запис',
  'booking.subtitle': 'Налаштування публічної сторінки запису для ваших клієнтів',
  'booking.enable': 'Увімкнути онлайн-запис',
  'booking.yourLink': 'Ваше посилання',
  'booking.copy': 'Копіювати',
  'booking.urlCopied': 'Посилання скопійовано',
  'booking.linkHint': 'Поділіться цим посиланням з клієнтами — в Instagram, Telegram, на сайті',
  'booking.businessInfo': 'Інформація про бізнес',
  'booking.businessName': 'Назва бізнесу',
  'booking.businessNameHint': 'Як бачитимуть клієнти',
  'booking.slug': 'URL-ідентифікатор',
  'booking.slugHint': 'Латиниця, цифри, дефіс. Наприклад: my-salon',
  'booking.description': 'Опис',
  'booking.descriptionHint': 'Коротко про ваш бізнес',
  'booking.themeColor': 'Колір теми',
  'booking.locale': 'Мова сторінки',
  'booking.rules': 'Правила запису',
  'booking.minHours': 'Мінімум до запису',
  'booking.hours': 'год',
  'booking.minHoursHint': 'За скільки годин можна записатись',
  'booking.maxDays': 'Макс. глибина',
  'booking.days': 'днів',
  'booking.maxDaysHint': 'На скільки днів вперед доступний запис',
  'booking.allowedServices': 'Послуги для онлайн-запису',
  'booking.allowedServicesHint': 'Оберіть послуги, доступні для онлайн-запису. Якщо нічого не обрано — доступні всі.',
  'booking.allowedStaff': 'Спеціалісти для онлайн-запису',
  'booking.allowedStaffHint': 'Оберіть спеціалістів, до яких можна записатись онлайн. Якщо нічого не обрано — доступні всі.',
  'booking.selectAll': 'Обрати всі',
  'booking.deselectAll': 'Зняти всі',
  'booking.tabGeneral': 'Загальне',
  'booking.tabServices': 'Послуги',
  'booking.tabProducts': 'Товари',
  'booking.tabAfter': 'Після запису',
  'booking.serviceCategories': 'Категорії послуг',
  'booking.serviceCategoriesHint': 'Оберіть категорії для онлайн-запису. Якщо нічого не обрано — доступні всі.',
  'booking.productCategories': 'Категорії товарів',
  'booking.productCategoriesHint': 'Оберіть категорії для онлайн-продажу. Якщо нічого не обрано — доступні всі.',
  'booking.noCategoriesYet': 'Категорій поки немає. Створіть їх у відповідному розділі.',
  'booking.mode': 'Режим роботи',
  'booking.modeServices': 'Послуги',
  'booking.modeShop': 'Магазин',
  'booking.modeBoth': 'Обидва',
  'booking.modeHint': 'Послуги — запис до спеціалістів. Магазин — онлайн-замовлення товарів. Обидва — і те, і те.',
  'booking.shopSettings': 'Налаштування магазину',
  'booking.shopMinOrder': 'Мін. сума замовлення',
  'booking.shopShowOutOfStock': 'Товари без залишків',
  'booking.shopShowOutOfStockLabel': 'Показувати товари з нульовим залишком',
  'booking.shopDelivery': 'Способи доставки',
  'booking.deliveryPickup': 'Самовивіз',
  'booking.deliveryNP': 'Нова Пошта',
  'booking.deliveryMeest': 'Meest Express',
  'booking.deliveryCourier': 'Кур\'єр',
  'booking.gallery': 'Галерея',
  'booking.galleryHint': 'Фото робіт, інтер\'єру, товарів — до 10 зображень',
  'booking.galleryCount': 'фото',
  'booking.promo': 'Промо-банер',
  'booking.promoEnable': 'Показувати промо-банер',
  'booking.promoText': 'Текст акції',
  'booking.promoPlaceholder': 'Наприклад: Знижка 20% на перший візит',
  'booking.chat': 'Чат на сайті',
  'booking.tariffServices': 'Тарифний план',
  'booking.tariffProducts': 'Тарифний план',
  'booking.tariffHint': 'Тариф застосовується до цін на shop-сайті. Клієнти бачать знижені ціни, а у CRM замовлення/записи тегуються обраним тарифом.',
  'booking.tariffNone': '— без знижки —',
  'booking.chatEnable': 'Показувати чат на shop-сайті',
  'booking.chatHint': 'Плаваюча кнопка у куті shop-сайту через яку клієнт може написати вам. Повідомлення приходять у модуль «Комунікації».',
  'booking.promoColor': 'Колір',
  'booking.colorScheme': 'Кольорова схема',
  'booking.bgColor': 'Колір фону',
  'booking.presetLight': 'Світла',
  'booking.presetDark': 'Темна',
  'booking.presetWarm': 'Тепла',
  'booking.presetFresh': 'Свіжа',
  'booking.presetRose': 'Рожева',
  'booking.presetPurple': 'Фіолетова',
  'booking.cardColor': 'Колір блоків',
  'booking.fontPreset': 'Шрифт',
  'booking.cardStyle': 'Стиль карток',
  'booking.cardStyleDefault': 'Стандартний',
  'booking.cardStyleFlat': 'Плоский',
  'booking.cardStyleShadow': 'З тінню',
  'booking.cardStyleMinimal': 'Мінімалістичний',
  'booking.cardStyleBorderless': 'Без рамки',
  'booking.footerText': 'Текст футера',
  'booking.footerTextHint': 'Наприклад: © 2026 Назва вашого бізнесу',
  'booking.branding': 'Брендинг',
  'booking.logo': 'Логотип',
  'booking.uploadLogo': 'Завантажити лого',
  'booking.changeLogo': 'Змінити лого',
  'booking.headerImage': 'Фон хедера',
  'booking.uploadImage': 'Завантажити фото',
  'booking.changeImage': 'Змінити фото',
  'booking.logoTooLarge': 'Лого занадто велике. Максимум 1 МБ.',
  'booking.imageTooLarge': 'Зображення занадто велике. Максимум 5 МБ.',
  'booking.headerImageHint': 'Фото вашого бізнесу — салону, студії, магазину',
  'booking.servicesBannerImage': 'Банер розділу "Послуги"',
  'booking.shopBannerImage': 'Банер розділу "Товари"',
  'booking.shopBannerHint': 'Зображення для верхньої частини магазину товарів',
  'booking.contacts': 'Контакти',
  'booking.contactsHint': 'Адреса та графік роботи беруться з налаштувань локацій',
  'booking.address': 'Адреса',
  'booking.addressHint': 'Вулиця, будинок, місто',
  'booking.businessPhone': 'Телефон',
  'booking.website': 'Веб-сайт',
  'booking.workingHours': 'Графік роботи',
  'booking.workingHoursHint': 'Пн-Пт 9:00-18:00',
  'booking.afterBooking': 'Після запису',
  'booking.successMsg': 'Повідомлення після запису',
  'booking.successMsgHint': 'Наприклад: Чекаємо на вас! Не забудьте паспорт.',
  'booking.cancelPolicy': 'Політика скасування',
  'booking.cancelPolicyHint': 'Наприклад: Скасувати можна за 24 години до візиту',
  'booking.disableTitle': 'Вимкнути онлайн-запис?',
  'booking.disableText': 'Клієнти більше не зможуть записатись онлайн. Ви зможете увімкнути запис знову в будь-який момент.',
  'booking.disableConfirm': 'Вимкнути',

  // ── Calendar months & days ──
  'months.0': 'Січень', 'months.1': 'Лютий', 'months.2': 'Березень',
  'months.3': 'Квітень', 'months.4': 'Травень', 'months.5': 'Червень',
  'months.6': 'Липень', 'months.7': 'Серпень', 'months.8': 'Вересень',
  'months.9': 'Жовтень', 'months.10': 'Листопад', 'months.11': 'Грудень',
  'dow.0': 'Пн', 'dow.1': 'Вт', 'dow.2': 'Ср',
  'dow.3': 'Чт', 'dow.4': 'Пт', 'dow.5': 'Сб', 'dow.6': 'Нд',

  // ── Common UI ──
  'common.save': 'Зберегти',
  'common.saving': 'Збереження...',
  'common.saved': 'Збережено',
  'common.cancel': 'Скасувати',
  'common.delete': 'Видалити',
  'common.edit': 'Редагувати',
  'common.add': 'Додати',
  'common.search': 'Пошук',
  'onboarding.title': 'Налаштуйте ваш бізнес',
  'onboarding.subtitle': 'Виконано {done} з {total} кроків',
  'onboarding.allDone': 'Все налаштовано!',
  'onboarding.allDoneHint': 'Ви готові до роботи 💪',
  'onboarding.stepBusiness': 'Тип бізнесу обрано',
  'onboarding.stepStaff': 'Додайте першого майстра',
  'onboarding.stepService': 'Додайте першу послугу',
  'onboarding.stepAppointment': 'Створіть перший запис',
  'onboarding.stepClient': 'Додайте першого клієнта',
  'onboarding.noStaffYet': 'Немає майстрів',
  'onboarding.noStaffHint': 'Додайте першого майстра, щоб почати приймати записи',
  'onboarding.goAddStaff': '+ Додати майстра',
  'gsearch.placeholder': 'Пошук клієнтів, записів, співробітників...',
  'gsearch.quickActions': 'Швидкі дії',
  'gsearch.customers': 'Клієнти',
  'gsearch.staff': 'Співробітники',
  'gsearch.appointments': 'Записи',
  'gsearch.noResults': 'Нічого не знайдено',
  'gsearch.goCalendar': 'Розклад — сьогодні',
  'gsearch.goClients': 'Клієнтська база',
  'gsearch.goFinances': 'Фінанси',
  'gsearch.goDashboard': 'Дешборд',
  'gsearch.newClient': 'Новий клієнт',
  'common.close': 'Закрити',
  'common.loading': 'Завантаження...',
  'common.yes': 'Так',
  'common.no': 'Ні',
  'common.and': 'та',
  'common.confirm': 'Підтвердити',
  'common.back': 'Назад',
  'common.next': 'Далі',
  'common.create': 'Створити',
  'common.actions': 'Дії',
  'common.name': "Ім'я",
  'common.phone': 'Телефон',
  'common.email': 'Email',
  'common.date': 'Дата',
  'common.time': 'Час',
  'common.status': 'Статус',
  'common.total': 'Разом',
  'common.price': 'Ціна',
  'common.quantity': 'Кількість',
  'common.note': 'Примітка',
  'common.all': 'Всі',
  'common.filter': 'Фільтр',
  'common.export': 'Експорт',
  'common.shown': 'Показано',
  'common.of': 'із',
  'common.logout': 'Вийти',
  'common.profile': 'Профіль',
  'common.settings': 'Налаштування',
  'common.language': 'Мова',

  // ── Clients page ──
  'clients.title': 'Клієнтська база',
  'clients.subtitle': 'Управління картками клієнтів',
  'clients.addClient': 'Додати клієнта',
  'clients.import': 'Імпорт',

  // ── Import customers ──
  'import.title': 'Імпорт клієнтів',
  'import.uploadHint': 'Завантажте файл з базою клієнтів. Підтримуються Excel та CSV.',
  'import.maxRows': 'максимум {max} рядків',
  'import.tooManyRowsTitle': 'Файл занадто великий',
  'import.tooManyRowsBody': 'У файлі {count} рядків — максимум за один імпорт {max}. Розбийте файл на менші частини або зверніться до підтримки.',
  'import.selectFile': 'Обрати файл',
  'import.downloadTemplate': 'Завантажити шаблон',
  'import.or': 'або',
  'import.rows': 'рядків',
  'import.fieldName': "Ім'я / ПІБ",
  'import.fieldLastName': 'Прізвище',
  'import.fieldFirstName': "Ім'я",
  'import.fieldPhone': 'Телефон',
  'import.fieldAdditionalPhone': 'Дод. телефон',
  'import.fieldEmail': 'Email',
  'import.fieldGender': 'Стать',
  'import.fieldBirthday': 'День народження',
  'import.fieldCategory': 'Категорія',
  'import.fieldCardNumber': '№ картки',
  'import.fieldNote': 'Примітка',

  // Bulk product import (Номенклатура → "Імпорт")
  'importProducts.btn': 'Імпорт',
  'importProducts.btnTitle': 'Завантажити список товарів з Excel/CSV',
  'importProducts.title': 'Імпорт товарів',
  'importProducts.uploadHint': 'Завантажте Excel або CSV з переліком товарів. Обов\'язкові поля: назва і ціна продажу.',
  'importProducts.maxRows': 'максимум {max} рядків',
  'importProducts.tooManyRowsTitle': 'Файл занадто великий',
  'importProducts.tooManyRowsBody': 'У файлі {count} рядків — максимум за один імпорт {max}. Розбийте файл на менші частини.',
  'importProducts.selectFile': 'Обрати файл',
  'importProducts.downloadTemplate': 'Завантажити шаблон',
  'importProducts.or': 'або',
  'importProducts.rows': 'рядків',
  'importProducts.fieldName': 'Назва',
  'importProducts.fieldSku': 'Артикул',
  'importProducts.fieldCategory': 'Категорія',
  'importProducts.fieldUnit': 'Одиниця',
  'importProducts.fieldMinStock': 'Мін. залишок',
  'importProducts.fieldSellPrice': 'Ціна продажу',
  'importProducts.statusCol': 'Статус',
  'importProducts.mapHint': 'Зіставте колонки файлу з полями товару. Зірочкою позначені обов\'язкові.',
  'importProducts.notMapped': 'не вибрано',
  'importProducts.back': 'Назад',
  'importProducts.next': 'Далі',
  'importProducts.startOver': 'Інший файл',
  'importProducts.willImport': 'буде імпортовано',
  'importProducts.willSkip': 'буде пропущено',
  'importProducts.newCategories': 'нових категорій',
  'importProducts.newCategoriesWarning': 'У файлі є категорії яких ще немає в системі — їх буде створено автоматично під час імпорту.',
  'importProducts.errMissingName': 'Порожня назва',
  'importProducts.errInvalidPrice': 'Некоректна ціна',
  'importProducts.errInvalidMinStock': 'Некоректний мін. залишок',
  'importProducts.errSkuExisting': 'Артикул вже існує',
  'importProducts.previewTruncated': 'Показано перших 100 з {count}',
  'importProducts.importing': 'Імпорт...',
  'importProducts.importBtn': 'Імпортувати {count}',
  'importProducts.doneTitle': 'Імпортовано {count} товарів',
  'importProducts.doneNewCategories': 'Створено {count} нових категорій',
  'importProducts.doneSkipped': 'Пропущено {count} рядків',
  'importProducts.close': 'Закрити',
  'importProducts.toastSuccess': 'Товари імпортовано',

  // Bulk service import
  'importServices.btn': 'Імпорт',
  'importServices.btnTitle': 'Завантажити список послуг з Excel/CSV',
  'importServices.title': 'Імпорт послуг',
  'importServices.uploadHint': 'Завантажте Excel або CSV з переліком послуг. Обов\'язкові поля: назва і ціна. Тривалість за замовчуванням — 30 хв.',
  'importServices.maxRows': 'максимум {max} рядків',
  'importServices.tooManyRowsTitle': 'Файл занадто великий',
  'importServices.tooManyRowsBody': 'У файлі {count} рядків — максимум за один імпорт {max}.',
  'importServices.selectFile': 'Обрати файл',
  'importServices.downloadTemplate': 'Завантажити шаблон',
  'importServices.or': 'або',
  'importServices.rows': 'рядків',
  'importServices.fieldName': 'Назва',
  'importServices.fieldGroup': 'Група',
  'importServices.fieldPrice': 'Ціна',
  'importServices.fieldDuration': 'Тривалість (хв)',
  'importServices.statusCol': 'Статус',
  'importServices.mapHint': 'Зіставте колонки файлу з полями послуги. Зірочкою позначені обов\'язкові.',
  'importServices.notMapped': 'не вибрано',
  'importServices.back': 'Назад',
  'importServices.next': 'Далі',
  'importServices.startOver': 'Інший файл',
  'importServices.willImport': 'буде імпортовано',
  'importServices.willSkip': 'буде пропущено',
  'importServices.newGroups': 'нових груп',
  'importServices.newGroupsWarning': 'У файлі є групи яких ще немає в системі — їх буде створено автоматично.',
  'importServices.errMissingName': 'Порожня назва',
  'importServices.errInvalidPrice': 'Некоректна ціна',
  'importServices.errInvalidDuration': 'Некоректна тривалість (1-1440 хв)',
  'importServices.errNameExisting': 'Послуга вже існує',
  'importServices.previewTruncated': 'Показано перших 100 з {count}',
  'importServices.importing': 'Імпорт...',
  'importServices.importBtn': 'Імпортувати {count}',
  'importServices.doneTitle': 'Імпортовано {count} послуг',
  'importServices.doneNewGroups': 'Створено {count} нових груп',
  'importServices.doneSkipped': 'Пропущено {count} рядків',
  'importServices.close': 'Закрити',
  'importServices.toastSuccess': 'Послуги імпортовано',

  'import.skip': 'пропустити',
  'import.phoneRequired': 'Поле "Телефон" обов\'язкове для маппінгу',
  'import.preview': 'Попередній перегляд',
  'import.back': 'Назад',
  'import.adjustColumns': 'Налаштувати колонки',
  'import.newClients': 'Нових клієнтів',
  'import.duplicates': 'Дублікатів (пропущено)',
  'import.duplicate': 'дублікат',
  'import.new': 'новий',
  'import.status': 'Статус',
  'import.andMore': '...та ще {count}',
  'import.importing': 'Імпортуємо...',
  'import.importBtn': 'Імпортувати ({count})',
  'import.success': 'Імпортовано {count} клієнтів!',
  'import.skippedDuplicates': '{count} дублікатів пропущено',
  'import.error': 'Помилка імпорту',
  'import.close': 'Закрити',

  // ── Help page ──
  'helpPage.title': 'Довідка',
  'helpPage.subtitle': 'Гіди та інструкції для роботи з Systemic CRM',
  'helpPage.locations.title': 'Локації в Systemic CRM',
  'helpPage.locations.content': '<h2>Що таке локація?</h2><p>Локація — це ваша фізична точка: салон краси, клініка, магазин, студія, офіс. Якщо у вас одна точка — система працює автоматично. Якщо точок декілька — додайте їх у <strong>Налаштування → Локації</strong> і перемикайтесь через бокове меню.</p>'
  + '<h2>Що окреме для кожної локації?</h2>'
  + '<ul>'
  + '<li><strong>Записи (Календар)</strong> — кожен запис належить локації, де створений</li>'
  + '<li><strong>Замовлення</strong> — прив\'язані до поточної локації</li>'
  + '<li><strong>Магазин (POS)</strong> — продажі фіксуються за локацією</li>'
  + '<li><strong>Фінанси</strong> — платежі відображаються по локації</li>'
  + '<li><strong>Каса (Checkbox)</strong> — окреме підключення для кожної точки</li>'
  + '<li><strong>Склади</strong> — кожен склад належить конкретній локації</li>'
  + '</ul>'
  + '<h2>Що спільне?</h2>'
  + '<ul>'
  + '<li><strong>Клієнти</strong> — єдина база для всіх точок</li>'
  + '<li><strong>Послуги та товари (номенклатура)</strong> — спільний каталог</li>'
  + '<li><strong>Категорії товарів та послуг</strong> — спільні</li>'
  + '<li><strong>Програми лояльності</strong> — діють у всіх локаціях</li>'
  + '<li><strong>Інтеграції</strong> — Нова Пошта, Telegram, SMS — одне підключення</li>'
  + '</ul>'
  + '<h2>Налаштування локації — 3 вкладки</h2>'
  + '<h3>Основне</h3>'
  + '<p>Назва, адреса, телефон, колір для візуального розрізнення в інтерфейсі.</p>'
  + '<h3>Онлайн-запис</h3>'
  + '<p>Налаштування для публічної сторінки <strong>shop.systemic-crm.com</strong>:</p>'
  + '<ul>'
  + '<li><strong>Фото локації</strong> — інтер\'єр або фасад, відображається на сторінці онлайн-запису</li>'
  + '<li><strong>Графік роботи</strong> — структурований по днях тижня з можливістю увімкнути/вимкнути кожен день і задати час роботи</li>'
  + '</ul>'
  + '<h3>Реквізити</h3>'
  + '<p>Юридичні дані для документів: офіційна назва, ЄДРПОУ/ІПН, банківський рахунок (IBAN), назва банку.</p>'
  + '<h2>Склади та локації</h2>'
  + '<ul>'
  + '<li>Кожен склад належить конкретній локації. При створенні складу він автоматично прив\'язується до поточної локації.</li>'
  + '<li>На сторінці &laquo;Залишки&raquo; відображаються тільки склади поточної локації.</li>'
  + '<li>Переміщення між складами працює і в межах однієї локації, і між різними локаціями — в модалці переміщення доступні всі склади всіх локацій.</li>'
  + '<li>Видалити склад неможливо якщо по ньому вже були рухи, є залишки або прив\'язані замовлення.</li>'
  + '</ul>'
  + '<h2>Видалення локації</h2>'
  + '<ul>'
  + '<li>Неможливо видалити останню локацію</li>'
  + '<li>Неможливо видалити локацію до якої прив\'язані співробітники або склади — спочатку перепризначте їх</li>'
  + '</ul>'
  + '<h2>Ліміти тарифного плану</h2>'
  + '<p>Кількість локацій обмежена тарифним планом: Start — 1, Business — 2, Pro — 7. При досягненні ліміту кнопка &laquo;Додати локацію&raquo; стає неактивною.</p>'
  + '<h2>Співробітники</h2>'
  + '<p>За замовчуванням відображаються у всіх локаціях. Можна обмежити через картку співробітника. Графік роботи — окремий для кожної точки.</p>'
  + '<h2>Звіти</h2>'
  + '<p>Фільтр по локаціях: дані по конкретній точці або зведені по всіх.</p>',
  'helpPage.staff-and-salaries.title': 'Співробітники, зарплати та доступ',
  'helpPage.staff-and-salaries.content': '<h2>1. Створіть співробітників</h2><p>Перейдіть у <strong>Персонал → Співробітники → Додати</strong>. Для кожного вкажіть ім\'я, посаду, контакти та <strong>статус</strong>:</p><ul><li><strong>Активний (показувати в календарі)</strong> — майстри, лікарі. Клієнти записуються до них.</li><li><strong>Активний (не показувати в календарі)</strong> — адміністратори, менеджери. Мають графік та зарплату, але не видимі в записі на послуги.</li><li><strong>Звільнений</strong> — не відображається ніде, історія зберігається.</li></ul><h2>2. Задайте графік роботи</h2><p>Перейдіть у <strong>Персонал → Розклад роботи</strong>. Для кожного співробітника задайте робочі дні, час початку/закінчення та перерви. Графік використовується для:</p><ul><li>Відображення доступного часу для запису клієнтів</li><li>Розрахунку зарплати (ставка за день/годину)</li><li>Контролю відпрацьованих годин у звітах</li></ul><p>При кількох локаціях — графік можна задати <strong>окремо для кожної точки</strong>.</p><h2>3. Створіть схему мотивації</h2><p>Перейдіть у <strong>Зарплати → Схеми мотивації → Створити</strong>. Дайте назву схемі та увімкніть потрібні правила нарахування. Правила згруповані за категоріями:</p><h3>Базові</h3><ul><li><strong>Оклад за місяць</strong> — фіксована сума щомісяця незалежно від графіку (наприклад, 20 000 ₴ менеджеру на повну ставку)</li><li><strong>Ставка за робочий день</strong> — фіксована сума за кожен день по графіку</li><li><strong>Ставка за годину</strong> — фіксована сума за кожну годину по графіку</li></ul><p><em>Ці три типи можна комбінувати. Наприклад: оклад 15 000 ₴ + 200 ₴/день доплати за виходи.</em></p><h3>Товари</h3><ul><li><strong>% від власних продажів</strong> — відсоток від товарів, проданих цим співробітником</li><li><strong>% від усіх продажів локації</strong> — відсоток від загальних товарних продажів точки</li></ul><h3>Послуги</h3><ul><li><strong>% від наданих послуг</strong> — відсоток від виручки записів, де цей співробітник — виконавець. Для послуг, оплачених абонементом, можна обрати: за ціною абонементу, за прайсом або не враховувати.</li><li><strong>Бонус за виконану послугу</strong> — фіксована сума за кожну надану послугу в записі. Якщо у записі 2 послуги (наприклад, манікюр + педикюр) — нараховується 2 × ставка. Можна задати <strong>індивідуальні ставки для окремих послуг</strong> (див. нижче).</li><li><strong>% від використаних матеріалів</strong> — відсоток від вартості матеріалів, використаних при наданні послуг</li><li><strong>% від усіх послуг локації</strong> — відсоток від загальної виручки послуг та абонементів точки</li></ul><h3>Загальні</h3><ul><li><strong>% від загальної виручки</strong> — від усієї виручки локації: послуги + товари + абонементи</li></ul><h3>Адміністративні</h3><ul><li><strong>% від записаних клієнтів</strong> — відсоток від виручки записів, створених цим співробітником</li><li><strong>Бонус за записаного клієнта</strong> — фіксована сума за кожного записаного клієнта</li></ul><h2>Прогресивна шкала (вилки)</h2><p>Для будь-якого <strong>відсоткового правила</strong> можна налаштувати вилки — різні ставки залежно від обсягу. Увімкніть чіпс <strong>«Прогресивна шкала»</strong> на правилі.</p><h3>Режими нарахування</h3><ul><li><strong>Прогресивно (по слайсах)</strong> — кожна частка обороту оподатковується своєю ставкою, як ПДФО. Приклад: вилки 0–100k → 5%, 100k–300k → 7%, 300k+ → 9%. При обороті 350 000 ₴: 100k × 5% + 200k × 7% + 50k × 9% = <strong>23 500 ₴</strong>.</li><li><strong>Плоско (вся сума за досягнутою вилкою)</strong> — вся база рахується за ставкою тієї вилки, в яку потрапив обсяг. При тих самих вилках і обороті 350 000 ₴: 350 000 × 9% = <strong>31 500 ₴</strong>.</li></ul><h3>Як заповнювати</h3><p>Поле <strong>«Від»</strong> заповнюється автоматично ланцюгом (перша вилка з 0, далі — з попереднього «До»). Задаєте тільки <strong>«До»</strong> і <strong>«%»</strong>. Остання вилка з порожнім «До» означає «і вище» (∞). Кнопка «+ Додати вилку» активна лише коли попередня коректно заповнена — це виключає прогалини і перетини.</p><h2>Індивідуальні ставки для послуг</h2><p>Для правила <strong>«Бонус за виконану послугу»</strong> можна задати окрему ставку для конкретних послуг. Увімкніть чіпс <strong>«Винятки для послуг»</strong>.</p><p>Приклад: дефолт 100 ₴/послугу, але для «SPA-педикюру» — 250 ₴. Клієнт прийшов на манікюр + SPA-педикюр: 100 + 250 = 350 ₴.</p><p>Одна послуга може мати тільки один виняток. Dropdown фільтрує вже додані послуги, щоб не дублювати.</p><h2>4. Призначте схему співробітнику</h2><p>У картці співробітника (<strong>Персонал → Співробітники</strong>) в полі <strong>Схема нарахування</strong> оберіть створену схему. Одну схему можна призначити кільком співробітникам.</p><h2>5. Створіть обліковий запис користувача</h2><p>Перейдіть у <strong>Система → Користувачі → Створити</strong>. Вкажіть email, пароль та:</p><ul><li><strong>Роль</strong> — визначає доступ до модулів</li><li><strong>Прив\'язка до співробітника</strong> — для розрахунку ЗП та графіку</li><li><strong>Видимість даних</strong>:<br/>— <strong>Показувати всі</strong> — бачить усі записи та замовлення (адмін, директор)<br/>— <strong>Лише власні</strong> — бачить тільки створені ним документи (менеджер)</li></ul><h2>6. Розрахунок зарплати</h2><p>Щомісяця перейдіть у <strong>Зарплати → Розрахунок</strong>:</p><ol><li>Оберіть місяць</li><li>Натисніть &laquo;Розрахувати&raquo;</li><li>Перегляньте розбивку по кожному правилу</li><li>Для правил з вилками або винятками — клікніть на рядок щоб розгорнути деталізацію (побачите скільки припало на кожну вилку або послугу)</li><li>Додайте ручні коригування за потреби</li><li>Збережіть результат</li></ol><h2>Приклади налаштування</h2><p><strong>Майстер салону:</strong> 40% від наданих послуг + 500₴/день. Видимість — лише власні.</p><p><strong>Майстер з прогресивною мотивацією:</strong> % від власних послуг з вилками (до 30 000 — 30%, 30–60 000 — 35%, 60 000+ — 40%, режим прогресивний) + 400₴/день. Чим більше виробляє, тим вища частка за надлишкові послуги.</p><p><strong>Майстер з різними тарифами:</strong> Бонус за виконану послугу 100₴, з винятками: «Фарбування» — 300₴, «SPA-догляд» — 250₴. Плюс 500₴/день базової ставки.</p><p><strong>Адміністратор медцентру:</strong> оклад 15 000₴/міс + 5% від записаних клієнтів. Видимість — всі.</p><p><strong>Менеджер з продажу:</strong> 8% від власних продажів з вилками (до 50k — 5%, 50–150k — 8%, 150k+ — 12%) + 200₴/день. Видимість — лише власні.</p><p><strong>Директор:</strong> оклад 30 000₴/міс + 2% від загальної виручки. Видимість — всі.</p>',
  'helpPage.schedule.title': 'Розклад роботи та шаблони',
  'helpPage.schedule.content': '<h2>Як задати графік</h2><p>Перейдіть у <strong>Персонал → Розклад роботи</strong>. Оберіть тиждень стрілками навігації. Натисніть на клітинку потрібного дня — відкриється панель налаштування.</p><h3>Тип дня</h3><ul><li><strong>Робочий</strong> — працює, доступний для запису клієнтів</li><li><strong>Вихідний</strong> — не працює</li><li><strong>Відпустка</strong> — не працює (відмічається окремо для обліку)</li><li><strong>Лікарняний</strong> — не працює (відмічається окремо для обліку)</li></ul><h3>Робочі години</h3><p>Вкажіть час початку та закінчення робочого дня. Система автоматично порахує тривалість.</p><h3>Перерви</h3><p>Додайте одну або кілька перерв (обід, відпочинок). Перерви віднімаються з робочого часу при розрахунку зарплати та не показуються як доступні для запису.</p><h2>Шаблони розкладу</h2><p>Щоб не налаштовувати кожен тиждень вручну — використовуйте шаблони.</p><h3>Як створити шаблон</h3><ol><li>Налаштуйте розклад на 2 тижні для потрібного співробітника</li><li>Натисніть &laquo;Зберегти як шаблон&raquo; та вкажіть назву (наприклад, &laquo;Менеджер 5/2&raquo; або &laquo;Майстер 2/2&raquo;)</li></ol><h3>Як застосувати шаблон</h3><ol><li>Відкрийте панель налаштування дня</li><li>Оберіть шаблон зі списку</li><li>Вкажіть кількість повторень (1 цикл = 2 тижні, або на пів року)</li><li>Натисніть &laquo;Застосувати&raquo; — розклад заповниться автоматично</li></ol><h2>Кілька локацій</h2><p>При наявності кількох точок графік задається <strong>окремо для кожної локації</strong>. Один співробітник може мати різний розклад у різних точках.</p><h2>Для чого використовується графік</h2><ul><li>Відображення вільних слотів для запису клієнтів у календарі</li><li>Розрахунок зарплати (ставка за день та за годину)</li><li>Звіт &laquo;Робочі години&raquo; — контроль відпрацьованого часу</li></ul>',
  'helpPage.loyalty.title': 'Програми лояльності',
  'helpPage.loyalty.content': '<h2>Огляд</h2><p>Модуль лояльності в Systemic CRM складається з 4 незалежних програм, кожна з яких вмикається окремо: <strong>Бали (кешбек)</strong>, <strong>Рівні (знижки за витрати)</strong>, <strong>Промокоди (купони)</strong> та <strong>Абонементи</strong>. Перейдіть у <strong>Продажі → Лояльність</strong> для налаштування.</p>'
  + '<h2>1. Бальна програма (кешбек)</h2>'
  + '<h3>Як працює</h3>'
  + '<p>Клієнт отримує бали як відсоток від фактично оплаченої суми. 1 бал = 1 грн. При наступній оплаті клієнт може списати бали для зменшення суми.</p>'
  + '<h3>Налаштування</h3>'
  + '<ul>'
  + '<li><strong>Кешбек балами (%)</strong> — відсоток від суми покупки, який повертається балами. Наприклад, при 10% клієнт отримає 100 балів з покупки на 1 000 грн.</li>'
  + '<li><strong>Макс. % оплати балами</strong> — максимальна частка замовлення, яку можна оплатити балами. При 50% замовлення на 2 000 грн можна покрити балами не більше 1 000 грн.</li>'
  + '</ul>'
  + '<h3>Автоматичні бонуси</h3>'
  + '<ul>'
  + '<li><strong>Бонус на день народження</strong> — вказана кількість балів нараховується автоматично при завантаженні програми в день народження клієнта. Нараховується 1 раз на рік.</li>'
  + '<li><strong>Реферальний бонус</strong> — бали нараховуються клієнту-рефереру при першій оплаті запрошеного клієнта. Вкажіть реферера в картці клієнта (Реферальна програма → Хто привів).</li>'
  + '<li><strong>Бонус за повернення</strong> — якщо клієнт не відвідував вас протягом вказаної кількості днів і повертається — отримує додаткові бали при оплаті.</li>'
  + '</ul>'
  + '<h3>Де нараховуються бали</h3>'
  + '<ul>'
  + '<li><strong>Календар</strong> — при оплаті візиту (на фактично оплачену суму після знижок і списання балів)</li>'
  + '<li><strong>Замовлення</strong> — при оплаті замовлення товарів</li>'
  + '<li><strong>Магазин (POS)</strong> — при продажу через касу</li>'
  + '</ul>'
  + '<h3>Списання балів</h3>'
  + '<p>При оплаті візиту, замовлення або покупки адміністратор бачить поле "Списати бали". Система автоматично обмежує максимум відповідно до налаштувань. Списані бали зменшують суму оплати — на терміналі та в фіскальному чеку фігурує зменшена сума.</p>'
  + '<h3>Історія та баланси</h3>'
  + '<p>У вкладці <strong>Баланси</strong> — поточний баланс кожного клієнта. У вкладці <strong>Історія</strong> — всі операції з балами з детальними примітками: за який візит/замовлення/продаж нараховано, коли і скільки списано.</p>'
  + '<h2>2. Рівні (знижки за витрати)</h2>'
  + '<h3>Як працює</h3>'
  + '<p>Клієнти автоматично отримують рівень (Бронза, Срібло, Золото тощо) залежно від загальної суми витрат. Кожен рівень дає фіксовану знижку на послуги.</p>'
  + '<h3>Що враховується у витратах</h3>'
  + '<ul>'
  + '<li>Оплати за послуги (візити)</li>'
  + '<li>Покупки товарів (замовлення та POS)</li>'
  + '<li>Покупки абонементів</li>'
  + '<li>Мінус повернення</li>'
  + '</ul>'
  + '<h3>Період обліку</h3>'
  + '<p>За замовчуванням витрати рахуються за весь час. Можна налаштувати ковзний період: <strong>6, 12 або 24 місяці</strong>. При ковзному періоді рівень клієнта переоцінюється автоматично — якщо клієнт перестає ходити, його рівень знижується.</p>'
  + '<h3>Налаштування рівнів</h3>'
  + '<p>Додавайте та редагуйте рівні: назва, мінімальна сума витрат, знижка (%). Можна створити скільки завгодно рівнів.</p>'
  + '<h3>Огляд клієнтів</h3>'
  + '<p>У вкладці <strong>Огляд клієнтів</strong> — таблиця з усіма клієнтами, їх рівнями, сумою витрат та знижкою. Пошук за іменем або телефоном.</p>'
  + '<h2>3. Промокоди (купони)</h2>'
  + '<h3>Як працює</h3>'
  + '<p>Створіть купони зі знижкою (відсоток або фіксована сума). Клієнт або адміністратор вводить код при оплаті — знижка застосовується автоматично.</p>'
  + '<h3>Параметри купона</h3>'
  + '<ul>'
  + '<li><strong>Код</strong> — унікальний промокод (наприклад, SPRING20)</li>'
  + '<li><strong>Тип</strong> — відсотковий або фіксований</li>'
  + '<li><strong>Значення</strong> — розмір знижки (20% або 200 грн)</li>'
  + '<li><strong>Мін. сума замовлення</strong> — купон не спрацює, якщо замовлення менше вказаної суми</li>'
  + '<li><strong>Макс. використань</strong> — скільки разів можна використати (0 = необмежено)</li>'
  + '<li><strong>Дійсний до</strong> — дата закінчення дії (пусте = безстрокова)</li>'
  + '</ul>'
  + '<h3>Де працюють купони</h3>'
  + '<p>Поле введення промокоду є в <strong>Календарі</strong> (при оплаті візиту), <strong>Замовленнях</strong> та <strong>Магазині (POS)</strong>.</p>'
  + '<h2>4. Абонементи</h2>'
  + '<h3>Як працює</h3>'
  + '<p>Створіть абонементні плани (наприклад, "10 відвідувань масажу" або "Безлімітний місяць"). Клієнт купує абонемент — і може списувати візити без додаткової оплати.</p>'
  + '<h3>Типи абонементів</h3>'
  + '<ul>'
  + '<li><strong>За кількістю відвідувань</strong> — фіксована кількість візитів (наприклад, 10). Кожне використання зменшує залишок.</li>'
  + '<li><strong>За часом</strong> — безлімітні відвідування протягом вказаного терміну (наприклад, 30 днів).</li>'
  + '</ul>'
  + '<h3>Параметри плану</h3>'
  + '<ul>'
  + '<li><strong>Назва</strong> — наприклад, "Масаж × 10"</li>'
  + '<li><strong>Ціна</strong> — вартість абонементу</li>'
  + '<li><strong>Термін дії</strong> — кількість днів від покупки (0 = безстроковий)</li>'
  + '<li><strong>Кількість відвідувань</strong> — для типу "за відвідуваннями" (0 = безлімітний)</li>'
  + '<li><strong>Послуги</strong> — які послуги покриває абонемент (порожнє = всі)</li>'
  + '</ul>'
  + '<h3>Продаж абонементу</h3>'
  + '<p>У вкладці <strong>Абонементи → Продаж</strong> — оберіть клієнта, план та спосіб оплати. Система створить підписку і платіжну транзакцію. Підтримується оплата готівкою, карткою та через термінал.</p>'
  + '<h3>Використання абонементу</h3>'
  + '<p>При оплаті візиту в Календарі — якщо у клієнта є активний абонемент, що покриває цю послугу — з\'явиться кнопка <strong>"Абонемент"</strong> серед способів оплати. Сума транзакції = 0 (гроші вже сплачені при покупці абонементу).</p>'
  + '<h3>Статуси</h3>'
  + '<ul>'
  + '<li><strong>Активний</strong> — термін не закінчився, є залишок відвідувань</li>'
  + '<li><strong>Використаний</strong> — всі відвідування вичерпано</li>'
  + '<li><strong>Прострочений</strong> — термін дії закінчився</li>'
  + '</ul>'
  + '<h2>Загальні принципи</h2>'
  + '<ul>'
  + '<li>Всі 4 програми працюють <strong>незалежно</strong> — можна увімкнути одну або всі</li>'
  + '<li>Бали, купони і абонементи можна <strong>комбінувати</strong> в одній оплаті</li>'
  + '<li>Всі операції з лояльністю <strong>атомарні</strong> — списання балів, нарахування та оплата відбуваються тільки після успішного проходження терміналу та фіскального чеку</li>'
  + '<li>Програми діють <strong>у всіх локаціях</strong></li>'
  + '<li>Всі операції логуються з <strong>детальними примітками</strong>: тип (візит/замовлення/продаж), дата, сума, кількість балів</li>'
  + '</ul>',
  'clients.searchPlaceholder': "Пошук за ім'ям, телефоном, email, номером картки...",
  'clients.allCategories': 'Всі категорії',
  'clients.allOrigins': 'Усі джерела',
  'clients.origin': 'Джерело',
  'clients.noOrigin': 'Без джерела',
  'custModal.origin': 'Джерело',
  'custModal.originAuto': '(визначено автоматично)',
  'custModal.originNone': '— не вказано —',
  'categories.sourcesTab': 'Джерела',
  'categories.sourcesDesc': 'Звідки приходять клієнти. Вибирається в картці клієнта (вкладка «Деталі»); картки з Instagram, сайту чи інтеграцій отримують джерело автоматично.',
  'categories.sourcesDefault': 'Зараз діє загальний список — змініть його під себе.',
  'categories.noSources': 'Джерел ще немає.',
  'categories.sourcePlaceholder': 'Наприклад: TikTok',
  'categories.addSource': 'Додати',
  'categories.sourceDuplicate': 'Таке джерело вже є',
  'categories.sourcesSaved': 'Збережено',
  'categories.sourcesExtra': 'Ще в картках',
  'categories.sourcesNone': 'Без джерела',
  'categories.clientsShort': 'кл.',
  'categories.moveUp': 'Вище',
  'categories.moveDown': 'Нижче',
  'clients.clientsCount': 'Клієнтів',
  'clients.grid': 'Сітка',
  'clients.list': 'Список',
  'clients.deleteTitle': 'Видалити клієнта?',
  'clients.deleteMessage': 'Ви збираєтесь видалити картку клієнта',
  'clients.cannotDeleteTitle': 'Неможливо видалити',
  'clients.cannotDeleteMessage': 'Клієнт має записи або фінансову історію і не може бути видалений',
  'clients.duplicatePhone': 'Клієнт з таким номером телефону вже існує',
  'clients.duplicatePhoneWithName': 'Клієнт з таким номером уже існує: {name}',
  'clients.importSqlErrors': 'Частину карток не вдалося записати повністю: {n}. Повідомте адміністратора.',
  'clients.duplicateInstagram': 'Цей нік Instagram уже вказано в іншій картці',
  'clients.duplicateInstagramWithName': 'Цей нік Instagram уже в картці: {name}',
  'clients.openExisting': 'Перейти до клієнта',
  'clients.understood': 'Зрозуміло',
  'clients.deleteWarning': 'Ця дія незворотна. Всі дані клієнта будуть втрачені.',

  // ── Delete modal ──
  'delete.title': 'Підтвердити видалення',
  'delete.message': 'Ви збираєтесь видалити запис',
  'delete.confirm': 'Так, видалити',
  'delete.warning': 'Ця дія незворотна. Всі дані будуть втрачені.',

  // ── Confirm Payment Modal ──
  'confirmPay.title': 'Підтвердити оплату',
  'confirmPay.refundTitle': 'Підтвердити повернення',
  'confirmPay.confirm': 'Підтвердити оплату',
  'confirmPay.confirmRefund': 'Підтвердити повернення',
  'confirmPay.withFiscal': 'З фіскальним чеком',
  'confirmPay.refundWarning': 'Кошти будуть повернуті клієнту',
  'confirmPay.subscriptionVisits': 'Буде списано {count} візит(ів) з абонементу',
  'confirmPay.terminalWaiting': 'Очікуйте на терміналі...',
  'confirmPay.terminalHint': 'Попросіть клієнта прикласти картку до терміналу',
  'confirmPay.terminalProcessing': 'Обробка...',

  // ── Payment Success Overlay ──
  'paySuccess.title': 'Оплата успішна',
  'paySuccess.refundTitle': 'Повернення успішне',
  'paySuccess.subscriptionVisits': 'Списано {count} візит(ів) з абонементу',

  // ── Sidebar ──
  'sidebar.crmSystem': 'CRM-система',
  'sidebar.version': 'v1.0',

  // ── Login ──
  'login.title': 'Вхід в систему',
  'login.setupTitle': 'Налаштування системи',
  'login.setupSubtitle': 'Створіть обліковий запис адміністратора',
  'login.subtitle': 'Введіть дані для входу',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.submit': 'Увійти',
  'login.setupSubmit': 'Створити адміністратора',
  'login.wait': 'Зачекайте…',
  'login.forgotPassword': 'Забули пароль?',
  'login.resetTitle': 'Скидання пароля',
  'login.resetSubtitle': 'Введіть email — надішлемо посилання для скидання',
  'login.resetSend': 'Надіслати',
  'login.resetSentHint': 'Перевірте вашу пошту — ми надіслали інструкції',
  'login.backToLogin': 'Повернутись до входу',
  'login.nameLabel': "Ім'я",
  'login.namePlaceholder': "Ваше ім'я",
  'login.businessLabel': 'Назва бізнесу',
  'login.businessPlaceholder': 'Мій салон / магазин / студія',
  'login.errorEnterBusiness': 'Введіть назву бізнесу',
  'login.businessTypeLabel': 'Тип бізнесу',
  'login.businessTypePlaceholder': 'Оберіть тип бізнесу...',
  'login.errorSelectBusinessType': 'Оберіть тип бізнесу',
  'login.showPassword': 'Показати пароль',
  'login.hidePassword': 'Сховати пароль',
  'login.errorInvalidCreds': 'Невірний email або пароль',
  'login.errorTooMany': 'Забагато спроб. Спробуйте пізніше.',
  'login.errorGeneric': 'Помилка входу: ',
  'login.errorEnterName': "Введіть ім'я",
  'login.errorEnterEmail': 'Введіть email',
  'login.errorMinPassword': 'Пароль мінімум 6 символів',
  'login.errorSetup': 'Помилка: ',
  'login.tabLogin': 'Вхід',
  'login.tabRegister': 'Реєстрація',
  'login.registerTitle': 'Створити акаунт',
  'login.registerSubtitle': '7 днів безкоштовно, всі модулі включено',
  'login.registerSubmit': 'Зареєструватись',
  'login.registerSuccess': 'Акаунт створено! Входимо...',
  'login.errorEmailExists': 'Цей email вже зареєстровано',
  'login.errorRegister': 'Помилка реєстрації: ',
  'login.confirmPassword': 'Підтвердіть пароль',
  'login.errorPasswordMismatch': 'Паролі не співпадають',
  'login.agreeTerms': 'Реєструючись, ви погоджуєтесь з',
  'login.agreeCheckbox': 'Я погоджуюсь з',
  'login.errorAgreeTerms': 'Необхідно погодитись з умовами використання',
  'login.terms': 'Умовами використання',
  'login.privacy': 'Політикою конфіденційності',

  // ── Blocked ──
  'blocked.title': 'Акаунт заблоковано',
  'blocked.desc': 'Зверніться до адміністратора для відновлення доступу',
  'blocked.trialExpired': 'Пробний період закінчився',
  'blocked.trialExpiredDesc': 'Оберіть тарифний план для продовження роботи',
  'blocked.paymentOverdue': 'Підписка прострочена',
  'blocked.paymentOverdueDesc': 'Ваша підписка закінчилась. Будь ласка, продовжіть її для продовження роботи.',
  'blocked.subscriptionExpiredDesc': 'Ваша підписка закінчилась. Будь ласка, пролонгуйте її для продовження роботи.',
  'blocked.contact': 'Зв\'язатись з підтримкою',
  'blocked.logout': 'Вийти',

  // ── My Plan ──
  'myPlan.title': 'Мій план',
  'myPlan.subtitle': 'Управління підпискою',
  'myPlan.loadError': 'Не вдалося завантажити дані плану',
  'myPlan.trial': 'Пробний',
  'myPlan.active': 'Активний',
  'myPlan.trialExpired': 'Тріал закінчився',
  'myPlan.blocked': 'Заблоковано',
  'myPlan.daysLeft': 'днів залишилось',
  'myPlan.month': 'міс',
  'myPlan.year': 'рік',
  'myPlan.orYearly': 'або',
  'myPlan.chooseBillingPeriod': 'оберіть період оплати',
  'myPlan.periodMonthly': 'Щомісяця',
  'myPlan.periodYearly': 'Річно',
  'myPlan.yearlySaving': 'економія {n} ₴ проти місячної',
  'myPlan.monthlyTotal': '{n} ₴/рік',
  'myPlan.proceedToPayment': 'Перейти до оплати',
  'myPlan.cancel': 'Скасувати',
  'myPlan.oldRateTitle': 'Ви на старій ставці',
  'myPlan.oldRateText': 'Зараз ви платите {old} ₴, поточна ставка для тарифу {plan} — {new} ₴. Можете залишитись на старій ставці необмежено або перейти на нову.',
  'myPlan.upgradeRate': 'Перейти на нову',
  'myPlan.users': 'Користувачі',
  'myPlan.locations': 'Локації',
  'myPlan.availablePlans': 'Доступні плани',
  'myPlan.popular': 'Популярний',
  'myPlan.usersIncl': 'користувачів',
  'myPlan.locationsIncl': 'локацій',
  'myPlan.allModules': 'Всі 46 модулів',
  'myPlan.trialActive': 'Тріал активний',
  'myPlan.currentPlan': 'Поточний план',
  'myPlan.upgrade': 'Обрати план',
  'myPlan.changePlan': 'Змінити план',
  'myPlan.renewPlan': 'Продовжити',
  'myPlan.subscriptionExpired': 'прострочено',
  'myPlan.trialHint': 'Після закінчення пробного періоду оберіть план для продовження роботи. Всі ваші дані збережуться.',
  'myPlan.limitUsers': 'Досягнуто ліміт користувачів для вашого плану. Оберіть вищий план.',
  'myPlan.limitLocations': 'Досягнуто ліміт локацій для вашого плану. Оберіть вищий план.',
  'myPlan.cancelSubscription': 'Скасувати підписку',
  'myPlan.cancelledNotice': 'Підписку скасовано. План діє до кінця оплаченого періоду.',
  'myPlan.cancelTitle': 'Скасувати підписку?',
  'myPlan.cancelDescription': 'Ваш план залишиться активним до кінця оплаченого періоду. Після цього акаунт буде переведено на пробний план.',
  'myPlan.cancelReasonLabel': 'Причина скасування (необов\'язково)',
  'myPlan.cancelReasonPlaceholder': 'Розкажіть, чому ви вирішили скасувати...',
  'myPlan.confirmCancel': 'Так, скасувати',
  'myPlan.keepSubscription': 'Залишити підписку',
  'myPlan.cancelError': 'Помилка скасування',

  // ── Checkout (post-registration) ──
  'checkout.title': 'Ваш акаунт створено!',
  'checkout.subtitle': 'Оберіть як почати роботу з Systemic CRM',
  'checkout.recommended': 'Рекомендовано',
  'checkout.payNow': 'Оплатити та почати',
  'checkout.trialTitle': 'Безкоштовний тріал',
  'checkout.days': 'днів',
  'checkout.trialFeature1': 'Повний доступ до всіх функцій',
  'checkout.trialFeature2': 'Без зобов\'язань',
  'checkout.trialFeature3': 'Дані збережуться після оплати',
  'checkout.tryFree': 'Спробувати безкоштовно',

  // ── Dashboard ──
  'dash.title': 'Dashboard',
  'dash.myOffice': 'Мій кабінет',
  'dash.subtitle': 'Головний екран',
  'dash.personalStats': 'Персональна статистика',
  'dash.todayAppointments': 'Записи сьогодні',
  'dash.completed': 'завершено',
  'dash.todayRevenue': 'Виручка сьогодні',
  'dash.clientsCount': 'Клієнтів',
  'dash.newThisMonth': 'цього місяця',
  'dash.unread': 'Непрочитаних',
  'dash.todaySchedule': 'Розклад на сьогодні',
  'dash.allAppointments': 'Всі записи',
  'dash.noAppointmentsToday': 'Немає записів на сьогодні',
  'dash.moreAppointments': 'записів',
  'dash.weekRevenue': 'Виручка за тиждень',
  'dash.needsAttention': 'Потребує уваги',
  'dash.unreadMessages': 'непрочитаних повідомлень',
  'dash.lowStock': 'низький залишок',
  'dash.topClients': 'Топ клієнти (місяць)',
  'dash.noPaymentsThisMonth': 'Немає оплат цього місяця',
  'dash.birthdays': 'Дні народження',
  'dash.noBirthdaysThisWeek': 'Немає днів народження цього тижня',
  'dash.today': 'Сьогодні!',
  'dash.tomorrow': 'Завтра',
  'dash.inDays': 'Через {n} дн.',
  'dash.congratulate': 'Привітати',
  'dash.atRisk': 'Під ризиком втрати',
  'dash.allClientsActive': 'Всі клієнти активні',
  'dash.daysWithoutVisit': 'днів без візиту',
  'dash.write': 'Написати',
  'dash.todayOrderSales': 'Продажі товарів',
  'dash.serviceSales': 'Продажі послуг',
  'dash.appointmentsToday': 'записів сьогодні',
  'dash.ordersToday': 'замовлень сьогодні',
  'dash.activeOrders': 'активних',
  'dash.recentOrders': 'Останні замовлення',
  'dash.allOrders': 'Всі замовлення',
  'dash.items': 'позицій',
  'dash.statusWaiting': 'Очікує',
  'dash.statusConfirmed': 'Завершено',
  'dash.statusArrived': 'Прийшов',
  'dash.statusNoShow': 'Не прийшов',
  'dash.dowSun': 'Нд', 'dash.dowMon': 'Пн', 'dash.dowTue': 'Вт',
  'dash.dowWed': 'Ср', 'dash.dowThu': 'Чт', 'dash.dowFri': 'Пт', 'dash.dowSat': 'Сб',

  // ── Profile modal ──
  'profile.title': 'Профіль',
  'profile.name': "Ім'я",
  'profile.namePlaceholder': "Ваше ім'я",
  'profile.email': 'Email',
  'profile.changePassword': 'Змінити пароль',
  'profile.passwordHint': 'Залиште поля порожніми, якщо не хочете змінювати пароль',
  'profile.currentPassword': 'Поточний пароль',
  'profile.newPassword': 'Новий пароль',
  'profile.newPasswordPlaceholder': 'Мінімум 6 символів',
  'profile.confirmPassword': 'Підтвердження пароля',
  'profile.confirmPasswordPlaceholder': 'Повторіть новий пароль',
  'profile.saved': 'Збережено!',
  'profile.passwordChanged': 'Пароль змінено',
  'profile.homePage': 'Головна сторінка',
  'profile.startingLocation': 'Стартова локація',
  'profile.startingLocationAuto': 'Автоматично (за замовчанням)',
  'profile.homeBizMonitor': 'Монітор бізнесу',
  'profile.homeDashboard': 'Дешборд',
  'profile.homeCalendar': 'Календар',
  'profile.homeClients': 'Клієнтська база',
  'profile.homePos': 'Магазин',
  'profile.homeOrders': 'Замовлення',
  'profile.homeFinances': 'Фінансові операції',
  'profile.homeCommunication': 'Повідомлення',
  'profile.homeStaff': 'Співробітники',
  'profile.homeStock': 'Залишки',
  'profile.homePurchases': 'Закупівлі',
  'profile.homeProduction': 'Виробництво',
  'profile.homeSalary': 'Розрахунок',
  'profile.homeCashRegister': 'Каса',
  'profile.homeReports': 'Звіти',
  'profile.homeFinResult': 'Фін. результат',
  'profile.profileUpdated': 'Профіль оновлено',
  'profile.errorEnterName': "Введіть ім'я",
  'profile.errorEnterCurrentPassword': 'Введіть поточний пароль',
  'profile.errorMinPassword': 'Новий пароль мінімум 6 символів',
  'profile.errorPasswordMismatch': 'Паролі не збігаються',
  'profile.errorWrongPassword': 'Невірний поточний пароль',
  'profile.errorTooMany': 'Забагато спроб. Спробуйте пізніше.',
  'profile.errorGeneric': 'Помилка: ',

  // ── Calendar page ──
  'cal.monthGen.0': 'січня', 'cal.monthGen.1': 'лютого', 'cal.monthGen.2': 'березня',
  'cal.monthGen.3': 'квітня', 'cal.monthGen.4': 'травня', 'cal.monthGen.5': 'червня',
  'cal.monthGen.6': 'липня', 'cal.monthGen.7': 'серпня', 'cal.monthGen.8': 'вересня',
  'cal.monthGen.9': 'жовтня', 'cal.monthGen.10': 'листопада', 'cal.monthGen.11': 'грудня',
  'cal.weekday.0': 'Неділя', 'cal.weekday.1': 'Понеділок', 'cal.weekday.2': 'Вівторок',
  'cal.weekday.3': 'Середа', 'cal.weekday.4': 'Четвер', 'cal.weekday.5': "П'ятниця", 'cal.weekday.6': 'Субота',
  'cal.today': 'Сьогодні',
  'cal.daySchedule': 'Розклад на день',
  'cal.appointments': 'записів',
  'cal.working': 'Працює',
  'cal.dayOff': 'Вихідний',
  'cal.noStaffWorking': 'Немає працюючих співробітників на цей день',
  'cal.clickToAdd': 'Натисніть на час, щоб додати запис',
  'cal.service': 'Послуга',
  'cal.material': 'Матеріал',
  'cal.batchClashed': 'Не створено — у майстра вже є запис: {list}',
  'cal.paymentNotRecorded': 'Оплату проведено, але запис про неї не збережено. Не повторюйте оплату — повідомте адміністратора.',
  'cal.subscriptionVisitNotReturned': 'Візит не повернуто на абонемент — повідомте адміністратора.',
  'cal.paid': 'Оплачено',
  'cal.unpaid': 'Не оплачено',
  'cal.batchBooking': 'Пакетний запис',
  'cal.batchCreated': 'Створено записів',
  'cal.fiscalReceiptCreated': 'Фіскальний чек створено',
  'cal.fiscalReceiptError': 'Помилка фіскалізації',
  'cal.terminalError': 'Помилка оплати через термінал',
  'cal.fiscalReturnError': 'Помилка створення фіскального чека повернення',
  'cal.refundRecorded': 'Повернення зафіксовано',
  'cal.cannotDeletePaid': 'Неможливо видалити оплачений запис. Спочатку зробіть повернення.',

  // ── Appointment modal ──
  'apt.newTitle': 'Новий запис',
  'apt.editTitle': 'Редагування запису',
  'apt.closeEsc': 'Закрити (Esc)',
  'apt.client': 'Клієнт',
  'apt.nameOrPhone': "Ім'я або телефон",
  'apt.startTyping': 'Почніть вводити...',
  'apt.phone': 'Телефон',
  'apt.viewProfile': 'Перейти до профілю',
  'apt.dateAndTime': 'Дата і час',
  'apt.date': 'Дата',
  'apt.startTime': 'Початок',
  'apt.endTime': 'Закінчення',
  'apt.servicesAndPayment': 'Послуги та оплата',
  'apt.pricelist': 'Прайс',
  'apt.addService': 'Додати послугу',
  'apt.standardPrice': 'Стандартна ціна',
  'apt.tariffPlan': 'Тарифний план',
  'apt.min': 'хв',
  'apt.discount': 'Знижка',
  'apt.uah': 'грн',
  'apt.total': 'Разом',
  'apt.toPay': 'До сплати',
  'apt.paymentMethod': 'Спосіб оплати',
  'apt.cash': 'Готівка',
  'apt.terminal': 'Термінал',
  'apt.transfer': 'Переказ',
  'apt.paid': 'Оплачено',
  'apt.clientGave': 'Клієнт дав',
  'apt.change': 'Решта',
  'apt.note': 'Примітка',
  'apt.author': 'Автор',
  'apt.rescheduled': 'Перенесено',
  'apt.notePlaceholder': 'Коментар до запису...',
  'apt.notesPlaceholder': 'Коментар до запису...',
  'apt.book': 'Записати',
  'apt.saveChanges': 'Зберегти зміни',
  'apt.cancel': 'Скасувати',
  'apt.delete': 'Видалити',
  'apt.printBill': 'Рахунок',
  'apt.deleteTitle': 'Видалити запис?',
  'apt.deleteMessage': 'Ви збираєтесь видалити цей запис. Цю дію неможливо скасувати.',
  'apt.payBtn': 'Оплатити',
  'apt.confirmPayment': 'Підтвердити оплату?',
  'apt.refund': 'Повернення',
  'apt.refundTitle': 'Повернення коштів',
  'apt.refundMessage': 'Ви впевнені, що хочете повернути кошти за цей запис?',
  'apt.refundWarning': 'Цю дію неможливо скасувати.',
  'apt.confirmRefund': 'Підтвердити повернення',
  'apt.refunded': 'Повернено',
  'apt.back': 'Назад',
  'apt.batchBooking': 'Пакетний запис',
  'apt.createMultiple': 'Створити декілька',
  'apt.materials': 'Матеріали',
  'apt.product': 'Товар',
  'apt.qty': 'К-сть',
  'apt.pcs': 'шт',
  'apt.add': 'Додати',
  'apt.noProductsAdded': 'Товари не додано',
  'apt.noProductsInStock': 'Немає товарів на складі',
  'apt.notEnough': 'Недостатньо',
  'apt.notEnoughInStock': 'Недостатньо на складі',
  'apt.notEnoughStock': 'Недостатньо залишку',
  'apt.appointmentNote': 'Примітка до запису',
  'apt.clientDocs': 'Документи клієнта',
  'apt.addDocument': 'Додати документ',
  'apt.docName': 'Назва документа',
  'apt.docNamePlaceholder': 'Введіть назву...',
  'apt.docText': 'Текст документа',
  'apt.noDocsYet': 'Документів ще немає',
  'apt.attachFile': 'Прикріпити файл',
  'apt.maxFileSize': 'Макс. розмір файлу: 2 МБ',
  'apt.errClientName': "Введіть ім'я клієнта",
  'apt.errClientPhone': 'Введіть телефон клієнта',
  'apt.errDate': 'Оберіть дату',
  'apt.errDiscount': 'Знижка не може перевищувати суму',
  'apt.errDayOff': 'Спеціаліст не працює в цей день',
  'apt.errOutsideWorkingHours': 'Час виходить за робочі години ({start} – {end})',
  'apt.errOverlap': 'Час перетинається з записом {start}–{end} ({client})',
  'apt.workingHoursHint': 'Робочі години: {start} – {end}',
  'apt.statusWaiting': 'Очікує',
  'apt.statusConfirmed': 'Завершено',
  'apt.statusArrived': 'Прийшов',
  'apt.statusNoShow': 'Не прийшов',

  // ── Batch appointment modal ──
  'batchApt.title': 'Пакетний запис',
  'batchApt.subtitle': 'Створення декількох записів одночасно',
  'batchApt.closeEsc': 'Закрити (Esc)',
  'batchApt.client': 'Клієнт',
  'batchApt.nameOrPhone': "Ім'я або телефон",
  'batchApt.phone': 'Телефон',
  'batchApt.staffMember': 'Майстер',
  'batchApt.service': 'Послуга',
  'batchApt.discount': 'Знижка',
  'batchApt.uah': 'грн',
  'batchApt.addDate': 'Додати дату',
  'batchApt.delete': 'Видалити',
  'batchApt.entries': 'записів',
  'batchApt.entrySingle': 'запис',
  'batchApt.entryPlural': 'записів',
  'batchApt.create': 'Створити',
  'batchApt.cancel': 'Скасувати',
  'batchApt.errClientName': "Введіть ім'я клієнта",
  'batchApt.errClientPhone': 'Введіть телефон клієнта',
  'batchApt.errDiscount': 'Знижка не може перевищувати суму',
  'batchApt.errNoRows': 'Додайте хоча б один запис',

  // ── Customer card ──
  'custCard.edit': 'Редагувати',
  'custCard.delete': 'Видалити',
  'custCard.book': 'Записати',
  'custCard.order': 'Замовлення',
  'custCard.sell': 'Продати',
  'custCard.sellProduct': 'Товар',
  'custCard.sellService': 'Послуга',
  'custCard.sellSubscription': 'Абонемент',
  'custCard.openFinances': 'Фінанси',
  'custCard.paid': 'Оплачено',
  'custCard.sold': 'Продано',
  'custCard.balance': 'Баланс',
  'custCard.importance': 'Важливість',
  'custCard.forbidOnlineBooking': 'Заборонено онлайн-запис',

  // ── Customer grid ──
  'custGrid.noCustomersFound': 'Клієнтів не знайдено',
  'custGrid.tryChangeSearch': 'Спробуйте змінити пошуковий запит або фільтр категорії',

  // ── Customer modal ──
  'custModal.newCustomer': 'Новий клієнт',
  'custModal.editCustomer': 'Редагування клієнта',
  'custModal.closeEsc': 'Закрити (Esc)',
  'custModal.tabMain': 'Основне',
  'custModal.tabDetails': 'Деталі',
  'custModal.tabVisits': 'Візити',
  'custModal.tabFinancial': 'Фінанси',
  'custModal.tabAnalytics': 'Аналітика',
  'custModal.tabNotes': 'Нотатки',
  'custModal.tabDocuments': 'Документи',
  'custModal.personalData': 'Особисті дані',
  'custModal.fullName': "Ім'я та прізвище",
  'custModal.fullNamePlaceholder': "Введіть повне ім'я",
  'custModal.mobilePhone': 'Мобільний телефон',
  'custModal.additionalPhone': 'Додатковий телефон',
  'custModal.birthDate': 'Дата народження',
  'custModal.day': 'День',
  'custModal.month': 'Місяць',
  'custModal.year': 'Рік',
  'custModal.gender': 'Стать',
  'custModal.genderMale': 'Чоловіча',
  'custModal.genderFemale': 'Жіноча',
  'custModal.genderOther': 'Інше',
  'custModal.cardNumber': 'Номер картки',
  'custModal.profilePhoto': 'Фото профілю',
  'custModal.uploadPhoto': 'Завантажити фото',
  'custModal.changePhoto': 'Змінити фото',
  'custModal.deletePhoto': 'Видалити фото',
  'custModal.avatar': 'Аватар',
  'custModal.categoryAndClassification': 'Категорія та класифікація',
  'custModal.category': 'Категорія',
  'custModal.importanceLabel': 'Важливість',
  'custModal.discountLabel': 'Знижка',
  'custModal.discountRange': '0–100%',
  'custModal.referral': 'Реферальна програма',
  'custModal.referredBy': 'Хто привів',
  'custModal.referredByHint': 'Вкажіть клієнта, який привів цю людину. Рефереру нарахується бонус при першій оплаті.',
  'custModal.restrictions': 'Обмеження',
  'custModal.forbidOnlineBooking': 'Заборонити онлайн-запис',
  'custModal.forbidOnlineBookingDesc': 'Клієнт не зможе записатися самостійно',
  'custModal.telegramReminders': 'Нагадування Telegram',
  'custModal.telegramConnected': 'Telegram підключено',
  'custModal.setupTelegramBot': 'Налаштуйте Telegram бот',
  'custModal.sendLinkToCustomer': 'Надіслати посилання клієнту',
  'custModal.send': 'Надіслати',
  'custModal.sending': 'Надсилання...',
  'custModal.specifyPhoneFirst': 'Вкажіть телефон спочатку',
  'custModal.save': 'Зберегти',
  'custModal.cancel': 'Скасувати',
  'custModal.close': 'Закрити',
  'custModal.editBtn': 'Редагувати',
  'custModal.viewCustomer': 'Картка клієнта',
  'custModal.back': 'Назад',
  'custModal.next': 'Далі',
  'custModal.nameRequired': "Ім'я обов'язкове",
  'custModal.phoneRequired': "Телефон обов'язковий",
  'custModal.instagram': 'Instagram (нік)',
  'custModal.instagramInvalid': 'Нік Instagram: латиниця, цифри, крапка, підкреслення',
  'custModal.fromThreadHint': 'Картка з листування: після збереження тред привʼяжеться до неї разом з історією.',
  'custModal.nameDuplicate': 'Клієнт з таким іменем вже існує',
  'custModal.phoneDuplicate': 'Клієнт з таким телефоном вже існує',
  'custModal.note': 'Примітка',
  'custModal.notePlaceholder': 'Додати нотатку...',
  'custModal.comments': 'Коментарі',
  'custModal.contactLater': 'Звʼязатися пізніше',
  'custComments.placeholder': 'Новий коментар…',
  'custComments.add': 'Додати',
  'apiKeys.title': 'Ключі API',
  'apiKeys.subtitle': 'Доступ зовнішніх систем до клієнтів закладу',
  'apiKeys.create': 'Створити ключ',
  'apiKeys.empty': 'Ключів ще немає.',
  'apiKeys.revoked': 'Відкликано',
  'apiKeys.revoke': 'Відкликати',
  'apiKeys.noScopes': 'Без дозволів',
  'apiKeys.createdBy': 'Створив',
  'apiKeys.lastUsed': 'Востаннє використано',
  'apiKeys.name': 'Назва',
  'apiKeys.namePlaceholder': 'Наприклад: Telegram-бот, Сайт, Binotel',
  'apiKeys.createBtn': 'Створити',
  'apiKeys.newTitle': 'Ключ створено',
  'apiKeys.onceWarning': 'Скопіюйте ключ зараз — більше його показати неможливо.',
  'apiKeys.copy': 'Копіювати',
  'apiKeys.done': 'Я зберіг ключ',
  'apiKeys.copied': 'Скопійовано',
  'apiKeys.copyFailed': 'Не вдалося скопіювати',
  'apiKeys.docs': 'Документація для розробника',
  'apiKeys.copyDocs': 'Копіювати посилання на документацію',
  'apiKeys.handover': 'Передайте розробнику ключ і посилання на документацію:',
  'nav.calls': 'Дзвінки',
  'nav.documentTemplates': 'Шаблони документів',
  'custModal.docFromTemplate': 'Документ із шаблону',
  'custModal.previewDoc': 'Переглянути й надрукувати',
  'apt.docFromTemplate': 'Документ із шаблону',
  'apt.previewDoc': 'Переглянути / друк',
  'nav.telephony': 'Телефонія',
  'custModal.tabCalls': 'Дзвінки',
  'custModal.fromCallHint': 'Картка з дзвінка: усі дзвінки з цього номера зʼявляться в її вкладці «Дзвінки».',
  'tel.title': 'Телефонія',
  'tel.subtitle': 'Дзвінки в Systemic: хто дзвонить, історія, пропущені',
  'tel.step1': 'Ключі Binotel',
  'tel.step1Hint': 'Ключ і секрет REST API видає підтримка Binotel: напишіть на support@binotel.ua з пошти вашого акаунта з проханням видати ключі для REST API.',
  'tel.apiKey': 'Ключ (key)',
  'tel.apiSecret': 'Секрет (secret)',
  'tel.save': 'Зберегти',
  'tel.saved': 'Збережено',
  'tel.test': 'Перевірити ключі',
  'tel.testOk': 'Binotel прийняв ключі',
  'tel.testFail': 'Binotel не прийняв ключі',
  'tel.linesNote': 'Внутрішні лінії розставляти не треба: кожен співробітник вибере свій телефон, коли вперше натисне «Подзвонити».',
  'tel.step2': 'Адреса для Binotel',
  'tel.step2Hint': 'Надішліть цей лист у підтримку Binotel (support@binotel.ua) з пошти вашого акаунта. Адреса секретна — нікому, крім Binotel, її не передавайте.',
  'tel.copyEmail': 'Копіювати лист',
  'tel.rotate': 'Нова адреса',
  'tel.rotateConfirm': 'Створити нову адресу? Стара перестане працювати, і нову треба буде знову передати в підтримку Binotel.',
  'tel.binotelLines': 'Лінії в Binotel',
  'tel.disconnect': 'Відключити',
  'tel.disconnectConfirm': 'Відключити телефонію? Історія дзвінків лишиться.',
  'tel.step4': 'Причини «не домовились»',
  'tel.step4Hint': 'Після розмови співробітник може позначити «Домовились» або «Не домовились» і вибрати причину з цього списку. Позначка необовʼязкова.',
  'tel.step4Default': 'Зараз діє загальний список — змініть його під себе.',
  'tel.removeReason': 'Прибрати',
  'tel.reasonPlaceholder': 'Наприклад: Немає вільного часу',
  'tel.addReason': 'Додати',
  'tel.saveReasons': 'Зберегти причини',
  'custComments.empty': 'Коментарів ще немає.',
  'custComments.afterCreate': 'Коментарі можна додавати після створення картки.',
  'custComments.edit': 'Виправити',
  'custComments.delete': 'Видалити',
  'custComments.save': 'Зберегти',
  'custComments.edited': 'виправлено',
  'custComments.unknown': 'Невідомий',
  'custComments.legacy': 'Попередні коментарі',
  'custComments.older': 'Показати раніші',
  'custComments.confirmDelete': 'Видалити коментар?',
  'custComments.addFailed': 'Не вдалося додати коментар',
  'custComments.saveFailed': 'Не вдалося зберегти',
  'custComments.deleteFailed': 'Не вдалося видалити',
  'custModal.commentsPlaceholder': 'Написати коментар...',
  'custModal.writeMessagePlaceholder': 'Написати повідомлення...',
  // Customer modal — visits tab
  'custModal.visitHistory': 'Історія візитів',
  'custModal.totalVisits': 'Всього візитів',
  'custModal.lastVisit': 'Останній візит',
  'custModal.visitFrequency': 'Частота візитів',
  'custModal.days': 'дн.',
  'custModal.visitsByMonth': 'Візити по місяцях',
  'custModal.noVisitsYet': 'Візитів ще немає',
  'custModal.tabOrders': 'Покупки',
  'custModal.orderHistory': 'Історія покупок',
  'custModal.ordersTotal': 'Замовлень',
  'custModal.ordersDelivered': 'Доставлено',
  'custModal.ordersPaid': 'Оплачено',
  'custModal.noOrdersYet': 'Покупок ще немає',
  'custModal.posSalesCount': 'Продажів',
  'custModal.orderStatusNew': 'Нове',
  'custModal.orderStatusConfirmed': 'Підтверджено',
  'custModal.orderStatusPacked': 'Зібрано',
  'custModal.orderStatusShipped': 'Відправлено',
  'custModal.orderStatusDelivered': 'Доставлено',
  'custModal.orderStatusCancelled': 'Скасовано',
  'custModal.posCompleted': 'Завершено',
  'custModal.posSourceLabel': 'Магазин',
  'custModal.orderSourceLabel': 'Замовлення',
  'custModal.subscriptionsLabel': 'Абонементи',
  'custModal.completed': 'Завершено',
  'custModal.noShow': 'Не прийшов',
  'custModal.statusWaiting': 'Очікує',
  'custModal.statusConfirmed': 'Завершено',
  'custModal.statusArrived': 'Прийшов',
  'custModal.statusNoShow': 'Не прийшов',
  // Customer modal — financial tab
  'custModal.financialIndicators': 'Фінансові показники',
  'custModal.finPaid': 'Оплачено',
  'custModal.finBalance': 'Баланс',
  'custModal.avgCheck': 'Сер. чек',
  'custModal.ltv': 'LTV',
  'custModal.charges': 'Нарахування',
  'custModal.noChargesYet': 'Нарахувань ще немає',
  'custModal.subscriptionPurchase': 'Покупка абонементу',
  'custModal.subscriptionRefund': 'Повернення абонементу',
  'custModal.noPaymentsYet': 'Оплат ще немає',
  'custModal.date': 'Дата',
  'custModal.dateTime': 'Дата/час',
  'custModal.service': 'Послуга',
  'custModal.serviceLabel': 'Послуга',
  'custModal.price': 'Ціна',
  'custModal.discount': 'Знижка',
  'custModal.total': 'Разом',
  'custModal.paidLabel': 'Оплата',
  'custModal.payment': 'Оплата',
  'custModal.paymentMethod': 'Спосіб оплати',
  'custModal.amount': 'Сума',
  'custModal.totalAmount': 'Загальна сума',
  'custModal.methodCash': 'Готівка',
  'custModal.methodCard': 'Картка',
  'custModal.methodTransfer': 'Переказ',
  'custModal.methodOnline': 'Онлайн',
  'custModal.methodSubscription': 'Абонемент',
  'custModal.cash': 'Готівка',
  'custModal.terminal': 'Термінал',
  'custModal.transfer': 'Переказ',
  'custModal.online': 'Онлайн',
  'custModal.refund': 'Повернення',
  'custModal.sold': 'Продано',
  'custModal.finCharged': 'Нараховано',
  'custModal.serviceCharges': 'Нарахування за послуги',
  'custModal.servicesLabel': 'Послуги',
  'custModal.productCharges': 'Нарахування за товари',
  'custModal.productLabel': 'Товар',
  'custModal.noProductChargesYet': 'Продажів товарів ще не було',
  'custModal.time': 'Час',
  'custModal.unknown': 'Невідомо',
  // Customer modal — analytics tab
  'custModal.favoriteMaster': 'Улюблений майстер',
  'custModal.favoriteService': 'Улюблена послуга',
  'custModal.favoriteProduct': 'Улюблений товар',
  'custModal.lastActivity': 'Остання активність',
  'custModal.spendingBreakdown': 'Розбивка витрат',
  'custModal.purchasesByMonth': 'Покупки по місяцях',
  'custModal.churn_low': 'Клієнт активний',
  'custModal.churn_medium': 'Ризик відтоку — давно не з\'являвся',
  'custModal.churn_high': 'Високий ризик відтоку — потрібен контакт',
  // Customer modal — documents tab
  'custModal.customerDocuments': 'Документи клієнта',
  'custModal.addDocument': 'Додати документ',
  'custModal.addDoc': 'Додати',
  'custModal.addBtn': 'Додати',
  'custModal.noDocumentsYet': 'Документів ще немає',
  'custModal.docName': 'Назва документа',
  'custModal.docNamePlaceholder': 'Введіть назву...',
  'custModal.docNameRequired': 'Введіть назву документа',
  'custModal.docText': 'Текст документа',
  'custModal.docTextPlaceholder': 'Введіть текст...',
  'custModal.attachFile': 'Прикріпити файл',
  'custModal.fileUpTo2MB': 'Файл до 2 МБ',
  'custModal.fileTooLarge': 'Файл занадто великий (макс. 2 МБ)',
  'custModal.emptyDocument': 'Порожній документ',
  'custModal.deleteDoc': 'Видалити документ',
  'custModal.deleteThisDoc': 'Видалити цей документ?',
  'custModal.deleteBtn': 'Видалити',
  'custModal.download': 'Завантажити',
  'custModal.copy': 'Копіювати',
  'custModal.specifyPhoneForDocs': 'Вкажіть телефон для документів',
  'custModal.loading': 'Завантаження...',
  'custModal.error': 'Помилка',
  // Customer modal — month abbreviations
  'custModal.monthJan': 'Січень', 'custModal.monthFeb': 'Лютий', 'custModal.monthMar': 'Березень',
  'custModal.monthApr': 'Квітень', 'custModal.monthMay': 'Травень', 'custModal.monthJun': 'Червень',
  'custModal.monthJul': 'Липень', 'custModal.monthAug': 'Серпень', 'custModal.monthSep': 'Вересень',
  'custModal.monthOct': 'Жовтень', 'custModal.monthNov': 'Листопад', 'custModal.monthDec': 'Грудень',
  'custModal.monthAbbrJan': 'Січ', 'custModal.monthAbbrFeb': 'Лют', 'custModal.monthAbbrMar': 'Бер',
  'custModal.monthAbbrApr': 'Кві', 'custModal.monthAbbrMay': 'Тра', 'custModal.monthAbbrJun': 'Чер',
  'custModal.monthAbbrJul': 'Лип', 'custModal.monthAbbrAug': 'Сер', 'custModal.monthAbbrSep': 'Вер',
  'custModal.monthAbbrOct': 'Жов', 'custModal.monthAbbrNov': 'Лис', 'custModal.monthAbbrDec': 'Гру',
  'custModal.monthShortJan': 'Січ', 'custModal.monthShortFeb': 'Лют', 'custModal.monthShortMar': 'Бер',
  'custModal.monthShortApr': 'Кві', 'custModal.monthShortMay': 'Тра', 'custModal.monthShortJun': 'Чер',
  'custModal.monthShortJul': 'Лип', 'custModal.monthShortAug': 'Сер', 'custModal.monthShortSep': 'Вер',
  'custModal.monthShortOct': 'Жов', 'custModal.monthShortNov': 'Лис', 'custModal.monthShortDec': 'Гру',

  // ── Categories page ──
  'categories.title': 'Категорії клієнтів',
  'categories.subtitle': 'Управління категоріями та рівнями важливості',
  'categories.categoriesTab': 'Категорії',
  'categories.importanceTab': 'Важливість',
  'categories.categoriesDesc': 'Групуйте клієнтів за типами',
  'categories.importanceDesc': 'Визначте рівні важливості клієнтів',
  'categories.addCategory': 'Додати категорію',
  'categories.newCategory': 'Нова категорія',
  'categories.editCategory': 'Редагувати категорію',
  'categories.noCategories': 'Категорій ще немає',
  'categories.categoryName': 'Назва категорії',
  'categories.name': 'Назва',
  'categories.namePlaceholder': 'Введіть назву...',
  'categories.nameDuplicate': 'Категорія з такою назвою вже існує',
  'categories.importanceDuplicate': 'Рівень важливості з такою назвою вже існує',
  'categories.icon': 'Іконка',
  'categories.changeIcon': 'Змінити іконку',
  'categories.chooseIcon': 'Оберіть іконку',
  'categories.color': 'Колір',
  'categories.bgColor': 'Колір фону',
  'categories.textColor': 'Колір тексту',
  'categories.borderColor': 'Колір рамки',
  'categories.indicatorColor': 'Колір індикатора',
  'categories.preview': 'Попередній перегляд',
  'categories.save': 'Зберегти',
  'categories.cancel': 'Скасувати',
  'categories.delete': 'Видалити',
  'categories.edit': 'Редагувати',
  'categories.add': 'Додати',
  'categories.confirmDelete': 'Ви впевнені, що хочете видалити?',
  'categories.hasCustomersBlocked': 'Ця категорія має клієнтів і не може бути видалена',
  'categories.yes': 'Так',
  'categories.no': 'Ні',
  'categories.addLevel': 'Додати рівень',
  'categories.newImportanceLevel': 'Новий рівень важливості',
  'categories.editLevel': 'Редагувати рівень',
  'categories.noImportanceLevels': 'Рівнів важливості ще немає',
  'categories.levelName': 'Назва рівня',
  'categories.levelPlaceholder': 'Введіть назву рівня...',
  'categories.iconBusiness': 'Бізнес',
  'categories.iconClients': 'Клієнти',
  'categories.iconNature': 'Природа',
  'categories.iconOther': 'Інше',
  'categories.iconStatus': 'Статус',
  'categories.iconSymbols': 'Символи',

  // ── Staff page ──
  'staff.title': 'Співробітники',
  'staff.subtitle': 'Управління персоналом',
  'staff.addStaff': 'Додати співробітника',
  'staff.searchPlaceholder': "Пошук за ім'ям, посадою, телефоном...",
  'staff.activeStaff': 'Активних',
  'staff.activeStaffDesc': 'співробітників',
  'staff.statusActive': 'Активний (показувати в календарі)',
  'staff.statusActiveHidden': 'Активний (не показувати в календарі)',
  'staff.statusDismissed': 'Звільнений',
  'staff.shown': 'Показано',
  'staff.of': 'із',
  'staff.total': 'всього',
  'staff.notFound': 'Співробітників не знайдено',
  'staff.notFoundHint': 'Спробуйте змінити пошуковий запит',
  'staff.newStaff': 'Новий співробітник',
  'staff.editStaff': 'Редагування співробітника',
  'staff.closeEsc': 'Закрити (Esc)',
  'staff.tabMain': 'Основне',
  'staff.tabDetails': 'Деталі',
  'staff.tabServices': 'Послуги',
  'staff.tabSchedule': 'Розклад',
  'staff.personalData': 'Особисті дані',
  'staff.fullName': "Повне ім'я",
  'staff.fullNamePlaceholder': "Введіть повне ім'я",
  'staff.nameRequired': "Ім'я обов'язкове",
  'staff.nameDuplicate': 'Співробітник з таким іменем вже існує',
  'staff.phoneDuplicate': 'Співробітник з таким телефоном вже існує',
  'staff.phone': 'Телефон',
  'staff.position': 'Посада',
  'staff.positionPlaceholder': 'Введіть посаду...',
  'staff.status': 'Статус',
  'staff.active': 'Активний',
  'staff.profilePhoto': 'Фото профілю',
  'staff.uploadPhoto': 'Завантажити фото',
  'staff.changePhoto': 'Змінити фото',
  'staff.avatar': 'Аватар',
  'staff.avatarColor': 'Колір аватара',
  'staff.birthDate': 'Дата народження',
  'staff.day': 'День',
  'staff.month': 'Місяць',
  'staff.year': 'Рік',
  'staff.address': 'Адреса',
  'staff.addressPlaceholder': 'Введіть адресу...',
  'staff.note': 'Примітка',
  'staff.notePlaceholder': 'Додати примітку...',
  'staff.salaryScheme': 'Схема нарахування',
  'staff.notSelected': 'Не обрано',
  'staff.locations': 'Локації',
  'staff.servicesEmpty': 'Послуг не призначено',
  'staff.servicesHint': 'Оберіть послуги, які надає цей співробітник',
  'staff.priceUah': 'Ціна (грн)',
  'staff.uah': 'грн',
  'staff.min': 'хв',
  'staff.mins': 'хв',
  'staff.workSchedule': 'Розклад роботи',
  'staff.dayOff': 'Вихідний',
  'staff.save': 'Зберегти',
  'staff.saveChanges': 'Зберегти зміни',
  'staff.cancel': 'Скасувати',
  'staff.back': 'Назад',
  'staff.next': 'Далі',
  'staff.add': 'Додати',
  'staff.edit': 'Редагувати',
  'staff.delete': 'Видалити',
  'staff.deleteConfirmTitle': 'Видалити співробітника?',
  'staff.deleteForever': 'Видалити назавжди',
  'staff.hasAppointments': 'Співробітник має записи і не може бути видалений',
  'staff.deleteError': 'Не вдалося видалити співробітника',
  'staff.understood': 'Зрозуміло',
  'staff.scheduleConflict': 'Конфлікт розкладу',
  'staff.dayMon': 'Пн', 'staff.dayTue': 'Вт', 'staff.dayWed': 'Ср',
  'staff.dayThu': 'Чт', 'staff.dayFri': 'Пт', 'staff.daySat': 'Сб', 'staff.daySun': 'Нд',
  'staff.monthJan': 'Січень', 'staff.monthFeb': 'Лютий', 'staff.monthMar': 'Березень',
  'staff.monthApr': 'Квітень', 'staff.monthMay': 'Травень', 'staff.monthJun': 'Червень',
  'staff.monthJul': 'Липень', 'staff.monthAug': 'Серпень', 'staff.monthSep': 'Вересень',
  'staff.monthOct': 'Жовтень', 'staff.monthNov': 'Листопад', 'staff.monthDec': 'Грудень',

  // ── Schedule page ──
  'schedule.title': 'Розклад роботи',
  'schedule.subtitle': 'Управління графіком роботи співробітників',
  'schedule.active': 'Активних',
  'schedule.inactive': 'Неактивних',
  'schedule.staffMember': 'Співробітник',
  'schedule.hrsPerWeek': 'Год/тиж',
  'schedule.prevWeek': '← Попередній тиждень',
  'schedule.nextWeek': 'Наступний тиждень →',
  'schedule.current': 'Поточний',
  'schedule.working': 'Працює',
  'schedule.dayOff': 'Вихідний',
  'schedule.noActiveStaff': 'Немає активних співробітників',
  'schedule.noActiveStaffHint': 'Додайте співробітників у розділі "Персонал"',
  'schedule.scheduleSettings': 'Налаштування розкладу',
  'schedule.dayType': 'Тип дня',
  'schedule.workDay': 'Робочий день',
  'schedule.workHours': 'Робочі години',
  'schedule.breaks': 'Перерви',
  'schedule.noBreaks': 'Немає перерв',
  'schedule.oneBreak': '1 перерва',
  'schedule.nBreaks': 'перерв',
  'schedule.addBreak': 'Додати перерву',
  'schedule.deleteBreak': 'Видалити перерву',
  'schedule.save': 'Зберегти',
  'schedule.cancel': 'Скасувати',
  'schedule.apply': 'Застосувати',
  'schedule.vacation': 'Відпустка',
  'schedule.sickLeave': 'Лікарняний',
  'schedule.repeat1': '2 тижні (1 цикл)',
  'schedule.repeatN': '{n} тижнів',
  'schedule.repeatWeekly': 'Щотижня (рік)',
  'schedule.templateAppliedWeeks': 'Шаблон застосовано на {n} тижнів',
  'schedule.scheduleTemplate': 'Шаблон розкладу',
  'schedule.noTemplate': 'Без шаблону',
  'schedule.saveTwoWeeksTemplate': 'Зберегти як шаблон (2 тижні)',
  'schedule.templateDuplicate': 'Шаблон з такою назвою вже існує',
  'schedule.templateNamePlaceholder': 'Назва шаблону...',
  'schedule.scheduleConflict': 'Конфлікт розкладу',
  'schedule.appointmentConflict': 'Неможливо змінити розклад: існує запис на {time} ({count} шт.) у неробочий після оновлення час',
  'schedule.h': 'год',
  'schedule.hrs': 'год',
  'schedule.min': 'хв',
  'schedule.dayMonFull': 'Понеділок', 'schedule.dayTueFull': 'Вівторок', 'schedule.dayWedFull': 'Середа',
  'schedule.dayThuFull': 'Четвер', 'schedule.dayFriFull': "П'ятниця", 'schedule.daySatFull': 'Субота', 'schedule.daySunFull': 'Неділя',
  'schedule.dayMon': 'Пн', 'schedule.dayTue': 'Вт', 'schedule.dayWed': 'Ср',
  'schedule.dayThu': 'Чт', 'schedule.dayFri': 'Пт', 'schedule.daySat': 'Сб', 'schedule.daySun': 'Нд',

  // ── Schedule templates page ──
  'schedTpl.title': 'Шаблони розкладів',
  'schedTpl.subtitle': 'Створюйте та керуйте шаблонами робочих графіків',
  'schedTpl.templates': 'Шаблонів',
  'schedTpl.newTemplate': 'Новий шаблон',
  'schedTpl.noTemplates': 'Шаблонів ще немає',
  'schedTpl.noTemplatesHint': 'Створіть шаблон розкладу для швидкого застосування',
  'schedTpl.templateSettings': 'Налаштування шаблону',
  'schedTpl.templateNamePlaceholder': 'Назва шаблону...',
  'schedTpl.dayType': 'Тип дня',
  'schedTpl.workDay': 'Робочий день',
  'schedTpl.dayOff': 'Вихідний',
  'schedTpl.vacation': 'Відпустка',
  'schedTpl.sickLeave': 'Лікарняний',
  'schedTpl.workHours': 'Робочі години',
  'schedTpl.breaks': 'Перерви',
  'schedTpl.noBreaks': 'Немає перерв',
  'schedTpl.addBreak': 'Додати перерву',
  'schedTpl.save': 'Зберегти',
  'schedTpl.cancel': 'Скасувати',
  'schedTpl.create': 'Створити',
  'schedTpl.delete': 'Видалити',
  'schedTpl.rename': 'Перейменувати',
  'schedTpl.deleteTitle': 'Видалити шаблон?',
  'schedTpl.deleteMessage': 'Ви збираєтесь видалити цей шаблон. Цю дію неможливо скасувати.',
  'schedTpl.hPerWeek': 'год/тиж',
  'schedTpl.hrs': 'год',
  'schedTpl.min': 'хв',
  'schedTpl.workShort': 'Роб',
  'schedTpl.offShort': 'Вих',
  'schedTpl.week1': 'Тиждень 1',
  'schedTpl.week2': 'Тиждень 2',
  'schedTpl.dayMonFull': 'Понеділок', 'schedTpl.dayTueFull': 'Вівторок', 'schedTpl.dayWedFull': 'Середа',
  'schedTpl.dayThuFull': 'Четвер', 'schedTpl.dayFriFull': "П'ятниця", 'schedTpl.daySatFull': 'Субота', 'schedTpl.daySunFull': 'Неділя',
  'schedTpl.dayMon': 'Пн', 'schedTpl.dayTue': 'Вт', 'schedTpl.dayWed': 'Ср',
  'schedTpl.dayThu': 'Чт', 'schedTpl.dayFri': 'Пт', 'schedTpl.daySat': 'Сб', 'schedTpl.daySun': 'Нд',

  // ── Services page ──
  'services.title': 'Послуги',
  'services.subtitle': 'Каталог послуг',
  'services.servicesCount': 'Послуг',
  'services.groups': 'Груп',
  'services.addService': 'Додати послугу',
  'services.newGroup': 'Нова група',
  'services.emptyCatalog': 'Каталог послуг порожній',
  'services.emptyCatalogHint': 'Додайте групу та послуги',
  'services.noServicesInGroup': 'У цій групі немає послуг',
  'services.serviceName': 'Назва послуги',
  'services.durationMin': 'Тривалість (хв)',
  'services.durationMinError': 'Тривалість має бути більше 0',
  'services.priceUah': 'Ціна (грн)',
  'services.priceNegativeError': 'Ціна не може бути від\'ємною',
  'services.nameDuplicate': 'Послуга з такою назвою вже існує',
  'services.groupDuplicate': 'Група з такою назвою вже існує',
  'services.min': 'хв',
  'services.uah': 'грн',
  'services.save': 'Зберегти',
  'services.cancel': 'Скасувати',
  'services.edit': 'Редагувати',
  'services.delete': 'Видалити',
  'services.renameGroup': 'Перейменувати групу',
  'services.deleteGroup': 'Видалити групу',
  'services.deleteGroupTitle': 'Видалити групу?',
  'services.deleteGroupMessage': 'Всі послуги в цій групі також будуть видалені.',
  'services.deleteServiceTitle': 'Видалити послугу?',
  'services.deleteServiceMessage': 'Цю дію неможливо скасувати.',
  'services.cannotDelete': 'Неможливо видалити',
  'services.serviceHasAppointments': 'Ця послуга має записи і не може бути видалена',
  'services.groupHasAppointments': 'Ця група має послуги з записами і не може бути видалена',
  'services.cannotDeleteGroupHasServices': 'Спочатку перенесіть або видаліть послуги з цієї групи',
  'services.deleteError': 'Помилка видалення',
  'services.understood': 'Зрозуміло',

  // ── Tariff plans page ──
  'tariffs.title': 'Тарифні плани',
  'tariffs.subtitle': 'Управління тарифними планами',
  'tariffs.tariffsCount': 'Тарифів',
  'tariffs.addTariff': 'Додати тариф',
  'tariffs.noTariffs': 'Тарифних планів немає',
  'tariffs.newTariffPlan': 'Новий тарифний план',
  'tariffs.editTariff': 'Редагувати тариф',
  'tariffs.tariffName': 'Назва тарифу',
  'tariffs.tariffNamePlaceholder': 'Введіть назву тарифу...',
  'tariffs.nameDuplicate': 'Тариф з такою назвою вже існує',
  'tariffs.tariffType': 'Тип тарифу',
  'tariffs.discount': 'Знижка',
  'tariffs.surcharge': 'Надбавка',
  'tariffs.noChange': 'Без змін',
  'tariffs.priceModifierPercent': 'Модифікатор ціни (%)',
  'tariffs.percentModifier': '% модифікатор',
  'tariffs.modifier': 'Модифікатор',
  'tariffs.modifierHint': 'Від\'ємне значення — знижка, додатне — надбавка',
  'tariffs.modifierPlaceholder': 'Наприклад: -10 або +15',
  'tariffs.activeCheckbox': 'Активний',
  'tariffs.active': 'Активний',
  'tariffs.inactive': 'Неактивний',
  'tariffs.tabServices': 'Послуги',
  'tariffs.tabProducts': 'Товари',
  'tariffs.servicePrices': 'Ціни на послуги',
  'tariffs.customPriceServices': 'Індивідуальні ціни на послуги',
  'tariffs.customPriceProducts': 'Індивідуальні ціни на товари: {n}',
  'tariffs.productPrices': 'Ціни на товари',
  'tariffs.productPricesHint': 'Знайдіть та додайте товари, щоб встановити акційну ціну',
  'tariffs.searchProduct': 'Пошук товару за назвою або артикулом...',
  'tariffs.noCategory': 'Без категорії',
  'tariffs.priceList': 'Прайс-лист',
  'tariffs.leaveEmptyDefault': 'Залиште порожнім для стандартної ціни',
  'tariffs.uah': 'грн',
  'tariffs.save': 'Зберегти',
  'tariffs.create': 'Створити',
  'tariffs.cancel': 'Скасувати',
  'tariffs.edit': 'Редагувати',
  'tariffs.delete': 'Видалити',
  'tariffs.deleteConfirm': 'Ви впевнені, що хочете видалити цей тариф?',
  'tariffs.cannotDelete': 'Неможливо видалити тариф',
  'tariffs.appointmentsCount': 'записів',
  'tariffs.ordersCount': 'замовлень',
  'tariffs.yes': 'Так',
  'tariffs.no': 'Ні',

  // ── Finances page ──
  'fin.title': 'Фінансові операції',
  'fin.subtitle': 'Журнал оплат та повернень',
  'fin.searchPlaceholder': "Пошук за клієнтом, телефоном, послугою...",
  'fin.period': 'Період',
  'fin.today': 'Сьогодні',
  'fin.week': 'Тиждень',
  'fin.month': 'Місяць',
  'fin.from': 'від',
  'fin.to': 'до',
  'fin.allTime': 'Весь час',
  'fin.typeLabel': 'Тип',
  'fin.all': 'Всі',
  'fin.payments': 'Оплати',
  'fin.refunds': 'Повернення',
  'fin.type_all': 'Всі',
  'fin.type_payment': 'Оплата',
  'fin.type_refund': 'Повернення',
  'fin.type_product_sale': 'Продаж товару',
  'fin.methodLabel': 'Метод оплати',
  'fin.cash': 'Готівка',
  'fin.terminal': 'Термінал',
  'fin.transfer': 'Переказ',
  'fin.online': 'Онлайн',
  'fin.subscription': 'Абонемент',
  'fin.total': 'Всього',
  'fin.uah': 'грн',
  'fin.exportExcel': 'Експорт Excel',
  'fin.exportFileName': 'Фінансові_операції',
  'fin.noOperations': 'Немає операцій',
  'fin.noOperationsHint': 'Спробуйте змінити фільтри або період',
  'fin.colDate': 'Дата',
  'fin.colClient': 'Клієнт',
  'fin.colPhone': 'Телефон',
  'fin.colService': 'Послуга',
  'fin.colMaster': 'Майстер',
  'fin.colType': 'Тип',
  'fin.colPayMethod': 'Спосіб оплати',
  'fin.colMethod': 'Метод',
  'fin.colAmount': 'Сума',
  'fin.colSum': 'Сума',
  'fin.colAuthor': 'Автор',
  'fin.colReceipt': 'Чек',
  'fin.service': 'Послуга',
  'fin.receipt': 'Чек',
  'fin.receiptNum': 'Чек №',
  'fin.receiptSubtitle': 'Фіскальний чек',
  'fin.receiptDate': 'Дата',
  'fin.receiptClient': 'Клієнт',
  'fin.receiptPhone': 'Телефон',
  'fin.receiptMaster': 'Майстер',
  'fin.receiptMethod': 'Спосіб оплати',
  'fin.receiptTotal': 'Сума',
  'fin.receiptThanks': 'Дякуємо за візит!',
  'fin.printReceipt': 'Друкувати чек',
  'fin.fiscalCode': 'Фіскальний код',
  'fin.noFiscal': 'Без фіскалізації',
  'fin.retryFiscal': 'Повторити фіскалізацію',
  'fin.fiscalRetrySuccess': 'Фіскалізацію повторено успішно',
  'fin.fiscalRetryError': 'Помилка повторної фіскалізації',
  'fin.fiscalMarkNotSaved': 'Чек створено ({code}), але позначку не збережено. Натисніть ще раз — нового чека не буде.',

  // ── Cash register page ──
  'cashReg.title': 'Каса',
  'cashReg.subtitle': 'Управління касовими змінами',
  'cashReg.currentShift': 'Поточна зміна',
  'cashReg.openNewShift': 'Відкрити нову зміну',
  'cashReg.openNewShiftHint': 'Зміна не відкрита. Відкрийте зміну для прийому платежів.',
  'cashReg.openingBalance': 'Початковий залишок',
  'cashReg.openingBalanceLabel': 'Початковий залишок каси',
  'cashReg.openShift': 'Відкрити зміну',
  'cashReg.closeShift': 'Закрити зміну',
  'cashReg.prro': 'ПРРО',
  'cashReg.processing': 'Обробка...',
  'cashReg.opened': 'Відкрита',
  'cashReg.closed': 'Закрита',
  'cashReg.openedAt': 'Відкрита о',
  'cashReg.openBal': 'Відкр. залишок',
  'cashReg.closeBal': 'Закр. залишок',
  'cashReg.revenue': 'Виручка',
  'cashReg.totalRevenue': 'Загальна виручка',
  'cashReg.operations': 'Операцій',
  'cashReg.inRegister': 'В касі',
  'cashReg.cash': 'Готівка',
  'cashReg.terminal': 'Термінал',
  'cashReg.transfer': 'Переказ',
  'cashReg.uah': 'грн',
  'cashReg.shift': 'Зміна',
  'cashReg.shiftLog': 'Журнал змін',
  'cashReg.historyEmpty': 'Історія змін порожня',
  'cashReg.historyEmptyHint': 'Тут з\'являться закриті зміни',
  'cashReg.shiftOpened': 'Зміну відкрито',
  'cashReg.shiftClosed': 'Зміну закрито',
  'cashReg.checkboxNotConfigured': 'Для роботи з касою необхідно налаштувати підключення до Checkbox ПРРО у розділі Налаштування → Checkbox ПРРО',

  // ── Reports page ──
  'reports.reportType_cash_day': 'Виручка за період',
  'reports.reportType_work_hours': 'Робочі години',
  'reports.reportType_services_sales': 'Продажі послуг',
  'reports.reportType_mutual': 'Взаєморозрахунки з клієнтами',
  'reports.reportType_inventory_flow': 'Рух товарів',
  'reports.reportType_client_analytics': 'Аналітика клієнтів',
  'reports.reportType_staff_revenue': 'Виручка по майстрах',
  'reports.reportType_service_profitability': 'Прибутковість послуг',
  'reports.reportType_abc_analysis': 'ABC-аналіз товарів',
  'reports.reportType_revenue_dynamics': 'Динаміка виручки',
  'reports.reportType_discount_analytics': 'Аналітика знижок',
  'reports.reportType_purchases_by_supplier': 'Закупівлі по постачальниках',
  'reports.reportType_purchase_dynamics': 'Динаміка закупівель',
  'reports.reportType_top_purchased_products': 'Топ закуповуваних товарів',
  'reports.reportType_supplier_price_compare': 'Порівняння цін постачальників',
  'reports.reportType_product_turnover': 'Оборотність товарів',
  'reports.reportType_subscriptions': 'Підписки / Абонементи',
  'reports.subsEmpty': 'Немає підписок за обраний період',
  'reports.subsAll': 'Всі',
  'reports.subsActive': 'Активні',
  'reports.subsNearExpiry': 'Близько кінця',
  'reports.subsNearExpiryHint': 'ближче до кінця <14 дн.',
  'reports.subsExpired': 'Прострочені',
  'reports.subsUsedUp': 'Використані',
  'reports.subsRefunded': 'Скасовані',
  'reports.subsRevenue': 'Виручка',
  'reports.subsSold': 'продано',
  'reports.subsUnusedVisits': 'Невикористані візити',
  'reports.subsUnusedHint': 'у активних і прострочених',
  'reports.subsPurchaseDate': 'Дата купівлі',
  'reports.subsPlan': 'Тариф',
  'reports.subsBoughtVisits': 'Куплено',
  'reports.subsUsage': 'Використання',
  'reports.subsPaid': 'Сплачено',
  'reports.subsValidUntil': 'Дійсна до',
  'reports.subsStatus': 'Статус',
  'reports.reportType_no_shows': 'Аналітика no-show',
  'reports.nsEmpty': 'Немає записів за обраний період',
  'reports.nsTotal': 'Всього записів',
  'reports.nsNoShow': 'No-show',
  'reports.nsCancelled': 'Скасовано',
  'reports.nsLostRevenue': 'Втрачена виручка',
  'reports.nsRepeatOffenders': 'Хронічні (≥2 no-show)',
  'reports.nsByStaff': 'По майстрах',
  'reports.nsByService': 'По послугах (топ-15 проблемних)',
  'reports.nsNoShowPct': 'No-show %',
  'reports.nsCancelPct': 'Cancel %',
  'reports.nsRepeatOffendersTitle': 'Хронічні зривники',
  'reports.nsRepeatOffendersHint': '≥2 no-show за період',
  'reports.nsLastNoShow': 'Останній no-show',
  'reports.reportType_service_profitability': 'Прибутковість послуг',
  'reports.reportType_payment_methods': 'Методи оплати',
  'reports.reportType_sales_by_channel': 'Продажі по каналах',
  'reports.reportType_customer_ltv': 'LTV / VIP клієнти',
  'reports.profitEmpty': 'Немає послуг за обраний період',
  'reports.profitRevenue': 'Виручка',
  'reports.profitCost': 'Собівартість',
  'reports.profitGross': 'Прибуток',
  'reports.profitMargin': 'Маржа',
  'reports.profitVisits': 'Візитів',
  'reports.group': 'Група',
  'reports.visits': 'Візитів',
  'reports.pmEmpty': 'Немає транзакцій за обраний період',
  'reports.tryChangeDate': 'Спробуйте змінити період',
  'reports.pmMethod': 'Метод',
  'reports.pmCount': 'Транзакцій',
  'reports.pmAmount': 'Сума',
  'reports.pmShare': 'Частка',
  'reports.pmTotalTx': 'Транзакцій',
  'reports.pmMethodsCount': 'Методів використано',
  'reports.pmCash': 'Готівка',
  'reports.pmTerminal': 'Термінал',
  'reports.pmOnline': 'Онлайн',
  'reports.pmTransfer': 'Переказ',
  'reports.pmSubscription': 'Підписка',
  'reports.pmGiftCard': 'Подарункова картка',
  'reports.pmPoints': 'Бонуси',
  'reports.pmUnknown': 'Не вказано',
  'reports.ltvEmpty': 'Немає клієнтів за обраний період',
  'reports.ltvCustomers': 'Клієнтів',
  'reports.ltvTotalRevenue': 'Загальна виручка',
  'reports.ltvAvgTicket': 'Середній чек',
  'reports.ltvVip': 'VIP-клієнтів (top 20%)',
  'reports.ltvSleepingVip': 'Сплячі VIP',
  'reports.ltvSleepingHint': '>60 днів без візиту',
  'reports.ltvTotal': 'Сума',
  'reports.ltvLastVisit': 'Останній візит',
  'reports.ltvSleepingBadge': '😴 Сплячий VIP',
  'reports.ltvVipBadge': '👑 VIP',
  'reports.reportType_salary_archive': 'Архів зарплат',
  'reports.reportType_salary_efficiency': 'Ефективність персоналу (ROI)',
  'reports.reportType_salary_ratio': 'Індекс ЗП до виручки',
  'reports.salaryArchiveEmpty': 'Поки немає збережених зарплатних розрахунків',
  'reports.salaryArchiveEmptyHint': 'Розрахуй ЗП у блоці "Розрахунок зарплат" — і вона з\'явиться тут.',
  'reports.salaryArchiveMonth': 'Місяць',
  'reports.salaryArchiveSavedAt': 'Збережено',
  'reports.salaryFund': 'Загальний фонд',
  'reports.salaryStaffCount': 'Працівників',
  'reports.salaryAvg': 'У середньому',
  'reports.salaryRevenue': 'Виручка місяця',
  'reports.salaryScheme': 'Схема',
  'reports.salaryByRules': 'За правилами',
  'reports.salaryAdjustments': 'Корекції',
  'reports.salaryEffEmpty': 'Немає розрахованих ЗП за обраний період',
  'reports.salaryEffEmptyHint': 'Спробуй обрати період коли ЗП уже розраховані.',
  'reports.salaryEffRevenue': 'Виручка',
  'reports.salaryEffSalary': 'ЗП',
  'reports.salaryEffProfit': 'Маржа',
  'reports.salaryEffAvgRoi': 'Середній ROI',
  'reports.salaryEffRoiHint': '>3 здоровий, <1.5 проблема',
  'reports.salaryRatioEmpty': 'Поки немає історії зарплат',
  'reports.salaryRatioCurrent': 'Поточний індекс',
  'reports.salaryRatioAvg': 'Середнє за період',
  'reports.salaryRatioTrend': 'Зміна vs попередній місяць',
  'reports.salaryRatioHealthy': 'Здоровий діапазон',
  'reports.salaryRatioHealthyHint': 'для б\'юті бізнесу',
  'reports.salaryRatioPct': 'Індекс',
  'reports.loading': 'Завантаження…',
  'reports.reportType_sales_managers': 'Менеджери з продажу товарів',
  'reports.smEmpty': 'Немає замовлень за обраний період',
  'reports.smUnknown': '— Без вказаного',
  'reports.smManagersCount': 'Менеджерів',
  'reports.smOrdersCreated': 'Створено замовлень',
  'reports.smDelivered': 'Доставлено',
  'reports.smNetRevenue': 'Виручка нетто',
  'reports.smAvgCheck': 'Середній чек',
  'reports.smManager': 'Менеджер',
  'reports.smCreated': 'Створив',
  'reports.smCancelled': 'Скасовано',
  'reports.smReturned': 'Повернень',
  'reports.smCancelRate': 'Cancel %',
  'reports.smReturnRate': 'Return %',
  'reports.smAvgTime': 'Дн. до доставки',
  'reports.reportType_admin_activity': 'Активність адміністраторів',
  'reports.aaEmpty': 'Немає активності з createdBy за обраний період',
  'reports.aaAdmins': 'Активних адмінів',
  'reports.aaTotalApts': 'Створено записів',
  'reports.aaTotalProcessed': 'Оброблено грошей',
  'reports.aaSubsRevenue': 'Виручка з підписок',
  'reports.aaAdmin': 'Адмін',
  'reports.aaApts': 'Записів',
  'reports.aaConfirmed': 'Підтв.',
  'reports.aaNoShowPct': 'No-show %',
  'reports.aaTx': 'Tx',
  'reports.aaProcessed': 'Сума',
  'reports.aaSubsSold': 'Підп.',
  'reports.aaSubsRev': 'Підп. ₴',
  'reports.aaDiscounts': 'Знижок ₴',
  'reports.groupSales': 'Виручка та продажі',
  'reports.groupCustomers': 'Клієнти',
  'reports.groupStaff': 'Персонал та зарплати',
  'reports.groupLoyalty': 'Лояльність та акції',
  'reports.groupInventory': 'Склад і товари',
  'reports.groupProcurement': 'Закупівлі',
  'reports.reportType_loyalty_points': 'Бонусна програма',
  'reports.reportType_coupons': 'Купони',
  'reports.lpEmpty': 'Немає бонусних операцій за обраний період',
  'reports.lpEarned': 'Нараховано',
  'reports.lpRedeemed': 'Витрачено',
  'reports.lpReversed': 'Сторновано',
  'reports.lpReversedHint': 'повернення / скасування',
  'reports.lpNet': 'Чисто за період',
  'reports.lpSourcesTitle': 'Звідки бали (нарахування)',
  'reports.lpSource': 'Джерело',
  'reports.lpPoints': 'Балів',
  'reports.lpShare': 'Частка',
  'reports.lpRefService': 'За послуги',
  'reports.lpRefProduct': 'За товари',
  'reports.lpRefOrder': 'За замовлення',
  'reports.lpRefReferral': 'Реферали',
  'reports.lpRefBirthday': 'День народження',
  'reports.lpRefManual': 'Ручне нарахування',
  'reports.lpRefSubscription': 'За підписку',
  'reports.lpRefOther': 'Інше',
  'reports.cpEmpty': 'У вас поки немає купонів',
  'reports.cpEmptyHint': 'Додайте купони у Лояльності, щоб побачити статистику тут.',
  'reports.cpTotal': 'Усього купонів',
  'reports.cpUsedInPeriod': 'Використано за період',
  'reports.cpDiscount': 'Дано знижок',
  'reports.cpOrderAmount': 'Виручка по купонах',
  'reports.cpCode': 'Код',
  'reports.cpType': 'Тип',
  'reports.cpValue': 'Знижка',
  'reports.cpUsage': 'Викор.',
  'reports.cpInPeriod': 'У періоді',
  'reports.cpOrderSum': 'Виручка ₴',
  'reports.cpStatus': 'Статус',
  'reports.cpStatusActive': 'Активний',
  'reports.cpStatusExpired': 'Прострочений',
  'reports.cpStatusExhausted': 'Вичерпаний',
  'reports.cpStatusDisabled': 'Вимкнений',
  'reports.reportType_production_runs': 'Виробничі запуски',
  'reports.reportType_cash_shifts_report': 'Касові зміни',
  'reports.reportType_heatmap_dow_hour': 'Heatmap день × година',
  'reports.prEmpty': 'Немає виробничих запусків за обраний період',
  'reports.prRuns': 'Запусків',
  'reports.prCancelled': 'скасовано',
  'reports.prOutputQty': 'Вихідна кількість',
  'reports.prInputCost': 'Витрачено матеріалу',
  'reports.prAvgUnitCost': 'Сер. собівартість од.',
  'reports.prRecipe': 'Рецепт',
  'reports.csEmpty': 'Немає касових змін за обраний період',
  'reports.csEmptyHint': 'Касові зміни синхронізуються з Checkbox.',
  'reports.csShifts': 'Змін',
  'reports.csCash': 'Готівка',
  'reports.csCard': 'Картка',
  'reports.csAvgDuration': 'Сер. тривалість',
  'reports.csDiscrep': 'З розбіжностями',
  'reports.csOpened': 'Відкрито',
  'reports.csClosed': 'Закрито',
  'reports.csLocation': 'Локація',
  'reports.csOpenBal': 'Старт ₴',
  'reports.csCloseBal': 'Закр. ₴',
  'reports.csDiff': 'Δ',
  'reports.csOpen': 'Відкрита',
  'reports.hmEmpty': 'Немає записів за обраний період',
  'reports.hmTotal': 'Усього записів',
  'reports.hmPeak': 'Пікова година',
  'reports.hmTopDay': 'Топ-день',
  'reports.hmRecords': 'записів',
  'reports.hmLow': 'Низько',
  'reports.hmMedium': 'Середньо',
  'reports.hmHigh': 'Високо',
  'reports.hmPeakLegend': 'Пік',
  'reports.dowMon': 'Пн',
  'reports.dowTue': 'Вт',
  'reports.dowWed': 'Ср',
  'reports.dowThu': 'Чт',
  'reports.dowFri': 'Пт',
  'reports.dowSat': 'Сб',
  'reports.dowSun': 'Нд',
  'reports.period_day': 'День',
  'reports.period_week': 'Тиждень',
  'reports.period_month': 'Місяць',
  'reports.period_year': 'Рік',
  'reports.period_custom': 'Довільний',
  'period.today': 'Сьогодні',
  'period.yesterday': 'Вчора',
  'period.thisWeek': 'Цей тиждень',
  'period.lastWeek': 'Минулий тиждень',
  'period.thisMonth': 'Цей місяць',
  'period.lastMonth': 'Минулий місяць',
  'period.thisQuarter': 'Цей квартал',
  'period.thisYear': 'Цей рік',
  'period.last30': 'Останні 30 днів',
  'period.last90': 'Останні 90 днів',
  'period.custom': 'Довільний',
  'reports.title': 'Звіти',
  'reports.subtitle': 'Аналітика та звітність',
  'reports.allStaff': 'Всі співробітники',
  'reports.allClients': 'Всі клієнти',
  'reports.allCategories': 'Всі категорії',
  'reports.allProducts': 'Всі товари',
  'reports.allLocations': 'Всі локації',
  'reports.appointments': 'Записи',
  'reports.clients': 'Клієнти',
  'reports.masters': 'Майстри',
  'reports.revenue': 'Виручка',
  'reports.service': 'Послуга',
  'reports.serviceOrProduct': 'Товар/Послуга',
  'reports.client': 'Клієнт',
  'reports.master': 'Майстер',
  'reports.date': 'Дата',
  'reports.dateTime': 'Дата/час',
  'reports.time': 'Час',
  'reports.duration': 'Тривалість',
  'reports.price': 'Ціна',
  'reports.discount': 'Знижка',
  'reports.paid': 'Оплачено',
  'reports.payment': 'Оплата',
  'reports.method': 'Метод',
  'reports.cash': 'Готівка',
  'reports.online': 'Онлайн',
  'reports.total': 'Всього',
  'reports.grandTotal': 'Загалом',
  'reports.sum': 'Сума',
  'reports.position': 'Позиція',
  'reports.positions': 'позицій',
  'reports.product': 'Товар',
  'reports.category': 'Категорія',
  'reports.qty': 'К-сть',
  'reports.pcs': 'шт',
  'reports.cost': 'Собівартість',
  'reports.balance': 'Баланс',
  'reports.debt': 'Борг',
  'reports.charges': 'Нарахування',
  'reports.productCharges': 'Нарахування за товари',
  'reports.serviceRefunds': 'Повернення за послуги',
  'reports.subscriptionVisit': 'Візит по абонементу',
  'reports.charged': 'Нараховано',
  'reports.visits': 'Візити',
  'reports.days': 'дн.',
  'reports.hrs': 'год',
  'reports.min': 'хв',
  'reports.avgCheck': 'Сер. чек',
  'reports.avgDuration': 'Сер. тривалість',
  'reports.totalClients': 'Всього клієнтів',
  'reports.totalHours': 'Всього годин',
  'reports.servicesSold': 'Послуг надано',
  'reports.withDiscount': 'Зі знижкою',
  'reports.utilization': 'Завантаженість',
  'reports.worked': 'Відпрацьовано',
  'reports.workingHours': 'Робочих годин',
  'reports.noVisitDays': 'Днів без візиту',
  'reports.forOrder': 'Для замовлення',
  'reports.mainRegister': 'Основна каса',
  'reports.settlementAccount': 'Розрахунковий рахунок',
  'reports.other': 'Інше',
  'reports.incoming': 'Надходження',
  'reports.incomingQty': 'К-сть надходжень',
  'reports.incomingSum': 'Сума надходжень',
  'reports.incomings': 'Надходження',
  'reports.writeoff': 'Списання',
  'reports.writeoffsExpenses': 'Списання/витрати',
  'reports.writtenOff': 'Списано',
  'reports.writtenOffQty': 'К-сть списань',
  'reports.writtenOffSum': 'Сума списань',
  'reports.remainQty': 'К-сть залишок',
  'reports.remainSum': 'Сума залишок',
  'reports.transferMove': 'Переміщення',
  'reports.together': 'Разом',
  'reports.subscriptionPurchase': 'Покупка абонементу',
  'reports.exportExcel': 'Завантажити в Excel',
  'reports.exportPdf': 'Друк / PDF',
  'reports.print': 'Друк',
  'reports.noService': 'Без послуги',
  'reports.noDataForPeriod': 'Немає даних за обраний період',
  'reports.noCompletedForPeriod': 'Немає завершених записів за обраний період',
  'reports.noRecordsForPeriod': 'Немає записів за обраний період',
  'reports.noInventoryForPeriod': 'Немає даних по складу за обраний період',
  'reports.segment_all': 'Всі',
  'reports.segment_no30': 'Не були 30+ днів',
  'reports.segment_new': 'Нові',
  'reports.segment_vip': 'VIP',
  'reports.segment_once': 'Були один раз',
  'reports.segment_services_only': 'Тільки послуги',
  'reports.segment_products_only': 'Тільки товари',
  'reports.ordersCol': 'Замовл.',
  'reports.productContactsCol': 'Зам. на тов.',
  'reports.serviceContactsCol': 'Зам. на посл.',
  'reports.servicesIncome': 'Послуги ₴',
  'reports.productsIncome': 'Товари ₴',
  'reports.lastContact': 'Ост. контакт',
  'reports.operations': 'Операцій',
  'reports.noClientsInSegment': 'Немає клієнтів у цьому сегменті',
  'reports.tryChangeDateOrStaff': 'Спробуйте змінити дату або співробітника',
  'reports.tryChangeDateOrFilters': 'Спробуйте змінити дату або фільтри',
  'reports.tryChangeDateOrClient': 'Спробуйте змінити дату або клієнта',
  'reports.servicesRevenue': 'Виручка з послуг',
  'reports.productSales': 'Продаж товарів',
  'reports.totalRevenue': 'Загальна виручка',
  'reports.share': 'Частка',
  'reports.materialCosts': 'Витрати на матеріали',
  'reports.margin': 'Маржа',
  'reports.abcClass': 'Клас',
  'reports.abcLeaders': 'лідери',
  'reports.abcMiddle': 'середні',
  'reports.abcSlow': 'аутсайдери',
  'reports.avgPerDay': 'Сер. за день',
  'reports.discountCount': 'К-сть знижок',
  'reports.discountSum': 'Сума знижок',
  'reports.discountShare': 'Частка знижок',
  'reports.noDiscountsForPeriod': 'Немає знижок за обраний період',
  'reports.grossPrice': 'Без знижки',
  'reports.avgDiscount': 'Сер. знижка',
  'reports.supplier': 'Постачальник',
  'reports.allSuppliers': 'Всі постачальники',
  'reports.suppliersCount': 'Постачальників',
  'reports.invoices': 'Накладних',
  'reports.returns': 'Поверн.',
  'reports.returnToSupplier': 'Повернення',
  'reports.invoice': 'Накладна',
  'reports.avgPrice': 'Сер. ціна',
  'reports.noPurchasesForPeriod': 'Немає закупівель за обраний період',
  'reports.productUnits': 'Одиниць товару',
  'reports.invoiceCount': 'К-сть накладних',
  'reports.netto': 'Нетто',
  'reports.peakDay': 'Пік',
  'reports.purchases': 'Закупівлі',
  'reports.categories': 'Категорій',
  'reports.remainder': 'Залишок',
  'reports.ordered': 'Замовлено',
  'reports.returned': 'Повернуто',
  'reports.received': 'Одержано',
  'reports.productsCompared': 'Товарів порівняно',
  'reports.noPriceComparison': 'Немає даних для порівняння',
  'reports.needMultipleSuppliers': 'Потрібні закупівлі одного товару у різних постачальників',
  'reports.turnoverRatio': 'Оборотність',
  'reports.turnoverStatus': 'Статус',
  'reports.highTurnover': 'Висока',
  'reports.medTurnover': 'Середня',
  'reports.lowTurnover': 'Низька',

  // ── Financial result page ──
  'finResult.month_jan': 'Січень', 'finResult.month_feb': 'Лютий', 'finResult.month_mar': 'Березень',
  'finResult.month_apr': 'Квітень', 'finResult.month_may': 'Травень', 'finResult.month_jun': 'Червень',
  'finResult.month_jul': 'Липень', 'finResult.month_aug': 'Серпень', 'finResult.month_sep': 'Вересень',
  'finResult.month_oct': 'Жовтень', 'finResult.month_nov': 'Листопад', 'finResult.month_dec': 'Грудень',
  'finResult.sourceDeleted': 'Цей документ було вилучено з системи',
  'finResult.title': 'Фінансовий результат',
  'finResult.subtitle': 'Аналіз доходів та витрат',
  'finResult.allLocations': 'Всі локації',
  'finResult.income': 'Дохід',
  'finResult.incomes': 'Доходи',
  'finResult.expenses': 'Витрати',
  'finResult.financialResult': 'Фінансовий результат',
  'finResult.profitability': 'Рентабельність',
  'finResult.sales': 'Продажі',
  'finResult.servicesCompleted': 'Послуг надано',
  'finResult.productSales': 'Продаж товарів',
  'finResult.orderProductSales': 'Продаж товарів на відгрузку',
  'finResult.posProductSales': 'Продаж товарів через власні магазини',
  'finResult.aptProductSales': 'Продаж товарів в послугах',
  'finResult.subscriptions': 'Абонементи',
  'finResult.refunds': 'поверн.',
  'finResult.cogsOrders': 'Собівартість товарів на відгрузку',
  'finResult.cogsAppointments': 'Собівартість товарів в послугах',
  'finResult.cogsPos': 'Собівартість товарів через власні магазини',
  'finResult.cogsWriteoffs': 'Собівартість інших списань',
  'finResult.orders': 'Замовлень',
  'finResult.visits': 'Візитів',
  'finResult.salaries': 'Зарплати',
  'finResult.addExpense': 'Додати витрату',
  'finResult.otherIncome': 'Інші доходи',
  'finResult.addOtherIncome': 'Додати інший дохід',
  'finResult.incomeName': 'Назва доходу',
  'finResult.deleteIncomeConfirm': 'Видалити цей дохід?',
  'finResult.exportExcel': 'Експорт у Excel',
  'finResult.add': 'Додати',
  'finResult.cancel': 'Скасувати',
  'finResult.delete': 'Видалити',
  'finResult.expenseName': 'Назва витрати',
  'finResult.expenseSum': 'Сума',
  'finResult.monthly': 'Щомісячно',
  'finResult.monthlyOption': 'Щомісячна',
  'finResult.oneTime': 'Одноразова',
  'finResult.oneTimeOption': 'Одноразова',
  'finResult.deleteExpenseTitle': 'Видалити витрату?',
  'finResult.deleteExpenseConfirm': 'Ви впевнені, що хочете видалити цю витрату?',
  'finResult.notCalculated': 'Не розраховано',
  'finResult.print': 'Друк',
  'finResult.printPdf': 'Друк PDF',
  'finResult.dynamics6months': 'Динаміка за 6 місяців',
  'finResult.expenseStructure': 'Структура витрат',
  'finResult.incomeStructure': 'Структура доходів',
  'finResult.donutServices': 'Послуги',
  'finResult.donutProducts': 'Товари',
  'finResult.noIncomeYet': 'Доходів у цьому місяці ще немає',
  'finResult.salaryFundTitle': 'Структура зарплатного фонду',
  'finResult.salaryNotCalculated': 'Зарплати за цей місяць ще не розраховані',
  'finResult.salaryNoData': 'Немає даних для відображення',
  'finResult.fundSalary': 'Окладна',
  'finResult.fundPercent': 'Відсоткова',
  'finResult.fundHybrid': 'Гібридна',
  'finResult.vsPrev': 'до пр. міс.',
  'finResult.cashFlowTitle': 'Грошовий потік (за днями)',
  'finResult.cashFlowEmpty': 'У цьому місяці поки немає транзакцій',
  'finResult.cashFlowReceipts': 'Надходження',
  'finResult.cashFlowRefunds': 'Повернення',
  'finResult.cashFlowNet': 'Чистий потік',
  'finResult.groupCogsProducts': 'Собівартість товарів',
  'finResult.groupSalaries': 'Заробітна плата',
  'finResult.groupFixed': 'Постійні затрати',
  'finResult.groupOther': 'Списання та інші',
  'finResult.noExpensesYet': 'Витрат у цьому місяці ще немає',
  'finResult.effectiveFrom': 'Діє з',
  'finResult.edit': 'Редагувати',
  'finResult.save': 'Зберегти',
  'finResult.applyForwardOnly': 'Застосувати лише з вказаного місяця і далі (зберегти стару суму для попередніх періодів)',
  'finResult.total': 'Всього',
  'finResult.hintAddNew': 'Витрата діятиме з {month} і далі (поки не зміниш).',
  'finResult.hintMutateSingle': 'Сума буде оновлена для: {month}',
  'finResult.hintMutateRange': 'Сума буде оновлена для: {from} — {to}',
  'finResult.hintMutateForward': 'Сума буде оновлена для: {month} і всіх наступних місяців',
  'finResult.hintSplit': 'Створиться нова версія з {newMonth}. Минулі місяці ({oldFrom} — {oldTo}) залишаться {oldAmount} ₴.',

  // ── Inventory products page ──
  'invProd.title': 'Номенклатура',
  'invProd.subtitle': 'Управління товарами, категоріями та складами',
  'invProd.tabProducts': 'Товари',
  'invProd.tabCategories': 'Категорії',
  'invProd.tabWarehouses': 'Склади',
  'invProd.statProducts': 'Товарів',
  'invProd.statCategories': 'Категорій',
  'invProd.statWarehouses': 'Складів',
  'invProd.productsCount': 'Товарів',
  'invProd.positionsCount': 'Позицій',
  'invProd.searchPlaceholder': 'Пошук за назвою, артикулом...',
  'invProd.allCategories': 'Всі категорії',
  'invProd.addProduct': 'Додати товар',
  'invProd.newProduct': 'Новий товар',
  'invProd.editProduct': 'Редагувати товар',
  'invProd.emptyProducts': 'Товарів ще немає',
  'invProd.emptyProductsHint': 'Додайте перший товар',
  'invProd.emptyCategories': 'Створіть свою першу категорію товарів',
  'invProd.emptyCategoriesHint': 'Категорії допоможуть організувати товари та швидко знаходити потрібне',
  'invProd.emptyWarehouses': 'Додайте свій перший склад',
  'invProd.emptyWarehousesHint': 'Склади потрібні для обліку залишків та проведення закупівель',
  'invProd.colName': 'Назва',
  'invProd.colSku': 'Артикул',
  'invProd.colCategory': 'Категорія',
  'invProd.colUnit': 'Одиниця',
  'invProd.colStock': 'Залишок',
  'invProd.colMin': 'Мін.',
  'invProd.colSellPrice': 'Ціна продажу',
  'invProd.labelName': 'Назва',
  'invProd.labelSku': 'Артикул',
  'invProd.labelCategory': 'Категорія',
  'invProd.labelUnit': 'Одиниця виміру',
  'invProd.labelMinStock': 'Мін. залишок',
  'invProd.labelSellPrice': 'Ціна продажу',
  'invProd.labelImageUrl': 'URL зображення',
  'invProd.labelImage': 'Фото товару',
  'invProd.uploadImage': 'Завантажити фото',
  'invProd.maxSize': 'до 200 КБ',
  'invProd.pasteUrl': 'Або вставити URL',
  'invProd.noCategory': 'Без категорії',
  'invProd.unitPcs': 'шт',
  'invProd.unitG': 'г',
  'invProd.unitKg': 'кг',
  'invProd.unitMl': 'мл',
  'invProd.unitL': 'л',
  'invProd.unitPack': 'уп',
  'invProd.save': 'Зберегти',
  'invProd.cancel': 'Скасувати',
  'invProd.publishOnOlx': 'Опублікувати на OLX',
  'invProd.olxPublished': 'OLX: оголошення створено',
  'olxPublish.title': 'Публікація на OLX',
  'olxPublish.alreadyPublished': 'Цей товар уже має оголошення на OLX. Нова публікація створить друге оголошення.',
  'olxPublish.openAdvert': 'Відкрити оголошення',
  'olxPublish.fieldTitle': 'Заголовок оголошення',
  'olxPublish.fieldDescription': 'Опис',
  'olxPublish.descriptionHint': 'Зазвичай OLX вимагає мінімум ~80 символів. Опиши що це за товар, стан, особливості.',
  'olxPublish.fieldCategory': 'Категорія',
  'olxPublish.suggesting': 'Підбираємо категорію за назвою…',
  'olxPublish.noCategorySuggestions': 'Не вдалось підібрати категорію автоматично. Уточни назву товару або введи ID вручну нижче.',
  'olxPublish.orManualCategoryId': 'або введи ID категорії OLX',
  'olxPublish.fieldCity': 'Місто',
  'olxPublish.cityPlaceholder': 'Почни вводити, наприклад «Київ»',
  'olxPublish.searching': 'Шукаємо…',
  'olxPublish.fieldPrice': 'Ціна',
  'olxPublish.fieldPhotoUrl': 'URL фото',
  'olxPublish.fieldContactName': 'Ім\'я контакту',
  'olxPublish.contactNamePlaceholder': 'Як підписати оголошення',
  'olxPublish.fieldContactPhone': 'Телефон',
  'olxPublish.errorTitle': 'OLX повернув помилку:',
  'olxPublish.showRawError': 'Показати повну відповідь OLX',
  'olxPublish.categoryAttrsTitle': 'OLX вимагає додаткові поля для цієї категорії:',
  'olxPublish.loadingAttrs': 'Завантажуємо поля категорії…',
  'olxPublish.choose': 'обери',
  'olxPublish.fieldDistrict': 'Район',
  'olxPublish.loadingDistricts': 'Підвантажуємо райони міста…',
  'olxPublish.success': 'Оголошення створено, відправлено на модерацію OLX',
  'olxPublish.cancel': 'Скасувати',
  'olxPublish.publish': 'Опублікувати',
  'invProd.add': 'Додати',
  'invProd.addCategory': 'Додати категорію',
  'invProd.addWarehouse': 'Додати склад',
  'invProd.categoryName': 'Назва категорії',
  'invProd.warehouseName': 'Назва складу',
  'invProd.warehouseDesc': 'Опис',
  'invProd.warehouseDescPlaceholder': 'Адреса, примітки...',
  'invProd.delete': 'Видалити',
  'invProd.deleteProduct': 'Видалити товар',
  'invProd.deleteCategory': 'Видалити категорію',
  'invProd.deleteWarehouse': 'Видалити склад',
  'invProd.deleteConfirmMsg': 'Ви впевнені, що хочете видалити?',
  'invProd.cannotDelete': 'Неможливо видалити',
  'invProd.errName': 'Введіть назву',
  'invProd.nameDuplicate': 'Товар з такою назвою вже існує',
  'invProd.catDuplicate': 'Категорія з такою назвою вже існує',
  'invProd.whDuplicate': 'Склад з такою назвою вже існує',
  'invProd.understood': 'Зрозуміло',
  'invProd.newCategoryPlaceholder': 'Назва нової категорії',
  'invProd.newWarehousePlaceholder': 'Назва нового складу',
  'invProd.blockProduct': 'Товари',
  'invProd.blockCategory': 'Категорії',
  'invProd.blockWarehouse': 'Склади',

  // ── Inventory stock page ──
  'invStock.title': 'Залишки',
  'invStock.subtitle': 'Контроль залишків на складах',
  'invStock.statProducts': 'Товарів',
  'invStock.statLow': 'Низький залишок',
  'invStock.searchPlaceholder': 'Пошук за назвою...',
  'invStock.allCategories': 'Всі категорії',
  'invStock.allWarehouses': 'Всі склади',
  'invStock.lowStockOnly': 'Тільки низький залишок',
  'invStock.emptyTitle': 'Немає даних',
  'invStock.emptyHint': 'Додайте товари в розділі "Номенклатура"',
  'invStock.colProduct': 'Товар',
  'invStock.colCategory': 'Категорія',
  'invStock.colUnit': 'Одиниця',
  'invStock.colTotal': 'Залишок',
  'invStock.colMin': 'Мін.',
  'invStock.colStatus': 'Статус',
  'invStock.statusLow': 'Низький',
  'invStock.statusEmpty': 'Немає',
  'invStock.available': 'В наявності',
  'invStock.transfer': 'Переміщення',
  'invStock.transferTitle': 'Переміщення товару',
  'invStock.transferBtn': 'Перемістити',
  'invStock.labelProduct': 'Товар',
  'invStock.labelFromWarehouse': 'Зі складу',
  'invStock.labelToWarehouse': 'На склад',
  'invStock.labelQuantity': 'Кількість',
  'invStock.cancel': 'Скасувати',

  // ── Inventory purchases page ──
  'invPurch.title': 'Закупівлі',
  'invPurch.subtitle': 'Облік закупівель товарів',
  'invPurch.statPurchases': 'Закупівель',
  'invPurch.searchPlaceholder': 'Пошук за постачальником...',
  'invPurch.newPurchase': 'Нова закупівля',
  'invPurch.emptyTitle': 'Закупівель ще немає',
  'invPurch.emptyHint': 'Створіть першу закупівлю',
  'invPurch.colDate': 'Дата',
  'invPurch.colSupplier': 'Постачальник',
  'invPurch.colWarehouse': 'Склад',
  'invPurch.colItems': 'Позиції',
  'invPurch.colTotal': 'Сума',
  'invPurch.modalTitle': 'Нова закупівля',
  'invPurch.labelSupplier': 'Постачальник',
  'invPurch.supplierPlaceholder': 'Введіть назву постачальника...',
  'invPurch.labelDestWarehouse': 'Склад призначення',
  'invPurch.sectionProducts': 'Товари',
  'invPurch.selectProduct': 'Оберіть товар',
  'invPurch.searchProduct': 'Пошук товару...',
  'invPurch.noProducts': 'Товарів не знайдено',
  'invPurch.addItem': 'Додати товар',
  'invPurch.qty': 'К-сть',
  'invPurch.pricePerUnit': 'Ціна за од.',
  'invPurch.totalSum': 'Загальна сума',
  'invPurch.pos': 'позицій',
  'invPurch.units': 'одиниць',
  'invPurch.receive': 'Оприбуткувати',
  'invPurch.cancel': 'Скасувати',
  'invPurch.errWarehouse': 'Оберіть склад',
  'invPurch.errItems': 'Додайте хоча б один товар',
  'invPurch.errNegPrice': 'Ціна не може бути від\'ємною',
  'invPurch.errZeroPrice': 'Вкажіть ціну закупівлі для кожного товару',
  'invPurch.periodWeek': 'Тиждень',
  'invPurch.periodMonth': 'Місяць',
  'invPurch.periodYear': 'Рік',
  'invPurch.periodAll': 'Весь час',
  'invPurch.periodCustom': 'Довільний',
  'invPurch.returnToSupplier': 'Повернути постачальнику',
  'invPurch.returnTitle': 'Повернення постачальнику',
  'invPurch.returnHint': 'Вкажіть кількість товарів для повернення',
  'invPurch.returnAmount': 'Сума повернення',
  'invPurch.confirmReturn': 'Повернути',
  'invPurch.returnSuccess': 'Повернення оформлено',
  'invPurch.returnLookupError': 'Не вдалося перевірити попередні повернення',
  'invPurch.returnSaveError': 'Не вдалося зберегти повернення',
  'invPurch.allReturned': 'Всі товари вже повернуто або відсутні на складі',
  'invPurch.deletePurchase': 'Видалити закупівлю',
  'invPurch.deleteTitle': 'Видалення закупівлі',
  'invPurch.deleteWarning': 'Ви впевнені? Буде відкатано наступні товари зі складу:',
  'invPurch.deleteStockNote': 'Залишки на складі будуть зменшені відповідно.',
  'invPurch.deleteConfirm': 'Видалити',
  'invPurch.deleteBlockedTitle': 'Видалення неможливе',
  'invPurch.deleteBlockedText': 'Цю закупівлю не можна видалити, бо по товарах вже були пізніші рухи:',
  'invPurch.deleteBlockedHint': 'Спочатку видаліть або скасуйте пізніші операції, потім повторіть спробу.',
  'invPurch.understood': 'Зрозуміло',

  // ── Tabs ──
  'invPurch.tabPurchases': 'Надходження товарів',
  'invPurch.tabSuppliers': 'Постачальники',
  'invPurch.selectSupplier': 'Оберіть постачальника',

  // ── Suppliers ──
  'invPurch.searchSupplier': 'Пошук постачальника...',
  'invPurch.newSupplier': 'Новий постачальник',
  'invPurch.editSupplier': 'Редагувати постачальника',
  'invPurch.statSuppliers': 'постачальників',
  'invPurch.emptySuppliersTitle': 'Постачальників поки немає',
  'invPurch.emptySuppliersHint': 'Додайте постачальників для зручного обліку закупівель',
  'invPurch.colSupplierName': 'Назва',
  'invPurch.colContact': 'Контактна особа',
  'invPurch.colPhone': 'Телефон',
  'invPurch.colEdrpou': 'ЄДРПОУ',
  'invPurch.supplierDuplicate': 'Постачальник з такою назвою вже існує',
  'invPurch.supplierName': 'Назва',
  'invPurch.supplierNamePh': 'ТОВ "Постачальник"',
  'invPurch.contactPerson': 'Контактна особа',
  'invPurch.contactPersonPh': 'Прізвище Ім\'я',
  'invPurch.phone': 'Телефон',
  'invPurch.email': 'Email',
  'invPurch.bankDetails': 'Банківські реквізити',
  'invPurch.edrpou': 'ЄДРПОУ',
  'invPurch.mfo': 'МФО',
  'invPurch.iban': 'IBAN / Розрахунковий рахунок',
  'invPurch.supplierNotes': 'Нотатки',
  'invPurch.supplierNotesPh': 'Додаткова інформація про постачальника...',
  'invPurch.create': 'Створити',
  'invPurch.deleteSupplierTitle': 'Видалити постачальника?',
  'invPurch.deleteSupplierWarning': 'Ви впевнені, що хочете видалити постачальника',

  // ── Inventory movements page ──
  'invMov.title': 'Рух товарів',
  'invMov.subtitle': 'Історія руху товарів на складах',
  'invMov.statOperations': 'Операцій',
  'invMov.filterType': 'Тип',
  'invMov.filterAll': 'Всі',
  'invMov.filterPurchase': 'Закупівля',
  'invMov.filterWriteoff': 'Списання',
  'invMov.filterTransfer': 'Переміщення',
  'invMov.filterAppointment': 'Запис',
  'invMov.filterOrder': 'Замовлення',
  'invMov.filterReturn': 'Повернення',
  'invMov.filterAllProducts': 'Усі товари',
  'invMov.emptyTitle': 'Немає операцій',
  'invMov.emptyHint': 'Тут відображатимуться всі операції з товарами',
  'invMov.colDate': 'Дата',
  'invMov.colType': 'Тип',
  'invMov.colProduct': 'Товар',
  'invMov.colQty': 'К-сть',
  'invMov.colCost': 'Собівартість',
  'invMov.colWarehouse': 'Склад',
  'invMov.colAuthor': 'Автор',
  'invMov.colDetails': 'Деталі',
  'invMov.typePurchase': 'Закупівля',
  'invMov.typeWriteoff': 'Списання',
  'invMov.typeTransfer': 'Переміщення',
  'invMov.typeAppointment': 'Запис',
  'invMov.typeSale': 'Продаж',
  'invMov.typeOrder': 'Замовлення',
  'invMov.typeOrderCancel': 'Скасування замовлення',
  'invMov.typeSaleCancel': 'Скасування продажу',
  'invMov.typeAppointmentCancel': 'Скасування запису',
  'invMov.typeReturn': 'Повернення',
  'invMov.typePurchaseReturn': 'Повернення постачальнику',
  'invMov.supplier': 'Постачальник',
  'invMov.writeoffTitle': 'Списання товару',
  'invMov.writeoffBtn': 'Списати',
  'invMov.writeoffConfirm': 'Підтвердити списання',
  'invMov.labelProduct': 'Товар',
  'invMov.labelQuantity': 'Кількість',
  'invMov.labelWarehouse': 'Склад',
  'invMov.labelReason': 'Причина',
  'invMov.labelNote': 'Примітка',
  'invMov.available': 'Доступно',
  'invMov.cancel': 'Скасувати',
  'invMov.reasonExpired': 'Прострочено',
  'invMov.reasonDamaged': 'Пошкоджено',
  'invMov.reasonLost': 'Втрачено',
  'invMov.reasonUsed': 'Використано',
  'invMov.reasonOther': 'Інше',

  // ── Salary calculation page ──
  'salCalc.month_jan': 'Січень', 'salCalc.month_feb': 'Лютий', 'salCalc.month_mar': 'Березень',
  'salCalc.month_apr': 'Квітень', 'salCalc.month_may': 'Травень', 'salCalc.month_jun': 'Червень',
  'salCalc.month_jul': 'Липень', 'salCalc.month_aug': 'Серпень', 'salCalc.month_sep': 'Вересень',
  'salCalc.month_oct': 'Жовтень', 'salCalc.month_nov': 'Листопад', 'salCalc.month_dec': 'Грудень',
  'salCalc.title': 'Розрахунок зарплат',
  'salCalc.subtitle': 'Нарахування заробітної плати',
  'salCalc.selectMonthHint': 'Оберіть місяць для розрахунку',
  'salCalc.calculate': 'Розрахувати',
  'salCalc.save': 'Зберегти',
  'salCalc.loadSaved': 'Завантажити збережене',
  'salCalc.exportExcel': 'Експорт Excel',
  'salCalc.staffCount': 'Співробітників',
  'salCalc.staffWithSchemes': 'Зі схемами',
  'salCalc.allStaff': 'Всі',
  'salCalc.noDataTitle': 'Немає даних',
  'salCalc.noDataDesc': 'Оберіть місяць і натисніть "Розрахувати"',
  'salCalc.noStaffTitle': 'Немає співробітників',
  'salCalc.noStaffDesc': 'Додайте співробітників у розділі "Персонал"',
  'salCalc.totalByRules': 'За правилами',
  'salCalc.manualAdjustments': 'Коригування',
  'salCalc.totalLabel': 'Всього',
  'salCalc.grandTotal': 'Загальна сума',
  'salCalc.adjustments': 'Коригування',
  'salCalc.addAdjustment': 'Додати коригування',
  'salCalc.adjDescPlaceholder': 'Опис...',
  'salCalc.adjAmountPlaceholder': 'Сума',
  'salCalc.edit': 'Редагувати',
  'salCalc.back': 'Назад',
  'salCalc.cancel': 'Скасувати',
  'salCalc.saved': 'Збережено',
  'salCalc.savedNotice': 'Розрахунок збережено',
  'salCalc.overwriteTitle': 'Перезаписати?',
  'salCalc.overwriteDesc': 'Для цього місяця вже є збережений розрахунок. Перезаписати?',
  'salCalc.overwrite': 'Перезаписати',
  'salCalc.hourlyRate': 'Ставка за годину',
  'salCalc.monthlySalary': 'Оклад за місяць',
  'salCalc.monthlyFixed': 'фікс. за місяць',
  'salCalc.tiered': 'вилки',
  'salCalc.dailyRate': 'Ставка за робочий день',
  'salCalc.fixedPerAppointment': 'Бонус за виконаний запис',
  'salCalc.percentOwnServices': '% від наданих послуг',
  'salCalc.percentTotalRevenue': '% від загальної виручки',
  'salCalc.percentOwnProductSales': '% від власних продажів',
  'salCalc.percentAllProductSales': '% від усіх продажів локації',
  'salCalc.percentCreatedAppointments': '% від записаних клієнтів',
  'salCalc.fixedPerCreatedAppointment': 'Бонус за записаного клієнта',
  'salCalc.percentOwnMaterials': '% від використаних матеріалів',
  'salCalc.percentAllServices': '% від усіх послуг локації',
  'salCalc.hours': 'год',
  'salCalc.days': 'дн',
  'salCalc.appts': 'зап.',
  'salCalc.services': 'посл.',
  'salCalc.individual': 'індивідуально',
  'salCalc.otherService': 'інше',
  'salCalc.exFileName': 'Зарплати',
  'salCalc.exStaff': 'Співробітник',
  'salCalc.exScheme': 'Схема',
  'salCalc.exByRules': 'За правилами',
  'salCalc.exAdjustments': 'Коригування',
  'salCalc.exTotal': 'Всього',
  'salCalc.exRule': 'Правило',
  'salCalc.exDetails': 'Деталізація',
  'salCalc.exAmount': 'Сума',
  'salCalc.exGrandTotal': 'Загальна сума',
  'salCalc.adjustment': 'Коригування',

  // ── Salary schemes page ──
  'salSchemes.title': 'Схеми мотивації',
  'salSchemes.subtitle': 'Правила нарахування заробітної плати',
  'salSchemes.schemesCount': 'Схем',
  'salSchemes.newScheme': 'Нова схема',
  'salSchemes.emptyTitle': 'Схем ще немає',
  'salSchemes.emptyDesc': 'Створіть першу схему нарахування',
  'salSchemes.newSchemeTitle': 'Нова схема',
  'salSchemes.editScheme': 'Редагувати схему',
  'salSchemes.schemeName': 'Назва схеми',
  'salSchemes.nameDuplicate': 'Схема з такою назвою вже існує',
  'salSchemes.schemeNamePlaceholder': 'Введіть назву...',
  'salSchemes.rulesSection': 'Правила нарахування',
  'salSchemes.groupBase': 'Базові',
  'salSchemes.groupServices': 'Послуги',
  'salSchemes.groupProducts': 'Товари',
  'salSchemes.groupGeneral': 'Загальні',
  'salSchemes.groupAdmin': 'Адміністративні',
  'salSchemes.noRules': 'Правил ще немає',
  'salSchemes.hourlyRate': 'Ставка за годину',
  'salSchemes.dailyRate': 'Ставка за робочий день',
  'salSchemes.fixedPerAppointment': 'Бонус за виконану послугу',
  'salSchemes.percentOwnServices': '% від наданих послуг',
  'salSchemes.percentTotalRevenue': '% від загальної виручки',
  'salSchemes.hintHourlyRate': 'Фіксована сума за кожну годину по графіку',
  'salSchemes.hintDailyRate': 'Фіксована сума за кожен день по графіку',
  'salSchemes.hintFixedPer': 'Фіксована сума за кожну надану послугу; можна додати окремі ставки для конкретних послуг',
  'salSchemes.hintPercentOwn': 'Відсоток від виручки записів, де цей співробітник — виконавець',
  'salSchemes.hintPercentTotal': 'Від усієї виручки локації: послуги + товари + абонементи',
  'salSchemes.percentOwnProductSales': '% від власних продажів',
  'salSchemes.hintPercentOwnProducts': 'Відсоток від товарів, проданих цим співробітником',
  'salSchemes.percentAllProductSales': '% від усіх продажів локації',
  'salSchemes.hintPercentAllProducts': 'Відсоток від загальних товарних продажів точки',
  'salSchemes.percentCreatedAppointments': '% від записаних клієнтів',
  'salSchemes.hintPercentCreated': 'Відсоток від виручки записів, створених цим співробітником',
  'salSchemes.fixedPerCreatedAppointment': 'Бонус за записаного клієнта',
  'salSchemes.hintFixedCreated': 'Фіксована сума за кожного записаного клієнта',
  'salSchemes.percentOwnMaterials': '% від використаних матеріалів',
  'salSchemes.hintPercentMaterials': '% від вартості матеріалів, використаних при наданні послуг цим майстром',
  'salSchemes.percentAllServices': '% від усіх послуг локації',
  'salSchemes.hintPercentAllServices': 'Відсоток від загальної виручки послуг та абонементів точки',
  'salSchemes.subscriptionLabel': 'Послуги за абонементом',
  'salSchemes.subModeVisitPrice': 'За ціною абонементу',
  'salSchemes.subModeFullPrice': 'За прайсом',
  'salSchemes.subModeSkip': 'Не враховувати',
  'salSchemes.unitHour': 'грн/год',
  'salSchemes.unitDay': 'грн/день',
  'salSchemes.unitRecord': 'грн/запис',
  'salSchemes.unitService': 'грн/послугу',
  'salSchemes.useOverrides': 'Винятки для послуг',
  'salSchemes.overrideService': 'Послуга',
  'salSchemes.overrideRate': 'Ставка',
  'salSchemes.overrideAdd': 'Додати виняток',
  'salSchemes.overrideRemove': 'Видалити виняток',
  'salSchemes.overridesShort': 'винятків',
  'salSchemes.staffShort': 'спів.',
  'salSchemes.save': 'Зберегти',
  'salSchemes.create': 'Створити',
  'salSchemes.cancel': 'Скасувати',
  'salSchemes.editBtn': 'Редагувати',
  'salSchemes.deleteBtn': 'Видалити',
  'salSchemes.delete': 'Видалити',
  'salSchemes.deleteTitle': 'Видалити схему?',
  'salSchemes.deleteConfirmText': 'Ви впевнені, що хочете видалити цю схему?',
  'salSchemes.deleteAssigned': 'Ця схема призначена співробітникам і не може бути видалена',
  'salSchemes.understood': 'Зрозуміло',
  'salSchemes.monthlySalary': 'Оклад за місяць',
  'salSchemes.hintMonthlySalary': 'Фіксована сума за місяць незалежно від графіка',
  'salSchemes.unitMonth': 'грн/міс',
  'salSchemes.useBrackets': 'Прогресивна шкала (вилки)',
  'salSchemes.bracketModeProgressive': 'Прогресивно (по слайсах)',
  'salSchemes.bracketModeFlat': 'Плоско (вся сума за досягнутою вилкою)',
  'salSchemes.bracketFrom': 'Від',
  'salSchemes.bracketTo': 'До',
  'salSchemes.bracketAdd': 'Додати вилку',
  'salSchemes.bracketRemove': 'Видалити вилку',

  // ── Checkbox settings page ──
  'checkbox.title': 'Checkbox ПРРО',
  'checkbox.subtitle': 'Налаштування підключення до Checkbox',
  'checkbox.licenseKey': 'Ліцензійний ключ',
  'checkbox.licenseKeyHint': 'Ключ із особистого кабінету Checkbox',
  'checkbox.licenseKeyPlaceholder': 'Введіть ліцензійний ключ...',
  'checkbox.pinCode': 'PIN-код касира',
  'checkbox.pinCodeHint': 'PIN-код касира з Checkbox',
  'checkbox.pinPlaceholder': 'Введіть PIN-код...',
  'checkbox.save': 'Зберегти',
  'checkbox.saving': 'Збереження...',
  'checkbox.settingsSaved': 'Налаштування збережено',
  'checkbox.testConnection': 'Перевірити підключення',
  'checkbox.testing': 'Перевірка...',
  'checkbox.connectionSuccess': 'Підключення успішне',
  'checkbox.connectionSuccessToast': 'Checkbox підключено успішно',
  'checkbox.shiftOpen': 'Зміна відкрита',
  'checkbox.shiftClosed': 'Зміна закрита',
  'checkbox.guideTitle': 'Як працює інтеграція',
  'checkbox.guideStep1': 'Зареєструйтесь на checkbox.ua та створіть касу. В особистому кабінеті скопіюйте ліцензійний ключ каси.',
  'checkbox.guideStep2': 'Створіть касира та запам\'ятайте його PIN-код. Вставте ключ та PIN вище, натисніть "Перевірити підключення".',
  'checkbox.guideStep3': 'Готово! Тепер при оплаті замовлення або запису на послуги система автоматично створить фіскальний чек.',
  'checkbox.guideCapabilities': 'Можливості:',
  'checkbox.guideCap1': 'Автоматична фіскалізація при оплаті замовлень та записів',
  'checkbox.guideCap2': 'Відкриття та закриття касових змін',
  'checkbox.guideCap3': 'Підтримка готівки та безготівкових платежів',
  'checkbox.guideCap4': 'X-звіт та Z-звіт для контролю каси',
  'checkbox.taxGroup': 'Податкова група',
  'checkbox.taxGroupHint': 'Оберіть податкові ставки, які додаватимуться до кожного чека. Натисніть "Перевірити підключення" щоб завантажити доступні ставки.',
  'checkbox.noTax': 'Без податку',
  'checkbox.paylinkTitle': 'Підключення POS-терміналу',
  'checkbox.paylinkDesc': 'Підключіть банківський термінал для автоматичної передачі суми оплати при натисканні "Картка".',
  'checkbox.paylinkStep1': 'Завантажте та встановіть {link}Checkbox Desktop PayLink{/link}',
  'checkbox.paylinkStep2': 'Підключіть термінал до PayLink (USB, Wi-Fi або Ethernet) та прив\'яжіть до вашої каси. Деталі — в {link}офіційній інструкції{/link}',
  'checkbox.paylinkStep3': 'Готово! Тепер при оплаті карткою сума автоматично передається на термінал',
  'checkbox.paylinkHost': 'Адреса PayLink',
  'checkbox.paylinkPort': 'Порт',
  'checkbox.paylinkDetect': 'Знайти термінали',
  'checkbox.paylinkDetecting': 'Пошук...',
  'checkbox.paylinkNoDevices': 'Терміналів не знайдено. Перевірте, що термінал додано в PayLink.',
  'checkbox.paylinkFound': 'Знайдено терміналів',
  'checkbox.paylinkSelectTerminal': 'Оберіть термінал',
  'checkbox.paylinkChoose': '— оберіть —',
  'checkbox.paylinkPing': 'Перевірити термінал',
  'checkbox.paylinkPinging': 'Перевірка...',
  'checkbox.paylinkPingOk': 'Термінал підключений і готовий до роботи',
  'checkbox.paylinkSave': 'Зберегти термінал',
  'checkbox.paylinkSaved': 'Термінал збережено',
  'checkbox.paylinkSupported': 'Підтримувані термінали:',
  'checkbox.paylinkDocs': 'Детальна інструкція на сайті Checkbox',

  // ── Nova Poshta settings page ──
  'np.title': 'Нова Пошта',
  'np.subtitle': 'Налаштування інтеграції з Новою Поштою',
  'np.apiKey': 'API-ключ',
  'np.apiKeyPlaceholder': 'Введіть API-ключ Нової Пошти...',
  'np.apiKeyHint': 'Ключ з особистого кабінету my.novaposhta.ua → Налаштування → Безпека',
  'np.save': 'Зберегти',
  'np.saving': 'Збереження...',
  'np.settingsSaved': 'Налаштування Нової Пошти збережено',
  'np.error': 'Помилка: ',
  'np.testConnection': 'Перевірити підключення',
  'np.testing': 'Перевірка...',
  'np.connectionSuccess': 'Підключено! Знайдено відправників: {count}',
  'np.connectionSuccessToast': 'Нова Пошта підключена успішно',
  'np.connectionFailed': 'Не вдалося підключитися. Перевірте API-ключ.',
  'np.senderSection': 'Дані відправника',
  'np.sender': 'Відправник (контрагент)',
  'np.contactPerson': 'Контактна особа',
  'np.senderPhone': 'Телефон відправника',
  'np.senderAddress': 'Адреса відправлення',
  'np.senderAddressHint': 'Відділення НП, звідки ви відправляєте посилки',
  'np.loadingSenders': 'Завантаження даних відправника...',
  'np.senderWarehouse': 'Відділення відправника',
  'np.senderWarehouseHint': 'У вашому акаунті НП немає зареєстрованих адрес. Оберіть відділення, звідки ви відправляєте посилки.',
  'np.senderCity': 'Місто відправника',
  'np.senderCityPlaceholder': 'Введіть назву міста...',
  'np.senderWarehouseSelect': 'Відділення',
  'np.noWarehouses': 'Відділень не знайдено',
  'np.clearSelection': 'Скинути',
  'np.guideTitle': 'Як працює інтеграція',
  'np.guideStep1': 'Увійдіть в особистий кабінет my.novaposhta.ua → Налаштування → Безпека → скопіюйте API-ключ.',
  'np.guideStep2': 'Вставте ключ вище, натисніть "Перевірити підключення". Оберіть відправника, контактну особу та адресу відправки.',
  'np.guideStep3': 'Готово! Тепер при створенні замовлення оберіть "Нова Пошта" як спосіб доставки.',
  'np.guideCapabilities': 'Можливості:',
  'np.guideCap1': 'Створення ТТН одним кліком зі сторінки замовлення (статус "Запаковано")',
  'np.guideCap2': 'Автоматична синхронізація статусу доставки кожні 10 хвилин',
  'np.guideCap3': 'Відстеження посилки в реальному часі',
  'np.guideCap4': 'Друк маркування для наклейки на посилку',
  'np.guideCap5': 'Автоматичний розрахунок вартості доставки при виборі відділення',

  // ── Meest Express settings page ──
  'meest.title': 'Meest Express',
  'meest.subtitle': 'Налаштування інтеграції з Meest Express',
  'meest.apiToken': 'API токен',
  'meest.apiTokenPlaceholder': 'Вставте API токен з кабінету Meest',
  'meest.apiTokenHint': 'Знайдіть в кабінеті 24.meest.com → Налаштування → API інтеграції',
  'meest.contractId': 'Contract ID',
  'meest.contractIdPlaceholder': 'Напр. b0004cad-27a3-...',
  'meest.contractIdHint': 'Знайдіть в кабінеті Meest поруч з API токеном',
  'meest.save': 'Зберегти',
  'meest.saving': 'Збереження...',
  'meest.settingsSaved': 'Налаштування Meest Express збережено',
  'meest.error': 'Помилка: ',
  'meest.testConnection': 'Перевірити підключення',
  'meest.testing': 'Перевірка...',
  'meest.testingConnection': 'Перевірка з\'єднання з Meest Express...',
  'meest.connectionSuccess': 'Meest Express підключено успішно',
  'meest.connectionSuccessToast': 'Meest Express підключено',
  'meest.connectionFailed': 'Не вдалося підключитися. Перевірте токен та Contract ID.',
  'meest.senderSection': 'Дані відправника',
  'meest.senderName': 'ПІБ відправника',
  'meest.senderNamePlaceholder': 'Прізвище Ім\'я По батькові',
  'meest.senderPhone': 'Телефон відправника',
  'meest.senderCity': 'Місто відправника',
  'meest.senderCityPlaceholder': 'Почніть вводити назву міста',
  'meest.senderBranch': 'Відділення відправника',
  'meest.branchPlaceholder': 'Пошук відділення',
  'meest.branchSearchPlaceholder': 'Місто, назва або номер відділення',
  'meest.noBranches': 'Відділень не знайдено',
  'meest.clearSelection': 'Скинути',
  'meest.guideTitle': 'Як працює інтеграція',
  'meest.guideStep1': 'Зареєструйтесь на 24.meest.com та підпишіть договір. В розділі Налаштування → API інтеграції скопіюйте токен і Contract ID.',
  'meest.guideStep2': 'Вставте їх вище, натисніть "Перевірити підключення". Дані відправника заповняться автоматично — перевірте та збережіть.',
  'meest.guideStep3': 'Готово! Тепер при створенні замовлення оберіть "Meest Express" як спосіб доставки.',
  'meest.guideCapabilities': 'Можливості:',
  'meest.guideCap1': 'Створення відправки одним кліком зі сторінки замовлення (статус "Запаковано")',
  'meest.guideCap2': 'Автоматична синхронізація статусу доставки кожні 10 хвилин',
  'meest.guideCap3': 'Відстеження посилки в реальному часі',
  'meest.guideCap4': 'Друк етикетки для наклейки на посилку',

  // ── Telegram settings page ──
  'telegram.title': 'Telegram нагадування',
  'telegram.subtitle': 'Налаштування бота для нагадувань клієнтам',
  'telegram.botToken': 'Bot Token',
  'telegram.botTokenHint': 'Токен бота від @BotFather',
  'telegram.saveAndConnect': 'Зберегти та підключити',
  'telegram.connecting': 'Підключення...',
  'telegram.checkingBot': 'Перевірка бота...',
  'telegram.settingWebhook': 'Налаштування webhook...',
  'telegram.botConnected': 'Бот підключено',
  'telegram.botReady': 'Бот готовий до роботи',
  'telegram.invalidToken': 'Невірний токен',
  'telegram.webhookError': 'Помилка webhook',
  'telegram.webhookFailed': 'Не вдалося налаштувати webhook',
  'telegram.error': 'Помилка',
  'telegram.howItWorks': 'Як це працює',
  'telegram.step1': '1. Створіть бота через @BotFather в Telegram',
  'telegram.step2': '2. Скопіюйте токен бота',
  'telegram.step3': '3. Вставте токен вище та натисніть "Зберегти та підключити"',
  'telegram.step4': '4. Клієнти зможуть підключитися через посилання',
  'telegram.guideCapabilities': 'Можливості:',
  'telegram.guideCap1': 'Автоматичні нагадування клієнтам про записи',
  'telegram.guideCap2': 'Клієнти можуть переглядати свої майбутні записи',
  'telegram.guideCap3': 'Підтвердження або скасування запису через бота',
  'telegram.guideCap4': 'Персональне посилання для кожного клієнта',

  // ── SMS settings page ──
  'sms.title': 'SMS-розсилка',
  'sms.subtitle': 'Налаштування SMS-шлюзу',
  'sms.provider': 'Провайдер',
  'sms.apiKey': 'API-ключ',
  'sms.apiKeyPlaceholder': 'Введіть API-ключ...',
  'sms.senderName': "Ім'я відправника",
  'sms.senderNameHint': "Ім'я, яке побачить отримувач (до 11 символів)",
  'sms.save': 'Зберегти',
  'sms.settingsSaved': 'Налаштування збережено',
  'sms.testConnection': 'Перевірити підключення',
  'sms.testing': 'Перевірка...',
  'sms.checkingConnection': 'Перевірка з\'єднання...',
  'sms.connectionSuccess': 'Підключення успішне',
  'sms.connectionError': 'Помилка підключення',
  'sms.gatewayWorks': 'SMS-шлюз працює',
  'sms.error': 'Помилка',
  'sms.unknown': 'Невідома помилка',
  'sms.howItWorks': 'Як це працює',
  'sms.howToConnect': 'Як підключити {name}',
  'sms.openSite': 'Відкрити сайт {name}',
  'sms.apiKeyLocation': 'API-ключ знайдеш тут: {path}',
  'sms.recommended': 'Рекомендовано',
  // Картки провайдерів — короткий опис під назвою
  'sms.tagline_turbosms': 'Найпопулярніший в Україні. Зручний кабінет, простий API.',
  'sms.tagline_smsclub': 'Гнучкі тарифи, підтримка alpha-name.',
  'sms.tagline_alphasms': 'Прозоре ціноутворення, швидка реєстрація.',
  // TurboSMS — крок 1 містить лінк на сайт (підкладається у компоненті)
  'sms.guide_turbosms.step1': 'Зареєструйся на сайті TurboSMS і поповни баланс.',
  'sms.guide_turbosms.step2': 'У кабінеті замов alpha-name (відображається як ім\'я відправника). Підтвердження зазвичай у той же день.',
  'sms.guide_turbosms.step3': 'Перейди в Профіль → API і скопіюй API-ключ.',
  'sms.guide_turbosms.step4': 'Встав ключ і alpha-name нижче, натисни "Перевірити підключення".',
  // SMSClub
  'sms.guide_smsclub.step1': 'Створи аккаунт у SMSClub і поповни баланс.',
  'sms.guide_smsclub.step2': 'У кабінеті оформи alpha-name (moderation ~1 робочий день).',
  'sms.guide_smsclub.step3': 'Перейди в Налаштування / Профіль → знайди API-токен.',
  'sms.guide_smsclub.step4': 'Встав токен та alpha-name нижче, натисни "Перевірити підключення".',
  // AlphaSMS
  'sms.guide_alphasms.step1': 'Зареєструйся на AlphaSMS і поповни баланс.',
  'sms.guide_alphasms.step2': 'Замов alpha-name у кабінеті (на модерацію зазвичай йде кілька годин).',
  'sms.guide_alphasms.step3': 'У кабінеті: Налаштування → API → скопіюй API-ключ.',
  'sms.guide_alphasms.step4': 'Встав ключ та alpha-name нижче, натисни "Перевірити підключення".',
  // Legacy keys (старі step1-4 — лишаємо для зворотньої сумісності)
  'sms.step1': '1. Зареєструйтесь у SMS-провайдера',
  'sms.step2': '2. Отримайте API-ключ',
  'sms.step3': '3. Вставте ключ вище та збережіть',
  'sms.step4': '4. Тепер можна надсилати SMS клієнтам',

  // ── Email settings page ──
  'emailSet.title': 'Email-розсилка',
  'emailSet.subtitle': 'Налаштування відправки email',
  'emailSet.gmailAddress': 'Gmail адреса',
  'emailSet.gmailHint': 'Адреса Gmail з якої надсилатимуться листи',
  'emailSet.appPassword': 'Пароль додатку',
  'emailSet.appPasswordHint': 'Пароль додатку Google (не основний пароль)',
  'emailSet.fromName': "Ім'я відправника",
  'emailSet.fromNameHint': "Ім'я, яке побачить отримувач",
  'emailSet.save': 'Зберегти',
  'emailSet.settingsSaved': 'Налаштування збережено',
  'emailSet.sendTestEmail': 'Надіслати тестовий лист',
  'emailSet.sendingTest': 'Надсилання...',
  'emailSet.testing': 'Тестування...',
  'emailSet.testSent': 'Тестовий лист надіслано',
  'emailSet.testSubject': 'Тестовий лист',
  'emailSet.testBody': 'Це тестовий лист від Systemic CRM',
  'emailSet.emailWorks': 'Email працює',
  'emailSet.sendError': 'Помилка надсилання',
  'emailSet.error': 'Помилка',
  'emailSet.unknown': 'Невідома помилка',
  'emailSet.howToGetAppPassword': 'Як отримати пароль додатку',
  'emailSet.important': 'Важливо',
  'emailSet.importantText': 'Використовуйте пароль додатку, а не основний пароль Gmail',
  'emailSet.step1': '1. Увійдіть у Google акаунт',
  'emailSet.step2': '2. Перейдіть у Безпека → Двоетапна перевірка',
  'emailSet.step2direct': '2. Увімкніть двоетапну перевірку',
  'emailSet.step3': '3. Перейдіть у Паролі додатків',
  'emailSet.step4': '4. Створіть новий пароль додатку',
  'emailSet.step5': '5. Скопіюйте згенерований пароль',
  'emailSet.provider': 'Поштовий сервіс',
  'emailSet.presetGmail': 'Gmail / Google Workspace',
  'emailSet.presetOutlook': 'Outlook / Microsoft 365',
  'emailSet.presetUkrnet': 'Ukr.net',
  'emailSet.presetMeta': 'Meta.ua',
  'emailSet.presetCustom': 'Власний SMTP',
  'emailSet.hintGmail': 'Потрібен App Password з myaccount.google.com/apppasswords (спочатку увімкніть 2FA)',
  'emailSet.hintOutlook': 'Логін — повна адреса (you@outlook.com). Може знадобитись окремий пароль додатка при увімкненому 2FA',
  'emailSet.hintUkrnet': 'У Ukr.net: Налаштування → Пошта → Дозволити доступ зовнішніх поштових клієнтів',
  'emailSet.hintMeta': 'У Meta.ua: Налаштування → IMAP/SMTP → Увімкнути',
  'emailSet.hintCustom': 'Введи host, port та облікові дані свого поштового сервера вручну',
  'emailSet.host': 'SMTP сервер',
  'emailSet.port': 'Порт',
  'emailSet.secure': 'TLS/SSL',
  'emailSet.smtpUser': 'Логін SMTP',
  'emailSet.smtpUserHint': 'Зазвичай повна email-адреса',
  'emailSet.password': 'Пароль SMTP',
  'emailSet.passwordHint': 'Для Gmail/Outlook — пароль додатка, не основний',
  'emailSet.fromEmail': 'Адреса відправника',
  'emailSet.fromEmailHint': 'Якщо порожнє — використовується логін SMTP',
  'emailSet.invalidEmail': 'Не валідна email-адреса (потрібно user@domain.com)',
  'emailSet.sectionProvider': 'Поштовий сервіс і сервер',
  'emailSet.sectionCredentials': 'Облікові дані',
  'emailSet.sectionFrom': 'Від кого надсилаємо',
  'emailSet.howToConnect': 'Як підключити {provider}',
  'emailSet.instrGmail': '<ol><li>Увімкніть двофакторну автентифікацію на акаунті Google: <a href="https://myaccount.google.com/security" target="_blank">myaccount.google.com/security</a> → <strong>Двоетапна перевірка</strong> → <strong>Увімкнути</strong>.</li><li>Перейдіть на <a href="https://myaccount.google.com/apppasswords" target="_blank">myaccount.google.com/apppasswords</a>.</li><li>Створіть новий App Password: тип — <strong>Mail</strong> (або <strong>Other</strong> з назвою <code>Systemic CRM</code>).</li><li>Скопіюйте 16-символьний пароль (виглядає як <code>abcd efgh ijkl mnop</code>).</li><li>Вставте його у поле <strong>Пароль SMTP</strong> вище. Натисніть <strong>Надіслати тестовий лист</strong>.</li></ol>',
  'emailSet.instrOutlook': '<ol><li>Увійдіть на <a href="https://account.microsoft.com/security" target="_blank">account.microsoft.com/security</a>.</li><li>Перейдіть у <strong>Розширені параметри безпеки</strong>.</li><li>У розділі <strong>Паролі програм</strong> натисніть <strong>Створити новий пароль</strong>.</li><li>Скопіюйте згенерований пароль і вставте у <strong>Пароль SMTP</strong>.</li><li><em>Якщо опція "Паролі програм" відсутня — спочатку увімкніть двоетапну перевірку.</em></li></ol>',
  'emailSet.instrUkrnet': '<ol><li>Увійдіть у Ukr.net пошту.</li><li>Перейдіть у <strong>Налаштування → Всі налаштування → Робота з поштовими програмами</strong>.</li><li>Увімкніть <strong>Доступ за протоколом IMAP/SMTP</strong>.</li><li>У полі <strong>Пароль SMTP</strong> вкажіть основний пароль до пошти Ukr.net.</li><li><em>Якщо у вас увімкнено двоетапну перевірку — створіть окремий пароль додатка в Параметрах безпеки.</em></li></ol>',
  'emailSet.instrMeta': '<ol><li>Увійдіть у Meta.ua пошту.</li><li>Перейдіть у <strong>Налаштування → IMAP/SMTP</strong>.</li><li>Увімкніть протокол SMTP.</li><li>Вкажіть основний пароль до пошти у полі <strong>Пароль SMTP</strong>.</li></ol>',
  'emailSet.instrCustom': '<ol><li>Зверніться до системного адміністратора або хостинг-провайдера за параметрами SMTP вашого поштового сервера.</li><li>Зазвичай потрібні: <strong>host</strong> (smtp.your-domain.com), <strong>port</strong> (587 або 465), <strong>TLS/SSL</strong> (для 465 — увімкнено).</li><li>Логін — повна email-адреса.</li><li>Пароль — той самий, що ви використовуєте для входу в пошту (або окремий SMTP-пароль якщо провайдер його видає).</li></ol>',

  // ── Locations settings page ──
  'locations.title': 'Локації',
  'locations.subtitle': 'Управління локаціями вашого бізнесу',
  'locations.locationsLabel': 'Локацій',
  'locations.staffCount': 'Співробітників',
  'locations.warehousesCount': 'Складів',
  'locations.addLocation': 'Додати локацію',
  'locations.tabMain': 'Основне',
  'locations.tabBooking': 'Онлайн-запис',
  'locations.tabCompany': 'Реквізити',
  'locations.photo': 'Фото локації',
  'locations.uploadPhoto': 'Завантажити фото',
  'locations.changePhoto': 'Змінити фото',
  'locations.photoHint': 'Фото інтер\'єру або фасаду — відображається на сторінці онлайн-запису',
  'locations.scheduleLabel': 'Графік роботи',
  'locations.dayOff': 'Вихідний',
  'locations.mon': 'Пн', 'locations.tue': 'Вт', 'locations.wed': 'Ср',
  'locations.thu': 'Чт', 'locations.fri': 'Пт', 'locations.sat': 'Сб', 'locations.sun': 'Нд',
  'locations.workingHoursLabel': 'Графік роботи',
  'locations.workingHoursPlaceholder': 'Пн-Пт 9:00-18:00, Сб 10:00-15:00',
  'locations.hasLinkedData': 'Неможливо видалити — до локації привʼязані співробітники або склади. Спочатку перепривʼяжіть їх.',
  'locations.limitReached': 'Досягнуто ліміт локацій вашого тарифного плану. Оновіть план для додавання.',
  'locations.newLocation': 'Нова локація',
  'locations.editLocation': 'Редагувати локацію',
  'locations.nameLabel': 'Назва',
  'locations.namePlaceholder': 'Введіть назву...',
  'locations.nameDuplicate': 'Локація з такою назвою вже існує',
  'locations.addressLabel': 'Адреса',
  'locations.addressPlaceholder': 'вул. Хрещатик 1',
  'locations.cityLabel': 'Місто',
  'locations.cityPlaceholder': 'Київ',
  'locations.phoneLabel': 'Телефон',
  'locations.colorLabel': 'Колір',
  'locations.save': 'Зберегти',
  'locations.cancel': 'Скасувати',
  'locations.add': 'Додати',
  'locations.edit': 'Редагувати',
  'locations.delete': 'Видалити',
  'locations.cannotDelete': 'Неможливо видалити',
  'locations.ordersCount': 'Замовлень',
  'locations.needAtLeastOne': 'Потрібна хоча б одна локація',
  'locations.added': 'Локацію додано',
  'locations.updated': 'Локацію оновлено',
  'locations.deleted': 'Локацію видалено',
  'locations.saveFailed': 'Помилка збереження локації. Спробуйте ще раз.',
  'locations.deleteFailed': 'Помилка видалення локації. Спробуйте ще раз.',
  'locations.deleteTitle': 'Видалення локації',
  'locations.deleteMessage': 'Ви впевнені? Цю дію неможливо скасувати.',
  'locations.companyDetailsHint': 'Реквізити компанії (для накладних та документів)',
  'locations.officialNameLabel': 'Офіційна назва',
  'locations.officialNamePlaceholder': 'ТОВ "Назва" / ФОП Прізвище І.І.',
  'locations.edrpouLabel': 'ЄДРПОУ / ІПН',
  'locations.edrpouShort': 'ЄДРПОУ',
  'locations.bankAccountLabel': 'Банківський рахунок (IBAN)',
  'locations.bankNameLabel': 'Назва банку',
  'locations.bankNamePlaceholder': 'АТ "ПриватБанк"',

  // ── Users page ──
  'users.title': 'Користувачі',
  'users.subtitle': 'Управління користувачами системи',
  'users.usersCount': 'Користувачів',
  'users.addUser': 'Додати користувача',
  'users.limitReached': 'Досягнуто ліміт користувачів вашого тарифного плану. Оновіть план для додавання.',
  'users.newUser': 'Новий користувач',
  'users.editUser': 'Редагувати користувача',
  'users.noUsers': 'Користувачів ще немає',
  'users.thName': "Ім'я",
  'users.thEmail': 'Email',
  'users.thRole': 'Роль',
  'users.thStaff': 'Співробітник',
  'users.thActions': 'Дії',
  'users.nameLabel': "Ім'я",
  'users.namePlaceholder': "Введіть ім'я...",
  'users.emailLabel': 'Email',
  'users.passwordLabel': 'Пароль',
  'users.passwordPlaceholder': 'Мінімум 6 символів',
  'users.passwordMin': 'Пароль мінімум 6 символів',
  'users.roleLabel': 'Роль',
  'users.selectRole': 'Оберіть роль',
  'users.selectRoleOption': '— Оберіть роль —',
  'users.showPassword': 'Показати пароль',
  'users.hidePassword': 'Сховати пароль',
  'users.enterName': "Введіть ім'я",
  'users.enterEmail': 'Введіть email',
  'users.emailAlreadyUsed': 'Цей email вже використовується',
  'users.error': 'Помилка',
  'users.edit': 'Редагувати',
  'users.delete': 'Видалити',
  'users.confirmDelete': 'Ви впевнені, що хочете видалити цього користувача?',
  'users.yes': 'Так',
  'users.no': 'Ні',
  'users.staffBinding': "Прив'язка до співробітника",
  'users.noStaffBinding': '— Немає —',
  'users.noPosition': 'без посади',
  'users.staffBindingHint': "Прив'яжіть користувача до співробітника для розрахунку зарплати та графіку роботи",
  'users.viewScope': 'Видимість даних',
  'users.viewScopeAll': 'Показувати всі записи та замовлення',
  'users.viewScopeOwn': 'Показувати лише власні',
  'users.viewScopeHint': '"Лише власні" — користувач бачитиме тільки свої записи, замовлення та продажі',
  'users.createWarning': 'Увага: після створення користувача вас може бути розлогінено. Просто увійдіть знову.',

  // ── Roles page ──
  'roles.title': 'Ролі',
  'roles.subtitle': 'Управління ролями та правами доступу',
  'roles.rolesCount': 'Ролей',
  'roles.addRole': 'Додати роль',
  'roles.noRoles': 'Ролей ще немає.',
  'roles.systemBadge': 'Системна',
  'roles.permsOf': 'прав',
  'roles.newRole': 'Нова роль',
  'roles.editRole': 'Редагувати роль',
  'roles.roleName': 'Назва ролі',
  'roles.roleNamePlaceholder': 'Наприклад: Адміністратор, Менеджер, Майстер',
  'roles.nameDuplicate': 'Роль з такою назвою вже існує',
  'roles.permissions': 'Права доступу',
  'roles.confirmDelete': 'Видалити?',
  'roles.cannotDelete': 'Неможливо видалити роль',
  'roles.usersAssigned': 'користувачів з цією роллю',
  'roles.groupClients': 'Клієнти',
  'roles.groupStaff': 'Персонал',
  'roles.groupCalendar': 'Календар',
  'roles.groupSales': 'Продажі',
  'roles.groupInventory': 'Склад',
  'roles.groupLoyalty': 'Лояльність',
  'roles.groupSalary': 'Зарплати',
  'roles.groupFinances': 'Фінанси та аналітика',
  'roles.groupCommunication': 'Комунікації',
  'roles.groupTasks': 'Задачі',
  'roles.fullAccess': 'Повний доступ',
  'roles.adminFullAccessNote': 'Адміністратор завжди має повний доступ — це власник акаунта, а не набір дозволів. Щоб обмежити людину, створіть окрему роль: там перемикачі працюють.',
  'roles.groupSettings': 'Налаштування',
  'roles.groupSystem': 'Система',
  // Clients
  'roles.permClientsView': 'Перегляд клієнтів',
  'roles.permClientsEdit': 'Редагування клієнтів',
  'roles.permClientsDelete': 'Видалення клієнтів',
  'roles.permClientsCategories': 'Категорії клієнтів',
  'roles.permClientsDocuments': 'Документи клієнтів',
  'roles.permDocumentsTemplates': 'Шаблони документів',
  // Staff
  'roles.permStaffView': 'Перегляд співробітників',
  'roles.permStaffEdit': 'Редагування співробітників',
  'roles.permScheduleView': 'Розклад роботи',
  'roles.permScheduleEdit': 'Шаблони розкладів',
  'roles.permServicesView': 'Перегляд послуг',
  'roles.permServicesEdit': 'Редагування послуг',
  // Calendar
  'roles.permCalendarView': 'Перегляд календаря',
  'roles.permCalendarCreate': 'Створення записів',
  'roles.permCalendarEdit': 'Редагування записів',
  // Sales
  'roles.permPosSell': 'Магазин (POS)',
  'roles.permOrdersView': 'Замовлення (перегляд)',
  'roles.permOrdersCreate': 'Замовлення (створення)',
  'roles.permOrdersEdit': 'Замовлення (редагування)',
  // Inventory
  'roles.permInvView': 'Номенклатура та залишки',
  'roles.permInvPurchases': 'Закупівлі',
  'roles.permInvMovements': 'Рух товарів',
  'roles.permProductionView': 'Перегляд виробництва',
  'roles.permProductionCreate': 'Створення виробництва',
  // Loyalty
  'roles.permLoyaltyView': 'Перегляд програм лояльності',
  'roles.permLoyaltyEdit': 'Редагування програм лояльності',
  // Salary
  'roles.permSalaryView': 'Розрахунок зарплат',
  'roles.permSalaryEdit': 'Схеми мотивації',
  // Finances
  'roles.permFinancesView': 'Перегляд фінансів',
  'roles.permCashRegister': 'Каса (Checkbox)',
  'roles.permReportsView': 'Звіти',
  'roles.permFinancialResult': 'Фін. результат',
  'roles.permBusinessMonitor': 'Монітор бізнесу',
  // Communication
  'roles.permCommunicationView': 'Повідомлення',
  'roles.permCommSettingsEdit': 'Налаштування комунікацій',
  'roles.permTasksView': 'Свої задачі',
  'roles.permTasksViewAll': 'Усі задачі компанії',
  'roles.permTasksCreate': 'Створення задач',
  'roles.permTasksAssign': 'Призначення виконавців',
  'roles.permTasksEditAll': 'Редагування чужих задач',
  'roles.permTasksManage': 'Шаблони й автоматизації',
  'roles.permTasksReports': 'Звіти по задачах',
  'roles.permProjectsManage': 'Керування проєктами',
  'nav.projects': 'Проєкти',
  // Settings
  'roles.permSettingsLocations': 'Локації',
  'roles.permSettingsBooking': 'Онлайн бронювання',
  'roles.permSettingsIntegrations': 'Інтеграції',
  'roles.permSettingsTariffs': 'Тарифні плани',
  // System
  'roles.permManageUsers': 'Користувачі',
  'roles.permManageRoles': 'Ролі',
  'roles.permAuditLog': 'Аудит-лог',

  // ── Auto-notifications ──
  'notifAuto.title': 'Налаштування комунікацій',
  'notifAuto.subtitle': 'Пріоритет каналів, автоматичні повідомлення та нагадування',
  'notifAuto.navItem': 'Налаштування комунікацій',
  'notifAuto.sectionDefaultPriority': 'Дефолтний пріоритет для ручних повідомлень',
  'notifAuto.defaultPriorityHint': 'Коли адмін пише клієнту в «Комунікації» вперше, обирається перший доступний канал із цього списку; далі підставляється канал, яким цьому клієнту писали востаннє. Перетягни для зміни порядку, вимкни непотрібні.',
  'notifAuto.sectionBooking': 'Повідомлення про створення запису на послуги',
  'notifAuto.sectionOrder': 'Повідомлення про створення замовлення на товари',
  'notifAuto.enable': 'Увімкнути',
  'notifAuto.mode': 'Режим доставки',
  'notifAuto.modePriority': 'Пріоритет (перший доступний канал)',
  'notifAuto.modeAll': 'Усі канали одночасно',
  'notifAuto.channelsOrder': 'Пріоритет каналів (перетягуйте для зміни порядку)',
  'notifAuto.channelsEmpty': 'Жоден канал не увімкнено — увімкніть хоча б один нижче',
  'notifAuto.otherChannels': 'Інші канали',
  'notifAuto.dragHint': 'Перетягніть для зміни порядку',
  'notifAuto.channelNotConfigured': 'Канал не налаштований у відповідному розділі — повідомлення не буде надіслано',
  'notifAuto.channelTelegram': 'Telegram',
  'notifAuto.channelSms': 'SMS',
  'notifAuto.channelEmail': 'Email',
  'notifAuto.channelWeb': 'Чат на сайті',
  'notifAuto.template': 'Шаблон повідомлення',
  'notifAuto.templateHint': 'Доступні змінні: {clientName}, {date}, {time}, {serviceName}, {staffName}, {locationName}, {phone}, {orderNumber}, {total}, {items}',
  'notifAuto.templateHtmlNote': 'Підтримує HTML для Telegram/Email; для SMS — автоматично конвертується в простий текст',
  'notifAuto.preview': 'Превʼю',
  'notifAuto.previewHint': 'Приклад з тестовими даними',
  'notifAuto.save': 'Зберегти',
  'notifAuto.saved': 'Налаштування збережено',
  'notifAuto.moveUp': 'Вище',
  'notifAuto.moveDown': 'Нижче',
  'notifAuto.defaultBookingTemplate': 'Вітаємо, {clientName}! Ваш запис підтверджено на {date} о {time}. Послуга: {serviceName}, майстер: {staffName}. Чекаємо на вас!',
  'notifAuto.defaultOrderTemplate': 'Дякуємо за замовлення #{orderNumber} на суму {total} ₴. Звʼяжемось з вами для підтвердження доставки.',
  'notifAuto.sectionReminders': 'Нагадування перед візитом',
  'notifAuto.remindersHint': 'Можна додати кілька правил з різними інтервалами (наприклад, за 24 години та за 2 години). Мінімум — 1 година.',
  'notifAuto.noReminders': 'Нагадувань ще не налаштовано',
  'notifAuto.addReminder': 'Додати нагадування',
  'notifAuto.removeReminder': 'Видалити нагадування',
  'notifAuto.hoursBefore': 'За скільки до візиту',
  'notifAuto.hoursBeforeUnit': 'годин',
  'notifAuto.defaultReminderTemplate': 'Нагадуємо: ваш візит {date} о {time}. Послуга: {serviceName}, майстер: {staffName}. Чекаємо на вас!',
  'notifAuto.timezone': 'Часовий пояс',
  'notifAuto.timezoneHint': 'Визначає час розсилки нагадувань',
  'notifAuto.tzKyiv': 'Київ (UTC+2/+3)',
  'notifAuto.tzWarsaw': 'Варшава (UTC+1/+2)',
  'notifAuto.tzBerlin': 'Берлін (UTC+1/+2)',
  'notifAuto.tzParis': 'Париж (UTC+1/+2)',
  'notifAuto.tzLondon': 'Лондон (UTC+0/+1)',
  'notifAuto.tzMadrid': 'Мадрид (UTC+1/+2)',
  'notifAuto.tzRome': 'Рим (UTC+1/+2)',
  'notifAuto.tzNewYork': 'Нью-Йорк (UTC-5/-4)',

  'errors.rateLimited': 'Забагато запитів. Спробуйте через {seconds} с 🙂',
  'errors.serverError': 'Помилка сервера. Спробуйте ще раз за мить',
  'errors.networkError': 'Немає з\'єднання. Перевірте інтернет',

  // ── Communication page ──
  'comm.title': 'Комунікація',
  'comm.filterAll': 'Всі',
  'comm.sendingVia': 'Поточний канал: {channel}',
  'comm.channelWeb': 'Чат на сайті',
  'comm.anonymousVisitor': 'Анонімний відвідувач',
  'comm.deletedVisitor': 'Видалений відвідувач',
  'comm.noChannelsForClient': 'У клієнта немає підключених каналів зв\'язку',
  'comm.addContactToCard': 'Додайте телефон або email у картці клієнта, або надішліть йому посилання на Telegram-бот',
  'comm.subtitle': "Повідомлення та зв'язок з клієнтами",
  'comm.searchPlaceholder': 'Пошук клієнта...',
  'comm.allClients': 'Всі клієнти',
  'comm.nothingFound': 'Нічого не знайдено',
  'comm.noConnectedClients': 'Немає підключених клієнтів',
  'comm.you': 'Ви: ',
  'comm.noMessages': 'Немає повідомлень',
  'comm.noHistory': 'Немає історії',
  'comm.selectChat': 'Оберіть чат',
  'comm.selectChatHint': 'Виберіть клієнта зліва для початку комунікації',
  'comm.telegramNotConnected': 'Telegram не підключено',
  'comm.smsNotConfigured': 'SMS-шлюз не налаштовано',
  'comm.clientNoPhone': 'У клієнта немає номера телефону',
  'comm.noPhone': 'Немає телефону',
  'comm.emailNotConfigured': 'Email не налаштовано',
  'comm.clientNoEmail': 'У клієнта немає email-адреси',
  'comm.noEmail': 'Немає email',
  'comm.defaultSubject': 'Повідомлення',
  'comm.emailSent': 'Email надіслано',
  'comm.smsSent': 'SMS надіслано',
  'comm.messageSent': 'Повідомлення надіслано',
  'comm.error': 'Помилка: ',
  'comm.linkCopied': 'Посилання скопійовано',
  'comm.yesterday': 'Вчора',
  'comm.clientNoTelegram': 'Клієнт ще не підключив Telegram',
  'comm.sendBotLink': 'Надішліть це посилання клієнту:',
  'comm.copy': 'Копіювати',
  'comm.sendSmsInstead': 'Надіслати SMS замість',
  'comm.botNotConfigured': 'Telegram бот не налаштований',
  'comm.configureTelegram': 'Налаштуйте в Система → Telegram нагадування',
  'comm.configureSms': 'Налаштуйте в Система → SMS-розсилка',
  'comm.addPhoneToCard': 'Додайте номер телефону в картку клієнта',
  'comm.configureEmail': 'Налаштуйте в Система → Email-розсилка',
  'comm.addEmailToCard': 'Додайте email в картку клієнта',
  'comm.noMessagesYet': 'Повідомлень ще немає. Напишіть першим!',
  'comm.openAttachment': 'Відкрити вкладення',
  'comm.seen': 'Переглянуто',
  'comm.igWindowHuman': 'Від останнього повідомлення клієнта минуло понад 24 години. Instagram прийме відповідь лише як відповідь оператора (до 7 днів) — якщо Meta це дозволила. Не пройде — напишіть із застосунку Instagram, копія зʼявиться тут.',
  'comm.igWindowClosed': 'Від останнього повідомлення клієнта минуло понад 7 днів — через CRM Instagram відповідь не прийме. Напишіть із застосунку Instagram (копія зʼявиться тут) або іншим каналом.',
  'comm.igOutsideWindow': 'Instagram не прийняв повідомлення: від останнього повідомлення клієнта минуло понад 24 години. Напишіть із застосунку Instagram (копія зʼявиться тут) або іншим каналом.',
  'comm.sentFromApp': 'з Instagram',
  'comm.sentFromAppHint': 'Надіслано не з CRM: із застосунку Instagram або Meta Business Suite',
  'comm.botLabel': 'Бот',
  'comm.pressed': 'Натиснув',
  'comm.saveAsCustomer': 'Зберегти як картку клієнта',
  'comm.cardCreatedNotLinked': 'Картку створено, але тред не привʼязано',
  'comm.clientReaction': 'Реакція клієнта',
  'comm.yourReaction': 'Ваша реакція',
  'comm.reactHeart': 'Поставити серце',
  'comm.unreactHeart': 'Прибрати серце',
  'comm.reactFailed': 'Не вдалося поставити реакцію',
  'comm.attachHintWeb': 'Листування переїде на картку клієнта разом з історією; наступні повідомлення з цього чату теж лягатимуть на картку.',
  'comm.createCardFromVisitor': 'Створити картку з даних відвідувача',
  'comm.cardCreated': 'Картку створено',
  'comm.showOlder': 'Показати раніші',
  'comm.emailSubjectPlaceholder': 'Тема листа...',
  'comm.emailPlaceholder': 'Текст листа...',
  'comm.smsPlaceholder': 'Написати SMS...',
  'comm.messagePlaceholder': 'Написати повідомлення...',
  'comm.sendEnter': 'Надіслати (Enter)',

  // ── Orders ──
  'orders.title': 'Замовлення',
  'orders.subtitle': 'Продаж товарів',
  'orders.statTotal': 'Всього',
  'orders.statusNew': 'Нові',
  'orders.statusPaid': 'Оплачені',
  'orders.searchPlaceholder': 'Пошук за клієнтом або товаром...',
  'orders.filterAll': 'Всі',
  'orders.status_new': 'Новий',
  'orders.status_confirmed': 'Підтверджений',
  'orders.status_packed': 'Запакований',
  'orders.status_shipped': 'Відправлений',
  'orders.status_delivered': 'Отримано',
  'orders.status_cancelled': 'Скасований',
  'orders.periodAll': 'Всі',
  'orders.periodWeek': 'Тиждень',
  'orders.periodMonth': 'Місяць',
  'orders.periodYear': 'Рік',
  'orders.periodCustom': 'Довільний',
  'orders.newOrder': 'Нове замовлення',
  'orders.editOrder': 'Редагувати замовлення',
  'orders.emptyTitle': 'Замовлень поки немає',
  'orders.emptyHint': 'Створіть перше замовлення на продаж товарів',
  'orders.pos': 'поз.',
  'orders.discount': 'Знижка',
  'orders.total': 'Разом',
  'orders.pay_unpaid': 'Не оплачено',
  'orders.pay_partial': 'Частково',
  'orders.pay_paid': 'Оплачено',
  'orders.pay_refunded': 'Повернення',
  'orders.refund': 'Повернути',
  'orders.refunded': 'Кошти повернено',
  'orders.refundTitle': 'Повернення коштів',
  'orders.refundMessage': 'Повернути клієнту {amount} ₴?',
  'orders.refundWarning': 'Буде створена транзакція повернення',
  'orders.refundDescription': 'Повернення за замовлення',
  'orders.confirmRefund': 'Підтвердити повернення',
  'orders.refundAmountLabel': 'Сума повернення коштів',
  'orders.paidOf': 'Оплачено {paid} з {total} ₴',
  'orders.payRemaining': 'Доплатити',
  'orders.payAmountLabel': 'Сума оплати',
  'orders.fullAmount': 'повна сума',
  'orders.returnProducts': 'Повернути товар',
  'orders.returnTitle': 'Повернення товару',
  'orders.returnHint': 'Вкажіть кількість товарів для повернення на склад',
  'orders.confirmReturn': 'Підтвердити повернення',
  'orders.returnFrom': 'Повернення з замовлення',
  'orders.fullyReturned': 'Повернуто',
  'orders.partiallyReturned': 'Частк. поверн.',
  'orders.statusReturned': 'Повернуто',
  'orders.action_confirmed': 'Підтвердити',
  'orders.action_packed': 'Запакувати',
  'orders.action_shipped': 'Відправити',
  'orders.action_delivered': 'Отримано',
  'orders.action_cancelled': 'Скасувати',
  'orders.markPaid': 'Оплатити',
  'orders.payBtn': 'Оплатити',
  'orders.cashGiven': 'Клієнт дав',
  'orders.change': 'Решта',
  'orders.notEnough': 'Не вистачає',
  'orders.confirmPayment': 'Підтвердити оплату',
  'orders.back': 'Назад',
  'orders.edit': 'Редагувати',
  'orders.errCustomerName': 'Вкажіть ім\'я клієнта',
  'orders.errItems': 'Додайте хоча б один товар',
  'orders.errWarehouse': 'Оберіть склад',
  'orders.errStockInsufficient': 'Недостатньо товару на складі',
  'orders.errNegPrice': 'Ціна не може бути від\'ємною',
  'orders.errQuantity': 'Вкажіть кількість для обраних товарів',
  'orders.inStock': 'На складі',
  'orders.available': 'доступно',
  'orders.needed': 'потрібно',
  'orders.paymentDescription': 'Продаж товарів',
  'orders.fiscalError': 'Помилка створення фіскального чека. Оплату не проведено',
  'orders.terminalError': 'Помилка оплати через термінал',
  'orders.fiscalReturnError': 'Помилка створення фіскального чека повернення',
  'orders.sectionCustomer': 'Клієнт',
  'orders.sectionProducts': 'Товари',
  'orders.sectionPayment': 'Оплата',
  'orders.labelName': 'Ім\'я',
  'orders.namePlaceholder': 'Ім\'я клієнта',
  'orders.labelPhone': 'Телефон',
  'orders.labelTariff': 'Тарифний план',
  'orders.standardPrice': 'Стандартна ціна',
  'orders.labelEmail': 'Email',
  'orders.labelWarehouse': 'Склад',
  'orders.selectWarehouse': 'Оберіть склад',
  'orders.labelPaymentMethod': 'Спосіб оплати',
  'orders.pm_cash': 'Готівка',
  'orders.pm_terminal': 'Термінал',
  'orders.pm_transfer': 'Переказ',
  'orders.pm_online': 'Онлайн',
  'orders.selectProduct': 'Оберіть товар',
  'orders.qty': 'Кількість',
  'orders.price': 'Ціна',
  'orders.addItem': 'Додати товар',
  'orders.colProduct': 'Товар',
  'orders.colWarehouse': 'Склад',
  'orders.colQty': 'К-ть',
  'orders.colPrice': 'Ціна',
  'orders.colDiscount': 'Знижка',
  'orders.colSum': 'Сума',
  'orders.labelDiscount': 'Знижка (₴)',
  'orders.labelNote': 'Примітка',
  'orders.notePlaceholder': 'Коментар до замовлення...',
  'orders.cancel': 'Скасувати',
  'orders.save': 'Зберегти',
  'orders.saving': 'Збереження…',
  'orders.searchProduct': 'Пошук товару...',
  'orders.noProducts': 'Товарів не знайдено',
  'orders.changeProduct': 'Змінити товар',
  'orders.noWarehouse': 'Немає складу з залишками',
  'orders.noCategory': 'Без категорії',
  'orders.printInvoice': 'Накладна',
  'orders.printBill': 'Рахунок',
  'orders.sectionShipping': 'Доставка',
  'orders.labelShippingMethod': 'Спосіб доставки',
  'orders.labelShippingAddress': 'Адреса доставки',
  'orders.shippingNone': 'Без доставки (самовивіз)',
  'orders.shippingNP': 'Нова Пошта',
  'orders.shippingMeest': 'Meest Express',
  'orders.shippingPickup': 'Самовивіз',
  'orders.shippingCourier': 'Кур\'єр',
  'orders.shippingOther': 'Інше',
  'orders.shipping_novaposhta': 'Нова Пошта',
  'orders.shipping_meest': 'Meest Express',
  'orders.meestCity': 'Місто (Meest)',
  'orders.meestCityPlaceholder': 'Введіть назву міста',
  'orders.meestBranch': 'Відділення (Meest)',
  'orders.meestBranchPlaceholder': 'Пошук відділення',
  'orders.meestBranchSearchPlaceholder': 'Місто, назва або номер відділення',
  'orders.meestTracking': 'Номер відправки Meest',
  'orders.meestTrackingPlaceholder': 'Заповниться автоматично',
  'orders.meestDeliveryTo': 'Доставка Meest',
  'orders.meestCreateParcel': 'Створити відправку Meest',
  'orders.meestParcelCreated': 'Відправку Meest створено',
  'orders.meestParcelError': 'Помилка створення відправки Meest',
  'orders.meestSettingsRequired': 'Налаштуйте Meest Express в розділі Інтеграції',
  'orders.meestAddressRequired': 'Оберіть місто та відділення Meest',
  'orders.meestAll': 'Всі',
  'orders.meestOffice': 'Відділення',
  'orders.meestParcelLocker': 'Поштомати',
  'orders.npCodConfirmTitle': 'Створення ТТН Нова Пошта',
  'orders.meestCodConfirmTitle': 'Створення відправки Meest',
  'orders.codChoiceMessage': 'Замовлення не оплачене. Є можливість створити доставку з післяплатою.',
  'orders.codWithCod': 'Так, з післяплатою',
  'orders.codWithoutCod': 'Ні, без післяплати',
  'orders.codCancel': 'Скасувати створення накладної',
  'orders.shipping_pickup': 'Самовивіз',
  'orders.shipping_courier': 'Кур\'єр',
  'orders.shipping_other': 'Інша доставка',
  'orders.npCity': 'Місто',
  'orders.npCityPlaceholder': 'Введіть назву міста...',
  'orders.npWarehouse': 'Відділення / поштомат',
  'orders.npWarehousePlaceholder': 'Пошук відділення...',
  'orders.npTTN': 'Номер ТТН',
  'orders.npTTNPlaceholder': 'Номер експрес-накладної',
  'orders.npTrack': 'Відстежити',
  'orders.npStatus': 'Статус',
  'orders.npFrom': 'Звідки',
  'orders.npTo': 'Куди',
  'orders.npDeliveryTo': 'Доставка',
  'orders.npDeliveryDate': 'Дата доставки',
  'orders.npTTNOnlyPacked': 'ТТН можна створити лише зі статусу «Запаковано»',
  'orders.npSyncTracking': 'Оновити трекінг',
  'orders.npSyncing': 'Синхронізація...',
  'orders.npAutoSyncActive': 'Статус оновиться автоматично через Нову Пошту',
  'orders.meestAutoSyncActive': 'Статус оновиться автоматично через Meest Express',
  'orders.addressPlaceholder': 'Адреса доставки...',
  'orders.courierAddressPlaceholder': 'Адреса для кур\'єра...',
  'orders.npSettingsRequired': 'Спершу налаштуйте Нову Пошту в Система → Нова Пошта',
  'orders.npResaveSettings': 'Перезбережіть налаштування Нової Пошти (Система → Нова Пошта → Зберегти), щоб оновити дані відправника.',
  'orders.npMissingFields': 'Не вистачає даних для створення ТТН. Перейдіть в Система → Нова Пошта та перезбережіть. Відсутні поля',
  'orders.npAddressRequired': 'Вкажіть місто та відділення НП в замовленні',
  'orders.npRecipientRequired': 'Вкажіть ім\'я та телефон отримувача',
  'orders.npCreateTTN': 'Створити ТТН',
  'orders.npTTNCreated': 'ТТН створено',
  'orders.npTTNError': 'Помилка створення ТТН',
  'orders.npPrintSticker': 'Друк стікера',
  'orders.npDeliveryPriceLabel': 'Орієнтовна вартість доставки',
  'orders.npUAH': 'грн',
  'orders.npCalcPrice': 'Розрахунок вартості',
  'orders.author': 'Автор',
  'invoice.title': 'Видаткова накладна',
  'invoice.date': 'Дата',
  'invoice.status': 'Статус',
  'invoice.customer': 'Покупець',
  'invoice.note': 'Примітка',
  'invoice.items': 'Товари',
  'invoice.product': 'Найменування',
  'invoice.unit': 'Од.',
  'invoice.qty': 'К-ть',
  'invoice.price': 'Ціна',
  'invoice.discountCol': 'Знижка',
  'invoice.sum': 'Сума',
  'invoice.discount': 'Знижка',
  'invoice.total': 'Разом',
  'invoice.paid': 'Оплачено',
  'invoice.remaining': 'Залишок',
  'invoice.seller': 'Продавець',
  'invoice.bankAccount': 'Р/р',
  'invoice.sellerSign': 'Підпис продавця',
  'invoice.buyerSign': 'Підпис покупця',
  'invoice.pcs': 'шт',

  // ── Bill (Рахунок) ──
  'bill.title': 'Рахунок на оплату',
  'bill.amountDue': 'До сплати',
  'bill.payTo': 'Реквізити для оплати',
  'bill.service': 'послуга',
  'bill.itemName': 'Найменування',

  // ── Services: default materials ──
  'services.materials': 'Матеріали',
  'services.hasMaterials': 'Є матеріали за замовчуванням',
  'services.defaultMaterials': 'Матеріали за замовчуванням',
  'services.defaultMaterialsHint': 'Ці матеріали будуть автоматично додані при виборі послуги в записі',
  'services.addMaterial': 'Додати матеріал',
  'services.noProductsAvailable': 'Немає доступних товарів',

  // ── Navigation ──
  'nav.production': 'Виробництво',

  // ── Production ──
  'production.title': 'Виробництво',
  'production.subtitle': 'Специфікації та операції',
  'production.recipesCount': 'Специфікацій',
  'production.operationsCount': 'Операцій',
  'production.tab_recipes': 'Специфікації',
  'production.tab_produce': 'Виробити',
  'production.tab_history': 'Історія',
  'production.newRecipe': 'Нова специфікація',
  'production.newProduction': 'Нова операція',
  'production.searchRecipes': 'Пошук специфікацій...',
  'production.searchHistory': 'Пошук в історії...',
  'production.noRecipes': 'Специфікацій поки немає',
  'production.noRecipesHint': 'Створіть специфікацію для виробництва продукції з сировини',
  'production.createRecipeFirst': 'Спершу створіть специфікацію у вкладці "Специфікації"',
  'production.noHistory': 'Історія виробництва порожня',
  'production.output': 'Вихід',
  'production.inputs': 'Сировина',
  'production.produce': 'Виробити',
  'production.edit': 'Редагувати',
  'production.delete': 'Видалити',
  'production.stockOk': 'Є на складі',
  'production.stockLow': 'Не вистачає',
  'production.inputCost': 'Собівартість сировини',
  'production.unitCost': 'Собівартість одиниці',
  'production.uah': 'грн',
  'production.warehouse': 'Склад',
  'production.recipeName': 'Назва специфікації',
  'production.recipeNamePlaceholder': 'Напр. "Крем для рук 100мл"',
  'production.selectWarehouse': 'Оберіть склад',
  'production.noInputsYet': 'Додайте сировину для специфікації',
  'production.outputSection': 'Готовий продукт',
  'production.outputProduct': 'Товар на виході',
  'production.selectProduct': 'Оберіть товар',
  'production.outputQty': 'Кількість',
  'production.inputsSection': 'Сировина (витрати)',
  'production.addInput': 'Додати сировину',
  'production.searchProduct': 'Пошук товару...',
  'production.qty': 'К-сть',
  'production.cancel': 'Скасувати',
  'production.save': 'Зберегти',
  'production.create': 'Створити',
  'production.editRecipe': 'Редагувати специфікацію',
  'production.recipeCreated': 'Специфікацію створено',
  'production.recipeUpdated': 'Специфікацію оновлено',
  'production.recipeDeleted': 'Специфікацію видалено',
  'production.cannotDeleteRecipe': 'Неможливо видалити специфікацію — вона вже використовувалась у виробництві',
  'production.executeProduction': 'Виконати виробництво',
  'production.selectRecipeLabel': 'Специфікація',
  'production.selectRecipe': 'Оберіть специфікацію',
  'production.multiplier': 'Множник (кількість партій)',
  'production.preview': 'Попередній перегляд',
  'production.willConsume': 'Буде витрачено',
  'production.willProduce': 'Буде вироблено',
  'production.need': 'потрібно',
  'production.available': 'є',
  'production.note': 'Примітка',
  'production.notePlaceholder': 'Коментар до операції',
  'production.executeProduce': 'Виробити',
  'production.produced': 'Вироблено: {qty} × {name}',
  'production.errNameRequired': 'Вкажіть назву специфікації',
  'production.errOutputRequired': 'Оберіть вихідний товар',
  'production.errInputsRequired': 'Додайте хоча б одну сировину',
  'production.errOutputInInputs': 'Вихідний товар не може бути серед сировини',
  'production.errSelectRecipe': 'Оберіть специфікацію',
  'production.errSelectWarehouse': 'Оберіть склад',
  'production.errMultiplier': 'Множник має бути >= 1',
  'production.cancelTitle': 'Скасування виробництва',
  'production.cancelMessage': 'Скасувати виробництво "{name}" ×{qty}?',
  'production.cancelDescription': 'Вироблений товар буде списано зі складу, сировина — повернута',
  'production.cancelWarning': 'Цю дію неможливо скасувати',
  'production.confirmCancel': 'Підтвердити скасування',
  'production.cancelledLabel': 'Скасовано',
  'production.cancelBtn': 'Скасувати',
  'production.alreadyCancelled': 'Це виробництво вже скасовано',
  'production.cancelNotEnoughStock': 'Неможливо скасувати — на складі залишилось {available} з {needed} одиниць. Товар вже було відвантажено.',
  'production.cancelNote': 'Скасування виробництва',
  'production.cancelledSuccess': 'Виробництво скасовано',
  'production.cancelLookupError': 'Не вдалося прочитати рухи складу — скасування не виконано',

  // ── Inventory movements: production types ──
  'invMov.typeProductionOut': 'Виробництво (витрата)',
  'invMov.typeProductionIn': 'Виробництво (вихід)',
  'invMov.filterProduction': 'Виробництво',

  // ── Navigation: audit log ──
  'nav.auditLog': 'Аудит-лог',

  // ── Audit Log ──
  'auditLog.title': 'Аудит-лог',
  'auditLog.dateTime': 'Дата і час',
  'auditLog.user': 'Користувач',
  'auditLog.action': 'Дія',
  'auditLog.collection': 'Розділ',
  'auditLog.documentId': 'ID документа',
  'auditLog.document': 'Документ',
  'auditLog.details': 'Деталі',
  'auditLog.actionCreate': 'Створення',
  'auditLog.actionUpdate': 'Зміна',
  'auditLog.actionDelete': 'Видалення',
  'auditLog.filterCollection': 'Розділ',
  'auditLog.filterAction': 'Дія',
  'auditLog.filterFrom': 'Від',
  'auditLog.filterTo': 'До',
  'auditLog.allCollections': 'Всі розділи',
  'auditLog.allActions': 'Всі дії',
  'auditLog.noEntries': 'Записів не знайдено',
  'auditLog.loadMore': 'Завантажити ще',
  'auditLog.changes': 'Зміни',
  'auditLog.field': 'Поле',
  'auditLog.oldValue': 'Було',
  'auditLog.newValue': 'Стало',
  'auditLog.deletedData': 'Видалені дані',
  'auditLog.newRecord': 'Створено новий запис',
  'auditLog.fieldsChanged': 'полів змінено',
  'auditLog.colCustomers': 'Клієнти',
  'auditLog.colStaff': 'Співробітники',
  'auditLog.colAppointments': 'Записи',
  'auditLog.colTransactions': 'Транзакції',
  'auditLog.colOrders': 'Замовлення',
  'auditLog.colProducts': 'Товари',
  'auditLog.colStock': 'Залишки',
  'auditLog.colStockMovements': 'Рух товарів',
  'auditLog.colServices': 'Послуги',
  'auditLog.colCategories': 'Категорії',
  'auditLog.colLocations': 'Локації',
  'auditLog.colRoles': 'Ролі',
  'auditLog.colUsers': 'Користувачі',
  'auditLog.colSalaryHistory': 'Історія зарплат',
  'auditLog.colSalarySchemes': 'Схеми мотивації',
  'auditLog.colFixedExpenses': 'Фіксовані витрати',
  'auditLog.colWarehouses': 'Склади',
  'auditLog.colScheduleTemplates': 'Шаблони розкладів',
  'auditLog.colCashShifts': 'Касові зміни',
  'auditLog.colProductions': 'Виробництво',
  'auditLog.colTechCards': 'Тех. карти',
  'auditLog.colCustomerComments': 'Коментарі клієнтів',

  // ── Loyalty (4 modules) ──
  'nav.loyalty': 'Програми лояльності',
  'loyalty.title': 'Програми лояльності',
  'loyalty.subtitle': 'Бали, рівні, промокоди та абонементи',
  'custModal.tabLoyalty': 'Лояльність',

  // Tabs
  'loyalty.tabPoints': 'Бали',
  'loyalty.tabTiers': 'Рівні',
  'loyalty.tabCoupons': 'Промокоди',
  'loyalty.tabSubscriptions': 'Абонементи',
  'loyalty.tabSettings': 'Налаштування',
  'loyalty.tabBalances': 'Баланси',
  'loyalty.tabHistory': 'Історія',
  'loyalty.tabTierOverview': 'Огляд клієнтів',
  'loyalty.tabPlans': 'Плани',
  'loyalty.tabPlansSettings': 'Налаштування планів',
  'loyalty.tabActiveSubs': 'Активні абонементи',

  // Common
  'loyalty.statMembers': 'учасників',
  'loyalty.statPoints': 'активних балів',
  'loyalty.saveSettings': 'Зберегти налаштування',
  'loyalty.saved': 'Налаштування збережено',
  'loyalty.searchCustomer': 'Пошук клієнта...',
  'loyalty.days': 'днів',
  'loyalty.pts': 'балів',
  'loyalty.cancel': 'Скасувати',
  'loyalty.colCustomer': 'Клієнт',
  'loyalty.colTier': 'Рівень',
  'loyalty.colBalance': 'Баланс',
  'loyalty.colTotalEarned': 'Нараховано',
  'loyalty.colTotalRedeemed': 'Списано',
  'loyalty.colTotalSpent': 'Витрачено',
  'loyalty.colDate': 'Дата',
  'loyalty.colType': 'Тип',
  'loyalty.colPoints': 'Бали',
  'loyalty.colNote': 'Примітка',
  'loyalty.colStatus': 'Статус',

  // Points module
  'loyalty.enablePoints': 'Увімкнути бальну програму',
  'loyalty.pointsDisabled': 'Бальна програма вимкнена',
  'loyalty.sectionEarning': 'Нарахування та списання',
  'loyalty.cashbackPercent': 'Кешбек балами',
  'loyalty.cashbackPercentHint': 'Відсоток від суми покупки, який повертається балами. 1 бал = 1 ₴',
  'loyalty.maxRedeemPercent': 'Макс. % оплати балами',
  'loyalty.maxRedeemPercentHint': 'Максимальна частка від суми замовлення, яку можна оплатити балами',
  'loyalty.sectionAutoBonuses': 'Автоматичні бонуси',
  'loyalty.birthdayBonus': 'Бонус на день народження',
  'loyalty.referralBonus': 'Реферальний бонус',
  'loyalty.inactivityDays': 'Днів неактивності',
  'loyalty.inactivityBonus': 'Бонус за повернення',
  'loyalty.noBalances': 'Ще немає учасників',
  'loyalty.noBalancesHint': 'Бали нараховуватимуться автоматично при оплаті',
  'loyalty.noHistory': 'Історія порожня',
  'loyalty.txEarn': 'Нарахування',
  'loyalty.txRedeem': 'Списання',
  'loyalty.txBirthday': 'День народження',
  'loyalty.txReferral': 'Реферал',
  'loyalty.txInactivity': 'Повернення',
  'loyalty.txManual': 'Вручну',
  'loyalty.sectionPoints': 'Бали',
  'loyalty.pointsBalance': 'балів',
  'loyalty.earned': 'нараховано',
  'loyalty.redeemed': 'списано',
  'loyalty.manualPlaceholder': '±балів',
  'loyalty.manualApply': 'Застосувати',
  'loyalty.manualAdd': 'Ручне нарахування',
  'loyalty.insufficientPoints': 'Недостатньо балів: на рахунку {n}',
  'loyalty.planHasSubscriptions': 'За цим планом уже продано абонементи — видалити його не можна.',
  'loyalty.planDeleteError': 'Не вдалося видалити план',
  'loyalty.redeemFailed': 'Не вдалося списати бали',
  'loyalty.manualDeduct': 'Ручне списання',
  'loyalty.history': 'Історія балів',
  'loyalty.noTransactions': 'Ще немає операцій з балами',

  // Tiers module
  'loyalty.enableTiers': 'Увімкнути програму рівнів',
  'loyalty.tiersDisabled': 'Програма рівнів вимкнена',
  'loyalty.tierPeriod': 'Період обліку',
  'loyalty.periodAllTime': 'Весь час',
  'loyalty.periodMonths': 'Останні {n} міс.',
  'loyalty.tierPeriodHint': 'За який період рахувати витрати для визначення рівня',
  'loyalty.sectionTiers': 'Рівні клієнтів',
  'loyalty.tiersHint': 'Знижка визначається автоматично за загальною сумою витрат клієнта',
  'loyalty.tierName': 'Назва',
  'loyalty.tierMinSpent': 'Мін. витрачено',
  'loyalty.tierDiscount': 'Знижка',
  'loyalty.tierLoadingBtn': 'Обчислюємо знижку',
  'loyalty.tierLoadingHint': 'Обчислюємо знижку за рівнем клієнта…',
  'loyalty.addTier': 'Додати рівень',
  'loyalty.noTierCustomers': 'Ще немає клієнтів з витратами',
  'loyalty.sectionTierStatus': 'Рівень клієнта',
  'loyalty.tierDiscountLabel': 'Знижка рівня',
  'loyalty.nextTier': 'Наступний рівень',

  // Coupons module
  'loyalty.enableCoupons': 'Увімкнути промокоди',
  'loyalty.couponsDisabled': 'Промокоди вимкнені',
  'loyalty.searchCoupon': 'Пошук промокоду...',
  'loyalty.addCoupon': 'Створити промокод',
  'loyalty.newCoupon': 'Новий промокод',
  'loyalty.editCoupon': 'Редагувати промокод',
  'loyalty.saveCoupon': 'Зберегти промокод',
  'loyalty.couponCode': 'Код',
  'loyalty.couponType': 'Тип знижки',
  'loyalty.couponPercent': 'Відсоток',
  'loyalty.couponFixed': 'Фіксована сума',
  'loyalty.couponValue': 'Розмір знижки',
  'loyalty.couponMinOrder': 'Мін. сума замовлення',
  'loyalty.couponMaxUses': 'Макс. використань',
  'loyalty.couponMaxUsesHint': '0 = без обмежень',
  'loyalty.couponExpiry': 'Дійсний до',
  'loyalty.couponUsed': 'Використано',
  'loyalty.generateCode': 'Генерувати',
  'loyalty.noCoupons': 'Ще немає промокодів',
  'loyalty.statusActive': 'Активний',
  'loyalty.statusInactive': 'Неактивний',
  'loyalty.statusExpired': 'Прострочений',
  'loyalty.statusMaxed': 'Вичерпано',

  // Subscriptions module
  'loyalty.enableSubscriptions': 'Увімкнути абонементи',
  'loyalty.subscriptionsDisabled': 'Абонементи вимкнені',
  'loyalty.disableConfirmTitle': 'Вимкнути програму?',
  'loyalty.disableConfirmMessage': 'Точно бажаєте вимкнути цю програму лояльності? Вона перестане діяти для клієнтів.',
  'loyalty.disableConfirm': 'Вимкнути',
  'loyalty.addPlan': 'Створити план',
  'loyalty.newPlan': 'Новий план',
  'loyalty.editPlan': 'Редагувати план',
  'loyalty.savePlan': 'Зберегти план',
  'loyalty.planName': 'Назва плану',
  'loyalty.planType': 'Тип',
  'loyalty.planTypeVisits': 'За кількістю візитів',
  'loyalty.planTypeTime': 'За часом',
  'loyalty.planTotalVisits': 'Кількість візитів',
  'loyalty.planValidDays': 'Термін дії',
  'loyalty.planPrice': 'Ціна',
  'loyalty.planServices': 'Послуги',
  'loyalty.planServicesHint': 'Оберіть послуги або залиште порожнім для всіх',
  'loyalty.allServices': 'Всі послуги',
  'loyalty.noPlans': 'Ще немає планів',
  'loyalty.visits': 'візитів',
  'loyalty.noActiveSubs': 'Ще немає активних абонементів',
  'loyalty.subVisits': 'Візити',
  'loyalty.subExpires': 'Закінчується',
  'loyalty.consumedVisitsTitle': 'Використані візити',
  'loyalty.noConsumedVisits': 'Ще немає використаних візитів',
  'loyalty.subStatus_active': 'Активний',
  'loyalty.subStatus_expired': 'Прострочений',
  'loyalty.subStatus_used_up': 'Вичерпано',
  'loyalty.sectionSubscriptions': 'Абонементи',
  'loyalty.sellSubscription': 'Продати абонемент',
  'loyalty.sellSubTitle': 'Продаж абонементу',
  'loyalty.selectCustomer': 'Оберіть клієнта',
  'loyalty.selectPlan': 'Оберіть план',
  'loyalty.confirmSell': 'Оформити',
  'loyalty.toPayment': 'До оплати',
  'loyalty.paymentTitle': 'Оплата абонементу',
  'loyalty.subSold': 'Абонемент успішно оформлено',
  'loyalty.refund': 'Повернення',
  'loyalty.refundConfirm': 'Повернути кошти за абонемент "{name}"? Абонемент буде деактивовано.',
  'loyalty.subRefunded': 'Кошти повернено, абонемент деактивовано',
  'loyalty.terminalError': 'Помилка оплати через термінал',
  'loyalty.fiscalError': 'Помилка створення фіскального чека. Оплату не проведено',
  'loyalty.fiscalReturnError': 'Помилка створення фіскального чека повернення',
  'loyalty.subStatus_refunded': 'Повернено',
  'loyalty.subPurchased': 'Придбано',
  'loyalty.subPrice': 'Вартість',
  'loyalty.noActiveModules': 'Немає активних програм лояльності',

  // ── Loyalty integration (checkout) ──
  'loyalty.usePoints': 'Використати бали',
  'loyalty.balance': 'Баланс',
  'loyalty.max': 'Макс.',
  'loyalty.apply': 'Застосувати',
  'loyalty.enterCoupon': 'Введіть промокод',
  'loyalty.couponNotFound': 'Промокод не знайдено',
  'loyalty.couponInvalid': 'Промокод недійсний',
  'loyalty.couponErr_not_found': 'Промокод не знайдено',
  'loyalty.couponErr_inactive': 'Промокод неактивний',
  'loyalty.couponErr_expired': 'Промокод прострочений',
  'loyalty.couponErr_maxed': 'Промокод вичерпано',
  'loyalty.couponErr_min_order': 'Сума менше мінімальної для промокоду',
  'loyalty.payBySubscription': 'Оплата абонементом',
  'loyalty.subscription': 'Абонемент',
  'loyalty.pointsRedeemed': 'Списання балів при оплаті',

  // ── Presence (real-time edit lock) ──
  'presence.editing': 'Цей запис зараз редагує',

  // ── Rozetka integration ──
  'rozetka.title': 'Rozetka Marketplace',
  'rozetka.subtitle': 'Інтеграція з маркетплейсом Rozetka для синхронізації замовлень',
  'rozetka.login': 'Логін (email продавця)',
  'rozetka.loginRequired': 'Вкажіть логін',
  'rozetka.password': 'Пароль',
  'rozetka.save': 'Зберегти',
  'rozetka.saved': 'Налаштування збережено',
  'rozetka.error': 'Помилка: ',
  'rozetka.testConnection': 'Тест підключення',
  'rozetka.testSuccess': 'Підключення успішне',
  'rozetka.testError': 'Помилка підключення',
  'rozetka.ordersCount': 'Замовлень',
  'rozetka.help': 'Для підключення потрібен обліковий запис продавця на Rozetka. Логін та пароль — ті самі, що для входу в кабінет продавця seller.rozetka.com.ua',

  // ── Prom.ua integration ──
  'prom.title': 'Prom.ua',
  'prom.subtitle': 'Інтеграція з маркетплейсом Prom.ua для синхронізації замовлень',
  'prom.apiToken': 'API токен',
  'prom.tokenRequired': 'Вкажіть API токен',
  'prom.save': 'Зберегти',
  'prom.saved': 'Налаштування збережено',
  'prom.error': 'Помилка: ',
  'prom.testConnection': 'Тест підключення',
  'prom.testSuccess': 'Підключення успішне',
  'prom.testError': 'Помилка підключення',
  'prom.help': 'Для отримання API токена: Кабінет продавця → Налаштування → Управління API-токенами. Створіть токен з правами на замовлення та товари.',

  // ── POS (швидкий продаж) ──
  'pos.title': 'Магазин',
  'pos.selectWarehouse': 'Оберіть склад',
  'pos.noWarehouseHint': 'Оберіть склад для початку продажу',
  'pos.tariffPlan': 'Тарифний план',
  'pos.standardPrice': 'Стандартна ціна',
  'pos.search': 'Пошук товару...',
  'pos.allCategories': 'Всі',
  'pos.outOfStock': 'Немає',
  'pos.noProducts': 'Товарів не знайдено',
  'pos.cart': 'Кошик',
  'pos.emptyCart': 'Кошик порожній',
  'pos.subtotal': 'Підсумок',
  'pos.discount': 'Знижка',
  'pos.loyaltyPoints': 'Бали лояльності',
  'pos.available': 'доступно',
  'pos.total': 'До сплати',
  'pos.coupon': 'Промокод',
  'pos.couponPlaceholder': 'Введіть промокод...',
  'pos.applyCoupon': 'Застосувати',
  'pos.invalidCoupon': 'Промокод недійсний або не знайдений',
  'pos.cash': 'Готівка',
  'pos.card': 'Картка',
  'pos.transfer': 'Переказ',
  'pos.cashGiven': 'Отримано',
  'pos.change': 'Решта',
  'pos.confirm': 'Підтвердити',
  'pos.saleComplete': 'Продаж завершено!',
  'pos.fiscalError': 'Помилка створення фіскального чека. Оплату не проведено',
  'pos.terminalError': 'Помилка оплати через термінал',
  'pos.fiscalReturnError': 'Помилка створення фіскального чека повернення',
  'pos.refundNotRecorded': 'Повернення проведено, але запис про нього не збережено. Не повторюйте повернення — повідомте адміністратора.',
  'orders.returnAfterCancel': 'Замовлення скасоване — товари вже повернуто на склад',
  'pos.returnTitle': 'Повернення товару',
  'pos.returnHint': 'Вкажіть кількість товарів для повернення',
  'pos.returnAmount': 'Сума повернення',
  'pos.confirmReturn': 'Повернути',
  'pos.tabSale': 'Продаж',
  'pos.tabHistory': 'Історія',
  'pos.historyEmpty': 'Продажів ще не було',
  'pos.historyDate': 'Дата',
  'pos.historyItems': 'Товари',
  'pos.historyTotal': 'Сума',
  'pos.historyMethod': 'Метод',
  'pos.historyAuthor': 'Автор',
  'pos.historyCancel': 'Скасувати',
  'pos.historyCancelConfirm': 'Скасувати цей продаж? Товари повернуться на склад.',
  'pos.historyCancelled': 'Продаж скасовано',
  'pos.historyCustomer': 'Клієнт',
  'pos.historyReturn': 'Повернення',
  'pos.historyReturned': 'Повернення',
  'pos.partialReturn': 'Частк. поверн.',
  'pos.warehouse': 'Склад',
  'pos.customer': 'Клієнт',
  'pos.selectCustomer': 'Пошук клієнта...',

  // ── Business Monitor ──
  'bizMonitor.title': 'Монітор бізнесу',
  'bizMonitor.subtitle': 'Стратегічний огляд для власника',
  'bizMonitor.revenue': 'Виручка',
  'bizMonitor.profit': 'Прибуток',
  'bizMonitor.profitability': 'Рентабельність',
  'bizMonitor.activeClients': 'Активні клієнти',
  'bizMonitor.retention': 'Retention',
  'bizMonitor.services': 'Послуги',
  'bizMonitor.goods': 'Товари',
  'bizMonitor.new': 'Нових',
  'bizMonitor.returning': 'Повторних',
  'bizMonitor.prevMonth': 'Пр. міс',
  'bizMonitor.revenueTrend': 'Динаміка виручки',
  'bizMonitor.clientHealth': 'Здоров\'я клієнтської бази',
  'bizMonitor.viewDetails': 'Детальніше',
  'bizMonitor.newClients': 'Нові',
  'bizMonitor.returningClients': 'Повторні',
  'bizMonitor.sleeping': 'Сплячі (30д+)',
  'bizMonitor.avgCheckServices': 'Сер. чек послуги',
  'bizMonitor.avgCheckProducts': 'Сер. чек товари',
  'bizMonitor.channels': 'Канали продажів',
  'bizMonitor.channelAppts': 'Записи',
  'bizMonitor.channelOrders': 'Замовлення',
  'bizMonitor.channelPos': 'POS',
  'bizMonitor.topStaff': 'Топ співробітників',
  'bizMonitor.topServices': 'Топ послуг',
  'bizMonitor.topProducts': 'Топ товарів',
  'bizMonitor.appointments': 'записів',
  'bizMonitor.times': 'разів',
  'bizMonitor.pcs': 'шт',
  'bizMonitor.margin': 'Маржа',
  'bizMonitor.stockAnalytics': 'Склад',
  'bizMonitor.stockValue': 'Залишок',
  'bizMonitor.positions': 'позицій',
  'bizMonitor.lowStockCount': 'Низький залишок',
  'bizMonitor.noMovementCount': 'Без руху 30д+',
  'bizMonitor.alerts': 'Потребує уваги',
  'bizMonitor.alertFinance': 'Фінанси',
  'bizMonitor.alertClients': 'Клієнти',
  'bizMonitor.alertStock': 'Товари/Склад',
  'bizMonitor.alertStaff': 'Персонал',
  'bizMonitor.alertRevenueDrop': 'Виручка впала на {pct}% порівняно з минулим місяцем',
  'bizMonitor.alertLowProfit': 'Рентабельність {pct}% — нижче порогу 15%',
  'bizMonitor.alertNoSalary': 'Зарплати за {month} не розраховані',
  'bizMonitor.alertSleeping': '{count} клієнтів не повертались 30+ днів',
  'bizMonitor.alertRetentionDrop': 'Retention впав з {from}% до {to}%',
  'bizMonitor.alertNoShow': 'No-show {pct}% — вище норми (10%)',
  'bizMonitor.alertLowStock': '{count} товарів нижче мінімального залишку',
  'bizMonitor.alertNoMovement': '{count} товарів без руху 30+ днів ({value}₴)',
  'bizMonitor.alertMarginDrop': 'Маржа на товари впала з {from}% до {to}%',
  'bizMonitor.alertStaffDrop': '{name} — виручка впала на {pct}%',
  'bizMonitor.noData': 'Немає даних',
  'sidebar.businessMonitor': 'Монітор бізнесу',

  // ── Комунікація: додано 2026-09-25 (ревізія модуля) ──────────
  'custModal.messageSent': 'Надіслано',
  'instagram.resubscribed': 'Підписку на вебхуки оновлено. Натисни «Перевірити зʼєднання», щоб побачити новий стан.',
  'instagram.resubscribeFailed': 'Не вдалось оновити підписку:',
  'instagram.errorPrefix': 'Помилка:',
  'sms.testText': 'Systemic CRM: тестове повідомлення.',
  'sms.testSent': 'Надіслано — перевірте телефон',
  'sms.testNotSent': 'Не надіслано',
  'sms.senderRule1': 'Максимум 11 символів латиницею, без пробілів — це межа стандарту GSM. Імʼя має бути',
  'sms.senderRuleStrong': 'зареєстроване в кабінеті провайдера',
  'sms.senderRule2': 'й збігатися символ у символ, з урахуванням регістру.',
  'sms.lastFailed': 'Остання відправка не пройшла',
  'sms.lastOk': 'Останнє успішне відправлення',
  'sms.testLabel': 'Перевірка справжньою SMS',
  'telegram.statusChecking': 'Перевіряю стан бота…',
  'telegram.statusRecheck': 'Перевірити',
  'telegram.statusLastError': 'Остання помилка:',
  'telegram.statusBot': 'Бот',
  'telegram.statusWebhook': 'Вебхук',
  'telegram.statusWebhookNone': 'не встановлений',
  'telegram.statusWebhookExpected': 'очікується',
  'telegram.statusQueue': 'У черзі',
  'telegram.statusSubscribers': 'Підписників',
  'telegram.statusSubscribersSub': 'клієнтів, що натиснули «Старт»',
  'telegram.verdictOk': 'Бот підключений і працює',
  'telegram.verdictNoToken': 'Бот не налаштований',
  'telegram.verdictNoTokenHint': 'Вставте токен від @BotFather і натисніть «Зберегти та підключити».',
  'telegram.verdictBadToken': 'Токен недійсний',
  'telegram.verdictBadTokenHint': 'Бот видалений або токен перевипущено в @BotFather. Вставте новий.',
  'telegram.verdictNoWebhook': 'Вебхук не встановлений',
  'telegram.verdictNoWebhookHint': 'Telegram не знає, куди слати оновлення. Натисніть «Зберегти та підключити».',
  'telegram.verdictHostMismatch': 'Вебхук дивиться на іншу адресу',
  'telegram.verdictHostMismatchHint': 'Найчастіше так буває, коли бота підключали з тестового посилання. Натисніть «Зберегти та підключити» на цій адресі.',
  'telegram.verdictWebhookError': 'Telegram не може достукатись',
  'telegram.verdictPending': 'Оновлення застрягли в черзі',
  'telegram.verdictPendingHint': 'Telegram накопичив оновлення, які не вдалося доставити.',
  'telegram.verdictNoSubscribers': 'Бот працює, але підписників немає',
  'telegram.verdictNoSubscribersHint': 'Жоден клієнт ще не натиснув «Старт» у боті. Персональне посилання — у картці клієнта.',
  'telegram.verdictUnreachable': 'Не вдалося перевірити стан',
  'telegram.statusForward': 'Пересилання',
  'telegram.statusForwardOk': 'працює',
  'telegram.statusForwardError': 'помилка',
  'telegram.statusForwardPending': 'оновлень ще не було',
  'telegram.fwdTitle': 'Зовнішній бот: меню й сценарії',
  'telegram.fwdIntro': 'Якщо для цього бота є окремий сервер із меню (кнопки, сценарії), Systemic лишається власником вебхука і пересилає йому копію кожного оновлення. Листування й відповіді операторів — як і раніше, тут.',
  'telegram.fwdUrl': 'Адреса для пересилання (https)',
  'telegram.fwdUrlHint': 'Порожнє поле — пересилання вимкнено.',
  'telegram.fwdSecret': 'Пароль пересилання',
  'telegram.fwdSecretHint': 'Придумайте будь-який рядок. Systemic надсилатиме його в заголовку X-Systemic-Secret і підпис тіла в X-Systemic-Signature — так зовнішній сервер перевірить, що запит від нас.',
  'telegram.fwdSecretStored': 'Пароль збережено на сервері й у браузер не повертається. Введіть новий, щоб замінити.',
  'telegram.fwdSave': 'Зберегти пересилання',
  'telegram.fwdSaved': 'Пересилання збережено',
  'telegram.fwdInvalidUrl': 'Адреса має починатися з https://',
  'telegram.fwdHowTitle': 'Як це працює і що врахувати',
  'telegram.fwdHow1': 'Адреса бота в Telegram лишається за Systemic. Зовнішній сервер нічого не переставляє: інакше картка стану покаже «Вебхук дивиться на іншу адресу», а кнопка «Зберегти та підключити» забере вебхук назад.',
  'telegram.fwdHow2': 'Systemic обробляє оновлення сам (листування, привʼязка клієнта, номер телефону) і паралельно шле копію на вказану адресу — включно з натисканнями кнопок, які сам ігнорує.',
  'telegram.fwdHow3': 'Зовнішній сервер показує меню через токен бота. Це інтерфейс, а не розмова: у «Комунікацію» воно не потрапляє. Відповідають клієнтам оператори з Systemic.',
  'telegram.fwdHow4': 'Кнопки меню робіть інлайн (під повідомленням). Клавіатура знизу надсилає натискання як звичайний текст, і в оператора в діалозі зʼявляться «Послуги», «Назад».',
  'telegram.fwdHow5': 'На /start Systemic уже відповідає сам: вітає і просить номер, щоб знайти клієнта в базі. Меню краще показувати після цього або за окремою командою, інакше клієнт отримає два повідомлення поспіль.',
  'telegram.fwdHow6': 'Сервер має відповісти 200 протягом 4 секунд. Повторів при збої немає; стан останньої пересилки видно в картці стану вище.',
  'messengerSet.tagline': 'Повідомлення з твоєї Facebook-сторінки — у CRM',
  'messengerSet.tabOpened': 'Facebook відкрито в новій вкладці. Авторизуйся і повернись сюди.',
  'messengerSet.connectFailed': 'Помилка підключення:',
  'messengerSet.confirmDisconnect': 'Відключити Messenger-інтеграцію?',
  'messengerSet.disconnected': 'Messenger відключено',
  'messengerSet.pageActivated': 'Сторінку «{name}» активовано',
  'messengerSet.subscribeFailed': 'Сторінку активовано, але підписати вебхук не вдалося: {error}. Натисни «Оновити підписку вебхуків».',
  'messengerSet.activateFailed': 'Не вдалось активувати сторінку',
  'messengerSet.errorPrefix': 'Помилка:',
  'messengerSet.pagesRefreshed': 'Список сторінок оновлено',
  'messengerSet.resubscribed': 'Підписку вебхуків оновлено. Натисни «Перевірити зʼєднання».',
  'messengerSet.resubscribeFailed': 'Не вдалось оновити підписку:',
  'messengerSet.needsReconnect': 'Потрібна повторна авторизація',
  'messengerSet.reconnectHint': 'Facebook анулював токен. Натисни «Підключити», щоб продовжити.',
  'messengerSet.howTitle': 'Як це працює',
  'messengerSet.how1': 'Натисни «Підключити Messenger» — Facebook відкриє авторизацію у новій вкладці.',
  'messengerSet.how2': 'Дозволь застосунку керувати повідомленнями твоїх сторінок.',
  'messengerSet.how3': 'Повернись сюди — побачиш список своїх сторінок Facebook. Обери одну для CRM.',
  'messengerSet.how4': 'Готово. Повідомлення з тієї сторінки автоматично потрапляють у «Комунікацію».',
  'messengerSet.givesTitle': 'Що дає підключення',
  'messengerSet.capInboxTitle': 'Повідомлення з Facebook-сторінки — у CRM',
  'messengerSet.capInboxText': 'Усі повідомлення на твою сторінку потрапляють у «Комунікацію» в реальному часі — поруч із Telegram, SMS та email.',
  'messengerSet.capReplyTitle': 'Відповідь з CRM напряму в Messenger',
  'messengerSet.capReplyText': 'Відкрий тред у «Комунікації», обери канал «Messenger» — відповідь піде клієнту. Meta дозволяє відповідати протягом 24 годин після його повідомлення.',
  'messengerSet.limitsLabel': 'Обмеження:',
  'messengerSet.limitsText': 'Працює лише з бізнес-сторінками Facebook, не з особистими профілями.',
  'messengerSet.statusOff': 'Не підключено',
  'messengerSet.statusPending': 'Очікує вибору сторінки',
  'messengerSet.statusOn': 'Підключено',
  'messengerSet.connectIntro': 'Підключи Facebook-акаунт і обери сторінку, з якої повідомлення надходитимуть у CRM.',
  'messengerSet.connectBtn': 'Підключити Messenger',
  'messengerSet.noPages': 'На цьому акаунті не знайдено жодної сторінки Facebook. Створи сторінку на facebook.com → Pages, потім онови список.',
  'messengerSet.refreshPages': 'Оновити список сторінок',
  'messengerSet.disconnectBtn': 'Відключити',
  'messengerSet.pickIntro': 'Обери Facebook-сторінку, з якої CRM отримуватиме повідомлення:',
  'messengerSet.pageActive': 'Активна',
  'messengerSet.pageUse': 'Використати',
  'messengerSet.refreshList': 'Оновити список',
  'messengerSet.fbAccount': 'Акаунт Facebook:',
  'messengerSet.activePage': 'Активна сторінка:',
  'messengerSet.connectedAt': 'Підключено:',
  'messengerSet.userTokenUntil': 'Токен користувача дійсний до:',
  'messengerSet.unknown': '(невідомо)',
  'messengerSet.testBtn': 'Перевірити зʼєднання',
  'messengerSet.resubscribeBtn': 'Оновити підписку вебхуків',
  'messengerSet.switchPage': 'Змінити сторінку',
  'messengerSet.patOk': '✓ Токен сторінки дійсний:',
  'messengerSet.patFailed': '✗ Токен сторінки не пройшов перевірку:',
  'messengerSet.subsTitle': 'Підписки вебхуків:',
  'messengerSet.noApps': 'Жоден застосунок не підписаний на цю сторінку. Натисни «Оновити підписку вебхуків».',
  'messengerSet.subscribedFields': 'Підписані поля:',
  'messengerSet.noMessagesField': '⚠ Поля «messages» немає в списку — Meta не надсилатиме повідомлення. Натисни «Оновити підписку вебхуків».',
  'messengerSet.subsFailed': '✗ Перевірка підписок не вдалася:',
};

export default uk;
